import * as Types from '../../../model/Sitecore.graphql.d';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type TrustSearchQuery_search_ItemSearchResults_pageInfo_PageInfo = (
  { __typename?: 'PageInfo' }
  & Pick<Types.PageInfo, 'endCursor' | 'hasNext'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_InvestmentTrustRegion_name_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM = { __typename?: 'Accordion' | 'AccordionFolder' | 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' | 'AccordionItem' | 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' | 'AccordionParametersTemplate' | 'AccordionPresentation' | 'AccordionPresentationFolder' | 'Accordion_02d060598cc14423a9ac9ff2365176b7' | 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' | 'AddItem' | 'AddItem_1e1b739ec3784909941d171aca7362e5' | 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' | 'AddItem_de8c75222f3241288f20342f479894eb' | 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' | 'AddThisParameters' | 'AggregatedFacetFilter' | 'AlertMessage' | 'AlertMessageFolder' | 'AlertMessageParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_dxYboWowVqXyFEQIHTW4KbhL0lHEcueHzhBbeD0999E = { __typename?: 'AlertMessageType' | 'AllertMessageTypeFolder' | 'Archive' | 'ArticleAuthor' | 'ArticleAuthorsFolder' | 'ArticleCategoriesFolder' | 'ArticleCategory' | 'ArticleChapter' | 'ArticleChapters' | 'ArticleContentType' | 'ArticleContentTypesFolder' | 'ArticleFilter' | 'ArticleFilterOption' | 'ArticleFootnote' | 'ArticleFootnoteLink' | 'ArticleFootnoteText' | 'ArticleInfogramTile' | 'ArticleInfogramTileParametersTemplate' | 'ArticlePage' | 'ArticleRegion' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_UCMOSvPffh5Tlps5EZhWVbLbLYAlnbiakefGIxYg2c = { __typename?: 'ArticleRegionsFolder' | 'ArticleSearchPage' | 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' | 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' | 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' | 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' | 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' | 'ArticleSeriesCollection' | 'ArticleSeriesFolder' | 'ArticleSettings' | 'ArticleSubscriptionBanner' | 'ArticleSubscriptionBannerFolder' | 'ArticleTag' | 'ArticleTagsFolder' | 'ArticleTeamAuthor' | 'ArticleTileParametersTemplate' | 'ArticleTilesParametersTemplate' | 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' | 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' | 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_xOJlvcBbMeSH2ZalUPaTM5ZeT2yOsFIN0h3Iv01is = { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' | 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' | 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' | 'ArticlesGroupFolder' | 'AttachThemeExtension' | 'AutomaticDocumentListings' | 'AutomaticDocumentListingsFolder' | 'AvailableJSONRenderings' | 'AvailableMetaRenderings' | 'AvailableRenderings' | 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' | 'AwardsBanner' | 'AwardsBannerFolder' | 'AwardsBannerImage' | 'AwardsBannerParametersTemplate' | 'BYOCWrapperRenderingParameters' | 'BackgroundColorOption' | 'BackgroundColorOptionFolder' | 'BannerFolder' | 'BannerType' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_TgBsOnUPPY6QvMRCjrAA0aJn3wFokEUMSDZlsVd9leA = { __typename?: 'BannerTypeFolder' | 'BaseHeading' | 'BaseHeadingFolder' | 'BoolFacet' | 'BranchesFolder' | 'Breadcrumb' | 'BrowserTitleDefinition' | 'CORSEntry' | 'CORSGrouping' | 'CTAPresentationType' | 'CTAPresentationTypeFolder' | 'C__AbrdnPage' | 'C__ActionBase' | 'C__AdvancedParameter' | 'C__App' | 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' | 'C__ArticleWildcardPage' | 'C__AvailableRenderingsFolder' | 'C__BYOCRenderingParameters' | 'C__BackgroundParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_1Fa5VAiUYUP8Bw87eryyMTnXaWA3g3Hakldosv8 = { __typename?: 'C__BaseCTA' | 'C__BasePage' | 'C__BasePage_037da552a5524fe4aeee331f57ac1378' | 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' | 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' | 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' | 'C__BasePage_728c97b5c56146d9807e21018a972bb5' | 'C__BasePage_6105875085f346729dfc8d133b481f26' | 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' | 'C__BaseRenderingParameters' | 'C__BaseTheme' | 'C__BaseVariantField' | 'C__Class' | 'C__CompositeGroup' | 'C__CompositeSection' | 'C__EloquaForm' | 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' | 'C__ExtendedOptions' | 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' | 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_ulsOVUMq3wDI6F3tyWyLZ3nyaAUzdauAXpbf8QIk = { __typename?: 'C__FEaaSRenderingParameters' | 'C__FacetSelectorConfigBase' | 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' | 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' | 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' | 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' | 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' | 'C__GlobalDatasourceBehavior' | 'C__GridDefinition' | 'C__GridItemBase' | 'C__GridParameters' | 'C__HeadlessSite' | 'C__HeadlessTenant' | 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' | 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' | 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' | 'C__IAllowEmpty' | 'C__IBaseVariantDefinition' | 'C__IBoosting' | 'C__ICacheable' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_xUQOkj0GMlc5wv60bmQQj73AHXxb38nIGTeN1leA = { __typename?: 'C__ICompatibleRenderings' | 'C__IComponentVariant' | 'C__IControlType' | 'C__IDynamicPlaceholder' | 'C__IFEaaSComponentsDataSourceTemplates' | 'C__IFEaaSComponentsEditorScriptURL' | 'C__IIcon' | 'C__ILocation' | 'C__IPaginable' | 'C__IPagination' | 'C__IPoi' | 'C__IRenderingId' | 'C__ISplitter' | 'C__IStyling' | 'C__IVariantDefinition' | 'C__InvestmentTrustPage' | 'C__JSONField' | 'C__JSONReference' | 'C__JSSData' | 'C__JSSSettings' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_t5cfgcaU3rr0AvX2OG5htlgnm2iWMKRTcTxzGBh8 = { __typename?: 'C__JSSSiteFolder' | 'C__JssRootFolder' | 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' | 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' | 'C__Page' | 'C__PageData' | 'C__PageDesignFolder' | 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' | 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' | 'C__PartialDesign' | 'C__PartialDesignFolder' | 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' | 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' | 'C__PlaceholderWrapper' | 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' | 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' | 'C__RedirectMapGrouping' | 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' | 'C__Route' | 'C__SimpleVideo' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_4mXqXPHUZr4otYDSpYWX8Y4XMpULNT8i6kWuAJEVV8 = { __typename?: 'C__SiteSettingsFolder' | 'C__SitemapSettings' | 'C__StandardTemplate' | 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' | 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' | 'C__TrustFolder' | 'C__VariantDefinition' | 'C__VariantField' | 'C__VariantsGrouping' | 'C___AdvancedItem' | 'C___Arguments' | 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' | 'C___Article' | 'C___ArticlePageWorkflow' | 'C___ArticleSearchPage' | 'C___ArticleWildcard' | 'C___AssetServiceThemeMode' | 'C___BaseArticle' | 'C___BaseDataFolder' | 'C___BaseHelpArticle' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_eeK09Y7wkhG5t6ox2MHbp12nGtLVIravFt2ix25Urx8 = { __typename?: 'C___BaseInvestmentTrust' | 'C___BaseJSSTenant' | 'C___BasePage' | 'C___BasePageDesign' | 'C___BasePageDesignFolder' | 'C___BasePartialDesign' | 'C___BasePartialDesignFolder' | 'C___BasePlaceholder' | 'C___BasePlaceholderSettingsFolder' | 'C___BasePresentation' | 'C___BasePressRelease' | 'C___BaseRenderingParameters' | 'C___BaseSXAStandardValuesFolder' | 'C___BaseSettings' | 'C___BaseSharedSitesSettings' | 'C___BaseSiteDefinition' | 'C___BaseSiteFolder' | 'C___BaseSiteGrouping' | 'C___BaseSiteRoot' | 'C___BaseTenant' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_QxspLemKohwcfn6MLuzq31LoWJcDWhvc6FyIrdg3Y = { __typename?: 'C___BaseTenantFolder' | 'C___BucketRules' | 'C___CORS' | 'C___Content' | 'C___ContentType' | 'C___DataAttributes' | 'C___DatasourceWorkflow' | 'C___Dependencies' | 'C___Description' | 'C___DesignTemplateMapping' | 'C___Designable' | 'C___EditType' | 'C___EditType_8a9f84baaa124c5d9096935714809da4' | 'C___EditingTheme' | 'C___Enabled' | 'C___ErrorHandling' | 'C___ExternalArticle' | 'C___Fields' | 'C___FilteredArticlesParent' | 'C___FilteredArticlesWildcard' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_pLSvoSlIZBlpRr0oqseIDsMYsAtAKahN2CujcRmUG4 = { __typename?: 'C___Footnotes' | 'C___FundDetailsWildcard' | 'C___FundFormAvailability' | 'C___FundMetadataPage' | 'C___FundSearchPage' | 'C___FundsFolder' | 'C___FundsFormsFolder' | 'C___FundsLiteratureFolder' | 'C___FundsShareclassesDetailsWildcard' | 'C___GridMapping' | 'C___HelpArticle' | 'C___HelpArticleSearchPage' | 'C___HelpArticleWildcard' | 'C___HorizonDatasourceGrouping' | 'C___Icon' | 'C___IncludeByDefault' | 'C___IncludeIfInstalled' | 'C___InternalArticle' | 'C___InternetExplorerCompatibilityMode' | 'C___IsSystemModule' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_bAtMrDx88rUB43hbWgykdpxX2U1q1LBRCJ4YGeZd4 = { __typename?: 'C___JSONVariantPaging' | 'C___JSONVariantsBase' | 'C___LimitedDisplay' | 'C___LinkAttributes' | 'C___LinkSettings' | 'C___LiteratureHubSearchPage' | 'C___ManualKeyInformation' | 'C___MemberOf' | 'C___MetadataPage' | 'C___Modules' | 'C___Name' | 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' | 'C___Name_299cdb154745448a807868d401248eaa' | 'C___Name_b88cf88159a54a19991e71038751cb60' | 'C___Navigable' | 'C___NavigablePage' | 'C___PageContent' | 'C___PageWorkflow' | 'C___PerSiteStandardValues' | 'C___Podcast' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_3TTCxtPd167YL33nF9XBmmHbkUnxZovqTZClaQHWlMw = { __typename?: 'C___PodcastPressRelease' | 'C___PremiumContentPage' | 'C___PressRelease' | 'C___PressReleaseContentType' | 'C___PressReleaseSearchPage' | 'C___PressReleaseWildcard' | 'C___ProtectedTheme' | 'C___PublishingGroupingTemplate' | 'C___RenderingRelatedParameters' | 'C___RenderingVariantsBase' | 'C___RenderingsList' | 'C___RobotsContent' | 'C___RoleDomain' | 'C___RoleName' | 'C___RoleType' | 'C___SalesforceCommonValidations' | 'C___SalesforceFieldId' | 'C___SalesforceFieldTitle' | 'C___SalesforceFieldValue' | 'C___Script' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_cjYnlIs8UAaiaQsoGXfmJs6J5mZumcliSqpOQJJTEs = { __typename?: 'C___SearchSignature' | 'C___Searchable' | 'C___SecurityItemPointer' | 'C___SharedArticles' | 'C___SharedContent' | 'C___SharedHelpArticles' | 'C___SharedPage' | 'C___SharedPressReleases' | 'C___SharedRoot' | 'C___SharedSettings' | 'C___SiteContent' | 'C___SiteFolder' | 'C___SiteMediaLibrary' | 'C___SiteSettings' | 'C___SiteTemplate' | 'C___SitecoreClientSiteManaging' | 'C___Sitemap' | 'C___SitemapMediaItems' | 'C___SlidersRangeSettings' | 'C___SolutionTemplateContent' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_06OIScbuurQrCIv2RnyRnUL8yzZFIOkwx4bqVVJ1U8 = { __typename?: 'C___SolutionTemplateDescription' | 'C___SolutionTemplateName' | 'C___SortOrder' | 'C___StackBreakpoint' | 'C___Statistics' | 'C___SupportedLanguages' | 'C___Taggable' | 'C___TeamMembersParentPage' | 'C___TeamMembersWildcard' | 'C___TechzoneArticle' | 'C___Template' | 'C___Title' | 'C___Type' | 'C___Validation' | 'C___VariantPaging' | 'C___VectorTile' | 'C___VectorTileLink' | 'C___Video' | 'C___VideoPressRelease' | 'C___Width' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_P8mpedaaoE314gdziPbBwa0OJmnSKCgK7OuMwTvh8 = { __typename?: 'C___WildcardPage' | 'CacheSetting' | 'Caching_26fce9bf0256458d8281a713a5bf5520' | 'CalendarEvent' | 'CallOutSection' | 'CallOutSectionDropdownOption' | 'CallOutSectionFolder' | 'CallOutSectionParametersTemplate' | 'CallToAction' | 'CallToActionFolder' | 'CapabilitiesFolder' | 'Capability' | 'CapabilityMap' | 'CapabilityMappings' | 'Carousel' | 'CarouselFolder' | 'CarouselSlide' | 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' | 'Checkbox' | 'ChecklistFilter' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_riDg0AYVm42AlYT43jww1Ay107z2R3VQxYQLo3qt4w = { __typename?: 'ChecklistFilterFolder' | 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' | 'ColumnSplitter' | 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' | 'CompatibilityMode' | 'ComponentConfiguration' | 'ComponentThemeConfiguration' | 'ComponentThemesConfiguration' | 'ComponentsConfigurations' | 'ConfigurationFolder' | 'Container' | 'ContainerOption' | 'ContainerOptionsFolder' | 'ContainerParametersTemplate' | 'Container_45130bdbbae34edcaea87b68b9d94c7f' | 'ContentBlock' | 'ContentBlockFolder' | 'ContentToken' | 'ContentTokenFolder' | 'ContentType' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_rOmfpST6oLo347EYJ7Raz1NFUvjdcKoBJzJr0H9BgZ0 = { __typename?: 'CorporateTheme' | 'CorporateThemesFolder' | 'Country' | 'CountryISOCode' | 'CountryISOCodesFolder' | 'CustomerReviewFolder' | 'CustomerReviewTile' | 'CustomerReviewTileParametersTemplate' | 'DataBridgeDocumentCategoryMap' | 'DataBridgeFund' | 'DataBridgeFundRangeName' | 'DataBridgeSettingsFolder' | 'DataBridgeShareClass' | 'DataFolder' | 'DatasourceConfiguration' | 'DatasourceConfigurations' | 'DatasourceWorkflowAction' | 'DateFacet' | 'DateFilter' | 'DateFilterFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_OotNkMr3fBFvpnup0QnIBAKz5eVEb0STNbTDByrUc = { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' | 'DefaultColumnLayout' | 'DefaultShareclassMapping' | 'DefaultShareclassMappings' | 'DescriptiveHighlight' | 'DescriptiveHighlightFolder' | 'DescriptiveHighlightItem' | 'DescriptiveHighlightParametersTemplate' | 'Device' | 'Device_7c27ec70f42e40428a0fabaa2f8eda18' | 'Devices' | 'DictionaryFolder' | 'DisqusParameters' | 'DistanceFacet' | 'Divider' | 'DocumentItem' | 'DocumentListings' | 'DocumentListingsFolder' | 'DocumentTypeFolder' | 'DominantLanguageMapping' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_OVU4NcIdr6UAPevtvSSCtiep2KkZxR5zGCVShCeVdM = { __typename?: 'Dropdown' | 'DropdownFilter' | 'DropdownFilterFolder' | 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' | 'EditEditingTheme' | 'EditFrame' | 'EditModePanel' | 'EditSiteItem' | 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' | 'EditSiteTheme' | 'EditTenantTemplate' | 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' | 'EditType' | 'EloquaFormFolder' | 'EloquaFundForm' | 'Enum' | 'Enums' | 'ErrorPage' | 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' | 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_PqG8IayP279sjtPG4vxuPRJW1hTc9wDd0Y6bxgfrj9M = { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' | 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' | 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' | 'EventCalendarParameters' | 'EventList' | 'EventListParameters' | 'EventTypes' | 'EventsFolder' | 'ExecuteScript' | 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' | 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' | 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' | 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' | 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' | 'ExtendSiteTheme' | 'ExternalLiterature' | 'FEaaSWrapperRenderingParameters' | 'FacebookCommentsParametersTemplate' | 'FacetSlider' | 'FacetSliderFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_jX8959OSsL1J6OXLEoQhYbwRZXji5sxbF5Emcsd7hk = { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' | 'FacetSummary' | 'FacetSummaryFolder' | 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' | 'FacetsGrouping' | 'FakeNavigationItem' | 'FeatureBanner' | 'FeatureBannerParametersTemplate' | 'FeaturedArticles' | 'FeaturedArticlesFolder' | 'FeaturedTheme' | 'FeaturedThemesFolder' | 'Feed' | 'FeedFolder' | 'FeedParameters' | 'FieldEditor' | 'FieldRenderer' | 'FileList' | 'FileListFolder' | 'FileListParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_nG2WofEr8CM8keV1x8PUfr4FiOA16RD19JEgZKAwYOw = { __typename?: 'File_04129321770849c1801baee196e1c0a8' | 'FilterCriteria' | 'FilterCriteriaFolder' | 'FilterTaxonomyOption' | 'FilterTaxonomyOptions' | 'FilteredArticlesParentPage' | 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' | 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' | 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' | 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' | 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' | 'FilteredArticlesWildcardPage' | 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' | 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' | 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' | 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' | 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' | 'Flip' | 'FlipFolder' | 'Flip_5ef078504c044b839dafefd752cfaba8' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_phPzDO2Ka14Ao7Iqi5urCuijJRssi4yX4Ebgh3FcnbI = { __typename?: 'Flipside' | 'FloatFacet' | 'Footer' | 'FooterFolder' | 'FooterLink' | 'FormRenderingParameters' | 'FundAssetClass' | 'FundAssetClassesFolder' | 'FundDetailsWildcardPage' | 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' | 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' | 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' | 'FundFormsFolder' | 'FundInFocus' | 'FundInFocusShareClass' | 'FundSearchPage' | 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' | 'FundSearchPage_5806f83c03bc443380678ff955f4310f' | 'FundSearchPage_7432205c04214a419ca064c4cb37501c' | 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_Cng12S8NWxtlSTgmXuOQLEDPix0BbRxa4F0cvSsv1c = { __typename?: 'FundSettings' | 'FundShareclassDetailsWildcardPage' | 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' | 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' | 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' | 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' | 'FundSubAssetClass' | 'FundSubAssetClassesFolder' | 'FundsExternalLiteratureFolder' | 'FundsFolder' | 'FundsInFocusFolder' | 'FundsInFocusParametersTemplate' | 'FundsLiteratureFolder' | 'FundsLiteratureMappingsFolder' | 'Gallery' | 'GalleryFolder' | 'GalleryImage' | 'GalleryParametersTemplate' | 'GalleryVideo' | 'GatedAccordionContainer' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_Q1eQ5zKp1DmJrdMkqNxGrBxP1DirJ86dHnlUL7O6I = { __typename?: 'GlobalLanguageSelector' | 'GlobalNavigationBar' | 'GoogleAnalytics' | 'GoogleTagManager' | 'GoogleTagManagerFolder' | 'GridSetup' | 'GridTheme' | 'HTMLCode' | 'HTMLCodeFolder' | 'HTMLInclude' | 'HTMLIncludesFolder' | 'HTMLSnippet' | 'HTMLSnippetFolder' | 'HTMLTag' | 'Header' | 'HeaderFolder' | 'Heading' | 'HeadlessSiteSetupRoot' | 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' | 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_UxmIFNNcD8BvR6JmFFbZx6akhkSuYq2XDQUlQUfc6gM = { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' | 'HeadlessSite_68ffa40c5aab45548f774742b163f318' | 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' | 'HeadlessSite_229484893ca144958b9937167dfb5064' | 'HeadlessSite_b28055626acc45a2913a9617398c9730' | 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' | 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' | 'HeadlessSolutionTemplateFolder' | 'HeadlessTenantSetupRoot' | 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' | 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' | 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' | 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' | 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' | 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' | 'HeadlessTenant_94824ac390d748499e5af0275d10811f' | 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' | 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' | 'HeadlessTrustSite' | 'HeadlessVariants' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_K03JPtJ3NPqclv8mEFeFiFxrLZNgqW5QncC2uGSA77Y = { __typename?: 'HeadlessVariantsGrouping' | 'HelpArticlePage' | 'HelpArticlePlatform' | 'HelpArticlePlatformMap' | 'HelpArticlePlatformMappings' | 'HelpArticlePlatformsFolder' | 'HelpArticleSearchPage' | 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' | 'HelpArticleTag' | 'HelpArticleTagsFolder' | 'HelpArticleWildcardPage' | 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' | 'HelpArticlesGroupFolder' | 'HelpTagMap' | 'HelpTagMappings' | 'HeroBanner' | 'Highlight' | 'HighlightBlock' | 'HighlightBlockFolder' | 'HighlightBlockParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_aenpgKLNXFjIwUuTFQwphJOVytmWnXoasHV2tDtjXA = { __typename?: 'HighlightFolder' | 'HighlightItem' | 'HighlightParametersTemplate' | 'Home' | 'HomePage' | 'HomePage_0d3963a8171d4080b5f808618578b631' | 'HomePage_6d95c7d946c74a70be07304cc73a2010' | 'HomePage_b407f259b4e34c7db9a06e8907a56b17' | 'HomePage_cde13c51062d426b95569e8202edc963' | 'HomePage_de9353283a3e41c495ba386aed0540c6' | 'IFrame' | 'IFrameFolder' | 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' | 'IFrameParametersTemplate' | 'IFrame_0da12d476de24dfeb4d0f513489bfea1' | 'IFrame_88a6f65f2b78491bb3770b06e48883e1' | 'Icon' | 'IconFolder' | 'Image' | 'ImageFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_F00TqNYYYq1qzYhXyz7eFauJxvms2okisTSzoXPYs = { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' | 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' | 'ImageParametersTemplate' | 'Image_83bc563c6320490092f8204bff81586a' | 'Image_15185b0e641844499f934ff03b7ee032' | 'Image_d885df8cb2d64007b34b2bbafb527304' | 'Infographics' | 'InfographicsFolder' | 'InputValidationStep' | 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' | 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' | 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' | 'IntegerFacet' | 'IntroCopy' | 'IntroCopyFolder' | 'InvestmentTrustAssetClass' | 'InvestmentTrustAssetClassFolder' | 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' | 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' | 'InvestmentTrustRegionFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_TFM8XAFL3R0W5BBj4PhNwCAwPErC6NwFNoclkK5Ozfg = { __typename?: 'InvestmentTrustStyle' | 'InvestmentTrustStyleFolder' | 'InvestorType' | 'InvestorTypesFolder' | 'ItemQueriesFolder' | 'ItemRights' | 'JSBeaconSettings' | 'JSONCheckbox' | 'JSONContent' | 'JSONDate' | 'JSONFile' | 'JSONImage' | 'JSONLayout' | 'JSONList' | 'JSONMultilistReference' | 'JSONPlaceholder' | 'JSONQuery' | 'JSONResults' | 'JSONRichText' | 'JSONScriban' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_bMHrVLsz7zTHT5CwjCPyMlvDh8syp5BNhgLmOFWY = { __typename?: 'JSONSection' | 'JSONTemplate' | 'JSONText' | 'JSONToken' | 'JSONVariantDefinition' | 'JSONVariants' | 'JSSLayout' | 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' | 'JSSSettings_6b328292f8314ab79885d89a054ca10a' | 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' | 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' | 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' | 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' | 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' | 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' | 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' | 'JSSSiteGrouping' | 'JSSTenantFolder' | 'JavaScriptRendering' | 'JsonRendering' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_uHyHdgbeup55x4fJn0iMgtziabR3eN1yEsBEkbjb5Q = { __typename?: 'JurisdictionStatus' | 'JurisdictionsFolder' | 'KeyHighlightItem' | 'KeyHighlights' | 'KeyHighlightsFolder' | 'KeyHighlightsParametersTemplate' | 'Language' | 'LanguageSelector' | 'LanguagesFolder' | 'LatestPressReleasesParametersTemplate' | 'LayoutServiceVariants' | 'LimitedDisplayFolder' | 'LimitedDisplayOption' | 'Link' | 'LinkList' | 'LinkListFolder' | 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' | 'LinkList_33c9207e3b0446068ef54ca99a97c776' | 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' | 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_T3o1wLwUnreOMfGErcoS5389oEEJtqeZlHP8vd3gA = { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' | 'Link_930f134d56784b35bfd1b77f9d0115f1' | 'Link_e24e0789a05848bfabb6c69c0e60b6b7' | 'LinksFolder' | 'List' | 'ListFacet' | 'ListFolder' | 'ListItem' | 'ListParametersTemplate' | 'ListStyle' | 'ListStyleItem' | 'ListingHeroBanner' | 'ListingHeroParametersTemplate' | 'LiteratureAuthorization' | 'LiteratureAuthorizationsFolder' | 'LiteratureHubSearchPage' | 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' | 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' | 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' | 'LoadMore' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_BiFBNsNFG239ill5wF74Fp0WARoTWU8lZUEROfPJZvM = { __typename?: 'LoadMoreFolder' | 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' | 'LocationFilter' | 'LocationFilterFolder' | 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' | 'Log' | 'Login' | 'Login_abed54dc4f7840ddac562289c9c849d8' | 'LogoTextBlockItem' | 'LogoTextBlocks' | 'LogoTextBlocksFolder' | 'Logout' | 'Logout_c2294d8235a6452a94b15eb5e543b602' | 'ManagedRangeFilter' | 'ManagedRangeFilterFolder' | 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' | 'ManagedRangeItem' | 'Map' | 'MapParameters' | 'MapsFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_G1e6Uvc81Pa7r6RKtchIZa50YYxIpwUNf0ONxBs4Bl0 = { __typename?: 'MapsProvider' | 'MediaBlock' | 'MediaBlockFolder' | 'MediaBlockParametersTemplate' | 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' | 'MediaLinkParameters' | 'MediaVirtualFolder' | 'MegaNavigation' | 'MegaNavigationFolder' | 'MetaBranding' | 'MetaRenderingParameters' | 'MetadataPartialDesign' | 'Model' | 'ModelIterator' | 'MyLocationPOI' | 'Navigation' | 'NavigationCategory' | 'NavigationFilter' | 'NavigationFilterFolder' | 'NavigationLink' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_WDgsk5S4YhtQoVJsDxcSUkTfZcwxXcb1NO0cFSqYNGs = { __typename?: 'NavigationSubcategory' | 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' | 'OneTrustSettings' | 'OptimiserConfiguration' | 'OptimiserConfigurationSection' | 'OptimizedFile' | 'OracleCDPSettings' | 'OverlayContent' | 'OverlayFolderTemplate' | 'Ownership' | 'OwnershipFolder' | 'POI' | 'POIFolder' | 'POIType' | 'POIs' | 'PageBranchesFolder' | 'PageContent' | 'PageContentFolder' | 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' | 'PageDesign' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_IWJynIRPteI7yBdYHGdbMI4cyxoxfNlbtSN7B20y4M = { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' | 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' | 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' | 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' | 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' | 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' | 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' | 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' | 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' | 'PageDesign_1105b8f81e00426bbf1fc840742d827b' | 'PageDesigns' | 'PageDesigns_3af52e70e982424b9c85e355542500c9' | 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' | 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' | 'PageDesigns_99a71bba507746729c3fb29b04abee23' | 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' | 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' | 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' | 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' | 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_D3YGmHHw8WNoPLjhaKccTYlBxHImWKx0FJmY7FY = { __typename?: 'PageLevelTabs' | 'PageLevelTabsFolder' | 'PageList' | 'PageSelector' | 'PageSelectorConfiguration' | 'PageSelectorFolder' | 'PageSelector_59a7bb775f8c435ab810291abde80e63' | 'PageSize' | 'PageSizeFolder' | 'PageSize_b682562e0af64b3e9e3b45273bbe152d' | 'PageTheme' | 'PageThemesFolder' | 'Page_4f49a81db3664f198b89cab92f377d7a' | 'Page_5e66d86353544fe6a27d3b894984d50f' | 'Page_84f342ad2d0646b9aa9a818201145ca2' | 'Page_718df200be51463d93edf4d77ab7a49e' | 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' | 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' | 'Page_dae7821153e14dbabb0ddf0b53a90aaf' | 'Page_fa608b3e6aeb426388a059d89caabada' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_5d6qs4EGU5QLch38FcFTz9usooPsSE3WceHdwYputc = { __typename?: 'Pagging' | 'Pagination' | 'PaginationFolder' | 'Paragraph' | 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' | 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' | 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' | 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' | 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' | 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' | 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' | 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' | 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' | 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' | 'PartialDesigns' | 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' | 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' | 'PartialDesigns_36c869ded22040929ce829f6ed643c66' | 'PartialDesigns_1943dc73710a430895515a342c84b037' | 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_B9w2udyDmdxORyQ5clNDVxDKQqarcHNAPO2AP3es = { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' | 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' | 'PartialDesigns_d216303f58d8425688da8cd30d00afab' | 'PartialDesigns_facda26791204fa9a0363344348f2c42' | 'PerformanceChartSettings' | 'PerformanceChartTimePeriod' | 'PerformanceChartTimePeriodFolder' | 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' | 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' | 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' | 'Placeholder_1ca0304be5b64810821154426f1752c2' | 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' | 'PlainHtmlParametersTemplate' | 'Playlist' | 'PlaylistFolder' | 'PlaylistParametersTemplate' | 'Podcast' | 'PodcastFolder' | 'PodcastPage' | 'PodcastPressReleasePage' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_AdqeB4aKdR2MyUECPtovrc95H3CJ6Ig98U7CdiLGaIM = { __typename?: 'PoiTypes' | 'PostDeleteStep' | 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' | 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' | 'PostDeleteStep_b20857895385413883f096f3767cb156' | 'PostSetupStep' | 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' | 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' | 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' | 'PreDeleteStep' | 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' | 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' | 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' | 'PreDeleteValidationStep' | 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' | 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' | 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' | 'Presentation' | 'Presentation_0a70fa7389234a6eabf34134f25f3221' | 'PressReleaseContentType' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_drzV1CJMhZ88IeARb30GphbrzYOHnyNZjm3CgUbIWk = { __typename?: 'PressReleaseContentTypesFolder' | 'PressReleaseFilter' | 'PressReleasePage' | 'PressReleasePlatform' | 'PressReleasePlatformsFolder' | 'PressReleaseSearchPage' | 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' | 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' | 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' | 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' | 'PressReleaseWildcardPage' | 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' | 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' | 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' | 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' | 'PressReleasesGroupFolder' | 'PrivacyWarning' | 'ProjectFolder' | 'Promo' | 'PromoFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU = { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' | 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' | 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' | 'Promo_dfed4457d760457abec1c0dccdc44381' | 'PromotedContent' | 'PromotedContentFolder' | 'PropertyListingCard' | 'PropertyListingCards' | 'PropertyListingCategory' | 'PropertyListingFolder' | 'Query_98b413525a4b4067b92418a4b50f0a53' | 'QuickLinks' | 'QuickLinksFolder' | 'QuickLinksParametersTemplate' | 'QuotationBlockItem' | 'QuotationBlocks' | 'QuotationBlocksFolder' | 'QuotationBlocksParametersTemplate' | 'Quote' | 'QuoteFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 = { __typename?: 'QuoteParametersTemplate' | 'RadiusFilter' | 'RadiusFilterFolder' | 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' | 'RadiusScheme' | 'RadiusSchemeValue' | 'RangeSliderFilter' | 'RangeSliderFilterFolder' | 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' | 'RecentArticles' | 'Redirect' | 'RedirectMap' | 'RedirectMaps' | 'Region' | 'RegionLanguages' | 'RegionLanguagesFolder' | 'RelatedArticles' | 'RelatedArticlesParametersTemplate' | 'RenderEngineType' | 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg = { __typename?: 'RenderingHost' | 'ResizableIFramePage' | 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' | 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' | 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' | 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' | 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' | 'ResponsiveImage' | 'ResultsCount' | 'ResultsCountFolder' | 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' | 'ResultsVariantSelector' | 'RichText' | 'RichTextFolder' | 'RichText_0f3b73366112418c8bbab0526f3887ce' | 'RichText_efcfd8f6596745f48f85b5421928205d' | 'RiskImageMapping' | 'RiskImageMappings' | 'RiskLevelOption' | 'RiskLevelOptionFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc = { __typename?: 'RiskWarning' | 'RiskWarningFolder' | 'RiskWarningParametersTemplate' | 'RolePlaceholder' | 'RowSplitter' | 'RowSplitter_340c887da1d1415b9678c763af74ea97' | 'Rule' | 'SDRLogoMapping' | 'SDRLogoMappings' | 'SDRTypeOption' | 'SDRTypeOptionFolder' | 'SXAJSSLayout' | 'SXARole' | 'SXAStandardValuesFolder' | 'SalesforceAlertMessage' | 'SalesforceCheckBox' | 'SalesforceCheckBoxType' | 'SalesforceConditionalRadioButton' | 'SalesforceConditionalRadioButtons' | 'SalesforceDateInput' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM = { __typename?: 'SalesforceDropdown' | 'SalesforceDropdownOption' | 'SalesforceHiddenField' | 'SalesforceInput' | 'SalesforceInputType' | 'SalesforceIntegratedForm' | 'SalesforceIntegratedFormTypesFolder' | 'SalesforceRepeatableSubSection' | 'SalesforceRichTextArea' | 'SalesforceSection' | 'SalesforceSortCodeInput' | 'SalesforceSubmissionType' | 'Scope' | 'ScopesFolder' | 'Scriban' | 'Scripts' | 'SearchBox' | 'SearchBoxFolder' | 'SearchBox_1c04fd611d874590acfe9cc186865ab3' | 'SearchFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo = { __typename?: 'SearchResults' | 'SearchResultsFolder' | 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' | 'SecondaryHeroBannerParametersTemplate' | 'SectionHeading' | 'SectionHeadingFolder' | 'SectionHeadingParametersTemplate' | 'SectionHeadingType' | 'SectionHeadingTypeFolder' | 'SectionSelector' | 'SectionSelectorFolder' | 'SectionSelectorTab' | 'Security_33077d51ebad4d1cb4a83b79f51dba13' | 'Series' | 'SeriesFolder' | 'Settings' | 'SettingsFolder' | 'Settings_6c82caca67dc464195698faad083230e' | 'SharePriceSettings' | 'SharedArticlesFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs = { __typename?: 'SharedContentFolder' | 'SharedFolder' | 'SharedHelpArticlesFolder' | 'SharedPressReleasesFolder' | 'SharedSettingsFolder' | 'SharedSitesSettings' | 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' | 'Showcase' | 'ShowcaseFolder' | 'ShowcaseItem' | 'ShowcaseParametersTemplate' | 'Site' | 'SiteContentFolder' | 'SiteDefinition' | 'SiteEntryDisclaimer' | 'SiteFolder' | 'SiteGrouping' | 'SiteManagement' | 'SiteSecurityItemPointer' | 'SiteSelector' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo = { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' | 'SiteSetupRoot' | 'SiteTheme' | 'Site_e46f3af239fa4866a1577017c4b2a40c' | 'SitecoreFormWrapperParametersTemplate' | 'SitecoreRole' | 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' | 'SkipLink' | 'SkipLinkParameters' | 'SkipLinksFolder' | 'Snippet' | 'SnippetItem' | 'SnippetsFolder' | 'SocialLoginWrapper' | 'SocialMediaButtons' | 'SocialMediaFolder' | 'SocialMediaShare' | 'SocialMediaTemplate' | 'SocialNetwork' | 'SocialNetworkFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU = { __typename?: 'SocialNetworkLink' | 'SolutionTemplate' | 'SortResults' | 'SortResultsFolder' | 'Sorting' | 'SortingGroups' | 'SpotifyPodcast' | 'SpotifyPodcastFolder' | 'StickyCTA' | 'StickyCTAFolder' | 'StickyCTAParametersTemplate' | 'StrategiesInFocusFolder' | 'StrategyInFocus' | 'Style' | 'Styles' | 'Styles_9c0dac2808aa4b44bc2153363206f6a5' | 'SubscriptionBannerParametersTemplate' | 'Tab' | 'TabItem' | 'TableOfContents' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 = { __typename?: 'TableOfContentsFolder' | 'TableOfContentsSection' | 'TableOfContentsSubsection' | 'Tabs' | 'TabsFolder' | 'Tabs_f26a9560ccf148c59542800e837caf7a' | 'Tag' | 'TagCloud' | 'TagFolder' | 'TagList' | 'TeamBiographySettings' | 'TeamListingCards' | 'TeamListingCardsFolder' | 'TeamMember' | 'TeamMemberCard' | 'TeamMembers' | 'TeamMembersParentPage' | 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' | 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' | 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk = { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' | 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' | 'TeamMembersWildcardPage' | 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' | 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' | 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' | 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' | 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' | 'TeamProfileCards' | 'TeamProfileCardsFolder' | 'TechzoneArticlePage' | 'Tenant' | 'TenantFolder' | 'TenantSecurityItemPointer' | 'TenantSetupRoot' | 'TertieryHeroBanner' | 'TertieryHeroBannerParametersTemplate' | 'Text' | 'TextBlock' | 'TextBlockHeadingParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 = { __typename?: 'TextBlockHeadingType' | 'TextBlockHeadingTypeFolder' | 'TextBlockLinkType' | 'TextBlockLinkTypeFolder' | 'TextBlocks' | 'TextBlocksFolder' | 'TextBlocksParametersTemplate' | 'TextFolder' | 'TextFolder_b762d56787f5493cbb480c455d834457' | 'Text_b8f5894cb4934016bf784090b0a2fd16' | 'Theme' | 'ThemeTag' | 'ThemeTagsFolder' | 'ThemingMode' | 'ThemingModes' | 'Tile' | 'TileLink' | 'TileParametersTemplate' | 'TileSizeOption' | 'TileSizeOptionFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 = { __typename?: 'TilesFolder' | 'TilesParametersTemplate' | 'Title' | 'Title_a82e893105754175917de904ef7e6dbe' | 'Toggle' | 'ToggleFolder' | 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' | 'Transformation' | 'TrustArticleHeroParametersTemplate' | 'TrustFinder' | 'TrustFinderFilterOption' | 'TrustRegion' | 'TrustType' | 'TrustTypesFolder' | 'Twitter' | 'TwitterApp' | 'TwitterApps' | 'TwitterFolder' | 'TwitterParametersTemplate' | 'TwitterSettings' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w = { __typename?: 'UnknownItem' | 'UnminifiedFile' | 'UpgradeScript' | 'UpgradeScriptLibrary' | 'VariantComponentField' | 'VariantDateField' | 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' | 'VariantPlaceholder' | 'VariantReference' | 'VariantSection' | 'VariantTemplate' | 'VariantText' | 'VariantToken' | 'Variants' | 'VectorFolder' | 'VectorTile' | 'VectorTileLink' | 'VectorTilesFolder' | 'VectorTilesParametersTemplate' | 'Version_95ebc23204774dc38ad3465d5fe8da2f' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU = { __typename?: 'Video' | 'VideoCountOption' | 'VideoCountOptions' | 'VideoFolder' | 'VideoFolder_bba49474673e468186ba8b1a20e067a9' | 'VideoPage' | 'VideoParameters' | 'VideoParametersTemplate' | 'VideoPressReleasePage' | 'Video_4bc649610a894242be2dc5026090cf49' | '_AssetsOptimization' | '_BackgroundImage' | '_CompatibleThemes' | '_CompositeTheme' | '_CustomMetadata' | '_CustomRenderingViewPath' | '_DatasourceBehaviour' | '_Favicon' | '_FormsFolderLocation' | '_FundSettings' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 = { __typename?: '_HasValidUrlName' | '_LocalDataLink' | '_Login' | '_OpenGraphMetadata' | '_PageDesignTheme' | '_PageSearchScope' | '_SearchCriteria' | '_SearchableWithoutRelatedItems' | '_SeoMetadata' | '_SiteTheme' | '_SitemapSettings' | '_StickyNote' | '_Styleable' | '_TwitterMetadata' | '_Webinar' | '_WildcardSource' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_InvestmentTrustRegion = (
  { __typename?: 'InvestmentTrustRegion' }
  & { name: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_InvestmentTrustRegion_name_TextField> }
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem = TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_dxYboWowVqXyFEQIHTW4KbhL0lHEcueHzhBbeD0999E | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_UCMOSvPffh5Tlps5EZhWVbLbLYAlnbiakefGIxYg2c | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_xOJlvcBbMeSH2ZalUPaTM5ZeT2yOsFIN0h3Iv01is | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_TgBsOnUPPY6QvMRCjrAA0aJn3wFokEUMSDZlsVd9leA | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_1Fa5VAiUYUP8Bw87eryyMTnXaWA3g3Hakldosv8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_ulsOVUMq3wDI6F3tyWyLZ3nyaAUzdauAXpbf8QIk | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_xUQOkj0GMlc5wv60bmQQj73AHXxb38nIGTeN1leA | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_t5cfgcaU3rr0AvX2OG5htlgnm2iWMKRTcTxzGBh8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_4mXqXPHUZr4otYDSpYWX8Y4XMpULNT8i6kWuAJEVV8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_eeK09Y7wkhG5t6ox2MHbp12nGtLVIravFt2ix25Urx8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_QxspLemKohwcfn6MLuzq31LoWJcDWhvc6FyIrdg3Y | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_pLSvoSlIZBlpRr0oqseIDsMYsAtAKahN2CujcRmUG4 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_bAtMrDx88rUB43hbWgykdpxX2U1q1LBRCJ4YGeZd4 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_3TTCxtPd167YL33nF9XBmmHbkUnxZovqTZClaQHWlMw | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_cjYnlIs8UAaiaQsoGXfmJs6J5mZumcliSqpOQJJTEs | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_06OIScbuurQrCIv2RnyRnUL8yzZFIOkwx4bqVVJ1U8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_P8mpedaaoE314gdziPbBwa0OJmnSKCgK7OuMwTvh8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_riDg0AYVm42AlYT43jww1Ay107z2R3VQxYQLo3qt4w | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_rOmfpST6oLo347EYJ7Raz1NFUvjdcKoBJzJr0H9BgZ0 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_OotNkMr3fBFvpnup0QnIBAKz5eVEb0STNbTDByrUc | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_OVU4NcIdr6UAPevtvSSCtiep2KkZxR5zGCVShCeVdM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_PqG8IayP279sjtPG4vxuPRJW1hTc9wDd0Y6bxgfrj9M | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_jX8959OSsL1J6OXLEoQhYbwRZXji5sxbF5Emcsd7hk | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_nG2WofEr8CM8keV1x8PUfr4FiOA16RD19JEgZKAwYOw | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_phPzDO2Ka14Ao7Iqi5urCuijJRssi4yX4Ebgh3FcnbI | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_Cng12S8NWxtlSTgmXuOQLEDPix0BbRxa4F0cvSsv1c | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_Q1eQ5zKp1DmJrdMkqNxGrBxP1DirJ86dHnlUL7O6I | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_UxmIFNNcD8BvR6JmFFbZx6akhkSuYq2XDQUlQUfc6gM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_K03JPtJ3NPqclv8mEFeFiFxrLZNgqW5QncC2uGSA77Y | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_aenpgKLNXFjIwUuTFQwphJOVytmWnXoasHV2tDtjXA | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_F00TqNYYYq1qzYhXyz7eFauJxvms2okisTSzoXPYs | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_TFM8XAFL3R0W5BBj4PhNwCAwPErC6NwFNoclkK5Ozfg | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_bMHrVLsz7zTHT5CwjCPyMlvDh8syp5BNhgLmOFWY | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_uHyHdgbeup55x4fJn0iMgtziabR3eN1yEsBEkbjb5Q | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_T3o1wLwUnreOMfGErcoS5389oEEJtqeZlHP8vd3gA | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_BiFBNsNFG239ill5wF74Fp0WARoTWU8lZUEROfPJZvM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_G1e6Uvc81Pa7r6RKtchIZa50YYxIpwUNf0ONxBs4Bl0 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_WDgsk5S4YhtQoVJsDxcSUkTfZcwxXcb1NO0cFSqYNGs | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_IWJynIRPteI7yBdYHGdbMI4cyxoxfNlbtSN7B20y4M | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_D3YGmHHw8WNoPLjhaKccTYlBxHImWKx0FJmY7FY | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_5d6qs4EGU5QLch38FcFTz9usooPsSE3WceHdwYputc | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_B9w2udyDmdxORyQ5clNDVxDKQqarcHNAPO2AP3es | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_AdqeB4aKdR2MyUECPtovrc95H3CJ6Ig98U7CdiLGaIM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_drzV1CJMhZ88IeARb30GphbrzYOHnyNZjm3CgUbIWk | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem_InvestmentTrustRegion;

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField = (
  { __typename?: 'LookupField' }
  & Pick<Types.LookupField, 'targetId'>
  & { targetItem: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField_targetItem> }
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustLink_LinkField = (
  { __typename?: 'LinkField' }
  & Pick<Types.LinkField, 'url'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_InvestmentTrustStyle_name_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM = { __typename?: 'Accordion' | 'AccordionFolder' | 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' | 'AccordionItem' | 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' | 'AccordionParametersTemplate' | 'AccordionPresentation' | 'AccordionPresentationFolder' | 'Accordion_02d060598cc14423a9ac9ff2365176b7' | 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' | 'AddItem' | 'AddItem_1e1b739ec3784909941d171aca7362e5' | 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' | 'AddItem_de8c75222f3241288f20342f479894eb' | 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' | 'AddThisParameters' | 'AggregatedFacetFilter' | 'AlertMessage' | 'AlertMessageFolder' | 'AlertMessageParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_dxYboWowVqXyFEQIHTW4KbhL0lHEcueHzhBbeD0999E = { __typename?: 'AlertMessageType' | 'AllertMessageTypeFolder' | 'Archive' | 'ArticleAuthor' | 'ArticleAuthorsFolder' | 'ArticleCategoriesFolder' | 'ArticleCategory' | 'ArticleChapter' | 'ArticleChapters' | 'ArticleContentType' | 'ArticleContentTypesFolder' | 'ArticleFilter' | 'ArticleFilterOption' | 'ArticleFootnote' | 'ArticleFootnoteLink' | 'ArticleFootnoteText' | 'ArticleInfogramTile' | 'ArticleInfogramTileParametersTemplate' | 'ArticlePage' | 'ArticleRegion' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_UCMOSvPffh5Tlps5EZhWVbLbLYAlnbiakefGIxYg2c = { __typename?: 'ArticleRegionsFolder' | 'ArticleSearchPage' | 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' | 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' | 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' | 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' | 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' | 'ArticleSeriesCollection' | 'ArticleSeriesFolder' | 'ArticleSettings' | 'ArticleSubscriptionBanner' | 'ArticleSubscriptionBannerFolder' | 'ArticleTag' | 'ArticleTagsFolder' | 'ArticleTeamAuthor' | 'ArticleTileParametersTemplate' | 'ArticleTilesParametersTemplate' | 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' | 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' | 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_xOJlvcBbMeSH2ZalUPaTM5ZeT2yOsFIN0h3Iv01is = { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' | 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' | 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' | 'ArticlesGroupFolder' | 'AttachThemeExtension' | 'AutomaticDocumentListings' | 'AutomaticDocumentListingsFolder' | 'AvailableJSONRenderings' | 'AvailableMetaRenderings' | 'AvailableRenderings' | 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' | 'AwardsBanner' | 'AwardsBannerFolder' | 'AwardsBannerImage' | 'AwardsBannerParametersTemplate' | 'BYOCWrapperRenderingParameters' | 'BackgroundColorOption' | 'BackgroundColorOptionFolder' | 'BannerFolder' | 'BannerType' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_TgBsOnUPPY6QvMRCjrAA0aJn3wFokEUMSDZlsVd9leA = { __typename?: 'BannerTypeFolder' | 'BaseHeading' | 'BaseHeadingFolder' | 'BoolFacet' | 'BranchesFolder' | 'Breadcrumb' | 'BrowserTitleDefinition' | 'CORSEntry' | 'CORSGrouping' | 'CTAPresentationType' | 'CTAPresentationTypeFolder' | 'C__AbrdnPage' | 'C__ActionBase' | 'C__AdvancedParameter' | 'C__App' | 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' | 'C__ArticleWildcardPage' | 'C__AvailableRenderingsFolder' | 'C__BYOCRenderingParameters' | 'C__BackgroundParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_1Fa5VAiUYUP8Bw87eryyMTnXaWA3g3Hakldosv8 = { __typename?: 'C__BaseCTA' | 'C__BasePage' | 'C__BasePage_037da552a5524fe4aeee331f57ac1378' | 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' | 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' | 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' | 'C__BasePage_728c97b5c56146d9807e21018a972bb5' | 'C__BasePage_6105875085f346729dfc8d133b481f26' | 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' | 'C__BaseRenderingParameters' | 'C__BaseTheme' | 'C__BaseVariantField' | 'C__Class' | 'C__CompositeGroup' | 'C__CompositeSection' | 'C__EloquaForm' | 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' | 'C__ExtendedOptions' | 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' | 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_ulsOVUMq3wDI6F3tyWyLZ3nyaAUzdauAXpbf8QIk = { __typename?: 'C__FEaaSRenderingParameters' | 'C__FacetSelectorConfigBase' | 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' | 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' | 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' | 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' | 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' | 'C__GlobalDatasourceBehavior' | 'C__GridDefinition' | 'C__GridItemBase' | 'C__GridParameters' | 'C__HeadlessSite' | 'C__HeadlessTenant' | 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' | 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' | 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' | 'C__IAllowEmpty' | 'C__IBaseVariantDefinition' | 'C__IBoosting' | 'C__ICacheable' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_xUQOkj0GMlc5wv60bmQQj73AHXxb38nIGTeN1leA = { __typename?: 'C__ICompatibleRenderings' | 'C__IComponentVariant' | 'C__IControlType' | 'C__IDynamicPlaceholder' | 'C__IFEaaSComponentsDataSourceTemplates' | 'C__IFEaaSComponentsEditorScriptURL' | 'C__IIcon' | 'C__ILocation' | 'C__IPaginable' | 'C__IPagination' | 'C__IPoi' | 'C__IRenderingId' | 'C__ISplitter' | 'C__IStyling' | 'C__IVariantDefinition' | 'C__InvestmentTrustPage' | 'C__JSONField' | 'C__JSONReference' | 'C__JSSData' | 'C__JSSSettings' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_t5cfgcaU3rr0AvX2OG5htlgnm2iWMKRTcTxzGBh8 = { __typename?: 'C__JSSSiteFolder' | 'C__JssRootFolder' | 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' | 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' | 'C__Page' | 'C__PageData' | 'C__PageDesignFolder' | 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' | 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' | 'C__PartialDesign' | 'C__PartialDesignFolder' | 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' | 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' | 'C__PlaceholderWrapper' | 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' | 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' | 'C__RedirectMapGrouping' | 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' | 'C__Route' | 'C__SimpleVideo' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_4mXqXPHUZr4otYDSpYWX8Y4XMpULNT8i6kWuAJEVV8 = { __typename?: 'C__SiteSettingsFolder' | 'C__SitemapSettings' | 'C__StandardTemplate' | 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' | 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' | 'C__TrustFolder' | 'C__VariantDefinition' | 'C__VariantField' | 'C__VariantsGrouping' | 'C___AdvancedItem' | 'C___Arguments' | 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' | 'C___Article' | 'C___ArticlePageWorkflow' | 'C___ArticleSearchPage' | 'C___ArticleWildcard' | 'C___AssetServiceThemeMode' | 'C___BaseArticle' | 'C___BaseDataFolder' | 'C___BaseHelpArticle' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_eeK09Y7wkhG5t6ox2MHbp12nGtLVIravFt2ix25Urx8 = { __typename?: 'C___BaseInvestmentTrust' | 'C___BaseJSSTenant' | 'C___BasePage' | 'C___BasePageDesign' | 'C___BasePageDesignFolder' | 'C___BasePartialDesign' | 'C___BasePartialDesignFolder' | 'C___BasePlaceholder' | 'C___BasePlaceholderSettingsFolder' | 'C___BasePresentation' | 'C___BasePressRelease' | 'C___BaseRenderingParameters' | 'C___BaseSXAStandardValuesFolder' | 'C___BaseSettings' | 'C___BaseSharedSitesSettings' | 'C___BaseSiteDefinition' | 'C___BaseSiteFolder' | 'C___BaseSiteGrouping' | 'C___BaseSiteRoot' | 'C___BaseTenant' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_QxspLemKohwcfn6MLuzq31LoWJcDWhvc6FyIrdg3Y = { __typename?: 'C___BaseTenantFolder' | 'C___BucketRules' | 'C___CORS' | 'C___Content' | 'C___ContentType' | 'C___DataAttributes' | 'C___DatasourceWorkflow' | 'C___Dependencies' | 'C___Description' | 'C___DesignTemplateMapping' | 'C___Designable' | 'C___EditType' | 'C___EditType_8a9f84baaa124c5d9096935714809da4' | 'C___EditingTheme' | 'C___Enabled' | 'C___ErrorHandling' | 'C___ExternalArticle' | 'C___Fields' | 'C___FilteredArticlesParent' | 'C___FilteredArticlesWildcard' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_pLSvoSlIZBlpRr0oqseIDsMYsAtAKahN2CujcRmUG4 = { __typename?: 'C___Footnotes' | 'C___FundDetailsWildcard' | 'C___FundFormAvailability' | 'C___FundMetadataPage' | 'C___FundSearchPage' | 'C___FundsFolder' | 'C___FundsFormsFolder' | 'C___FundsLiteratureFolder' | 'C___FundsShareclassesDetailsWildcard' | 'C___GridMapping' | 'C___HelpArticle' | 'C___HelpArticleSearchPage' | 'C___HelpArticleWildcard' | 'C___HorizonDatasourceGrouping' | 'C___Icon' | 'C___IncludeByDefault' | 'C___IncludeIfInstalled' | 'C___InternalArticle' | 'C___InternetExplorerCompatibilityMode' | 'C___IsSystemModule' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_bAtMrDx88rUB43hbWgykdpxX2U1q1LBRCJ4YGeZd4 = { __typename?: 'C___JSONVariantPaging' | 'C___JSONVariantsBase' | 'C___LimitedDisplay' | 'C___LinkAttributes' | 'C___LinkSettings' | 'C___LiteratureHubSearchPage' | 'C___ManualKeyInformation' | 'C___MemberOf' | 'C___MetadataPage' | 'C___Modules' | 'C___Name' | 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' | 'C___Name_299cdb154745448a807868d401248eaa' | 'C___Name_b88cf88159a54a19991e71038751cb60' | 'C___Navigable' | 'C___NavigablePage' | 'C___PageContent' | 'C___PageWorkflow' | 'C___PerSiteStandardValues' | 'C___Podcast' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_3TTCxtPd167YL33nF9XBmmHbkUnxZovqTZClaQHWlMw = { __typename?: 'C___PodcastPressRelease' | 'C___PremiumContentPage' | 'C___PressRelease' | 'C___PressReleaseContentType' | 'C___PressReleaseSearchPage' | 'C___PressReleaseWildcard' | 'C___ProtectedTheme' | 'C___PublishingGroupingTemplate' | 'C___RenderingRelatedParameters' | 'C___RenderingVariantsBase' | 'C___RenderingsList' | 'C___RobotsContent' | 'C___RoleDomain' | 'C___RoleName' | 'C___RoleType' | 'C___SalesforceCommonValidations' | 'C___SalesforceFieldId' | 'C___SalesforceFieldTitle' | 'C___SalesforceFieldValue' | 'C___Script' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_cjYnlIs8UAaiaQsoGXfmJs6J5mZumcliSqpOQJJTEs = { __typename?: 'C___SearchSignature' | 'C___Searchable' | 'C___SecurityItemPointer' | 'C___SharedArticles' | 'C___SharedContent' | 'C___SharedHelpArticles' | 'C___SharedPage' | 'C___SharedPressReleases' | 'C___SharedRoot' | 'C___SharedSettings' | 'C___SiteContent' | 'C___SiteFolder' | 'C___SiteMediaLibrary' | 'C___SiteSettings' | 'C___SiteTemplate' | 'C___SitecoreClientSiteManaging' | 'C___Sitemap' | 'C___SitemapMediaItems' | 'C___SlidersRangeSettings' | 'C___SolutionTemplateContent' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_06OIScbuurQrCIv2RnyRnUL8yzZFIOkwx4bqVVJ1U8 = { __typename?: 'C___SolutionTemplateDescription' | 'C___SolutionTemplateName' | 'C___SortOrder' | 'C___StackBreakpoint' | 'C___Statistics' | 'C___SupportedLanguages' | 'C___Taggable' | 'C___TeamMembersParentPage' | 'C___TeamMembersWildcard' | 'C___TechzoneArticle' | 'C___Template' | 'C___Title' | 'C___Type' | 'C___Validation' | 'C___VariantPaging' | 'C___VectorTile' | 'C___VectorTileLink' | 'C___Video' | 'C___VideoPressRelease' | 'C___Width' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_P8mpedaaoE314gdziPbBwa0OJmnSKCgK7OuMwTvh8 = { __typename?: 'C___WildcardPage' | 'CacheSetting' | 'Caching_26fce9bf0256458d8281a713a5bf5520' | 'CalendarEvent' | 'CallOutSection' | 'CallOutSectionDropdownOption' | 'CallOutSectionFolder' | 'CallOutSectionParametersTemplate' | 'CallToAction' | 'CallToActionFolder' | 'CapabilitiesFolder' | 'Capability' | 'CapabilityMap' | 'CapabilityMappings' | 'Carousel' | 'CarouselFolder' | 'CarouselSlide' | 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' | 'Checkbox' | 'ChecklistFilter' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_riDg0AYVm42AlYT43jww1Ay107z2R3VQxYQLo3qt4w = { __typename?: 'ChecklistFilterFolder' | 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' | 'ColumnSplitter' | 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' | 'CompatibilityMode' | 'ComponentConfiguration' | 'ComponentThemeConfiguration' | 'ComponentThemesConfiguration' | 'ComponentsConfigurations' | 'ConfigurationFolder' | 'Container' | 'ContainerOption' | 'ContainerOptionsFolder' | 'ContainerParametersTemplate' | 'Container_45130bdbbae34edcaea87b68b9d94c7f' | 'ContentBlock' | 'ContentBlockFolder' | 'ContentToken' | 'ContentTokenFolder' | 'ContentType' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_rOmfpST6oLo347EYJ7Raz1NFUvjdcKoBJzJr0H9BgZ0 = { __typename?: 'CorporateTheme' | 'CorporateThemesFolder' | 'Country' | 'CountryISOCode' | 'CountryISOCodesFolder' | 'CustomerReviewFolder' | 'CustomerReviewTile' | 'CustomerReviewTileParametersTemplate' | 'DataBridgeDocumentCategoryMap' | 'DataBridgeFund' | 'DataBridgeFundRangeName' | 'DataBridgeSettingsFolder' | 'DataBridgeShareClass' | 'DataFolder' | 'DatasourceConfiguration' | 'DatasourceConfigurations' | 'DatasourceWorkflowAction' | 'DateFacet' | 'DateFilter' | 'DateFilterFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_OotNkMr3fBFvpnup0QnIBAKz5eVEb0STNbTDByrUc = { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' | 'DefaultColumnLayout' | 'DefaultShareclassMapping' | 'DefaultShareclassMappings' | 'DescriptiveHighlight' | 'DescriptiveHighlightFolder' | 'DescriptiveHighlightItem' | 'DescriptiveHighlightParametersTemplate' | 'Device' | 'Device_7c27ec70f42e40428a0fabaa2f8eda18' | 'Devices' | 'DictionaryFolder' | 'DisqusParameters' | 'DistanceFacet' | 'Divider' | 'DocumentItem' | 'DocumentListings' | 'DocumentListingsFolder' | 'DocumentTypeFolder' | 'DominantLanguageMapping' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_OVU4NcIdr6UAPevtvSSCtiep2KkZxR5zGCVShCeVdM = { __typename?: 'Dropdown' | 'DropdownFilter' | 'DropdownFilterFolder' | 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' | 'EditEditingTheme' | 'EditFrame' | 'EditModePanel' | 'EditSiteItem' | 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' | 'EditSiteTheme' | 'EditTenantTemplate' | 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' | 'EditType' | 'EloquaFormFolder' | 'EloquaFundForm' | 'Enum' | 'Enums' | 'ErrorPage' | 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' | 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_PqG8IayP279sjtPG4vxuPRJW1hTc9wDd0Y6bxgfrj9M = { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' | 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' | 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' | 'EventCalendarParameters' | 'EventList' | 'EventListParameters' | 'EventTypes' | 'EventsFolder' | 'ExecuteScript' | 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' | 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' | 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' | 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' | 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' | 'ExtendSiteTheme' | 'ExternalLiterature' | 'FEaaSWrapperRenderingParameters' | 'FacebookCommentsParametersTemplate' | 'FacetSlider' | 'FacetSliderFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_jX8959OSsL1J6OXLEoQhYbwRZXji5sxbF5Emcsd7hk = { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' | 'FacetSummary' | 'FacetSummaryFolder' | 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' | 'FacetsGrouping' | 'FakeNavigationItem' | 'FeatureBanner' | 'FeatureBannerParametersTemplate' | 'FeaturedArticles' | 'FeaturedArticlesFolder' | 'FeaturedTheme' | 'FeaturedThemesFolder' | 'Feed' | 'FeedFolder' | 'FeedParameters' | 'FieldEditor' | 'FieldRenderer' | 'FileList' | 'FileListFolder' | 'FileListParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_nG2WofEr8CM8keV1x8PUfr4FiOA16RD19JEgZKAwYOw = { __typename?: 'File_04129321770849c1801baee196e1c0a8' | 'FilterCriteria' | 'FilterCriteriaFolder' | 'FilterTaxonomyOption' | 'FilterTaxonomyOptions' | 'FilteredArticlesParentPage' | 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' | 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' | 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' | 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' | 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' | 'FilteredArticlesWildcardPage' | 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' | 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' | 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' | 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' | 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' | 'Flip' | 'FlipFolder' | 'Flip_5ef078504c044b839dafefd752cfaba8' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_phPzDO2Ka14Ao7Iqi5urCuijJRssi4yX4Ebgh3FcnbI = { __typename?: 'Flipside' | 'FloatFacet' | 'Footer' | 'FooterFolder' | 'FooterLink' | 'FormRenderingParameters' | 'FundAssetClass' | 'FundAssetClassesFolder' | 'FundDetailsWildcardPage' | 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' | 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' | 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' | 'FundFormsFolder' | 'FundInFocus' | 'FundInFocusShareClass' | 'FundSearchPage' | 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' | 'FundSearchPage_5806f83c03bc443380678ff955f4310f' | 'FundSearchPage_7432205c04214a419ca064c4cb37501c' | 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_Cng12S8NWxtlSTgmXuOQLEDPix0BbRxa4F0cvSsv1c = { __typename?: 'FundSettings' | 'FundShareclassDetailsWildcardPage' | 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' | 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' | 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' | 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' | 'FundSubAssetClass' | 'FundSubAssetClassesFolder' | 'FundsExternalLiteratureFolder' | 'FundsFolder' | 'FundsInFocusFolder' | 'FundsInFocusParametersTemplate' | 'FundsLiteratureFolder' | 'FundsLiteratureMappingsFolder' | 'Gallery' | 'GalleryFolder' | 'GalleryImage' | 'GalleryParametersTemplate' | 'GalleryVideo' | 'GatedAccordionContainer' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_Q1eQ5zKp1DmJrdMkqNxGrBxP1DirJ86dHnlUL7O6I = { __typename?: 'GlobalLanguageSelector' | 'GlobalNavigationBar' | 'GoogleAnalytics' | 'GoogleTagManager' | 'GoogleTagManagerFolder' | 'GridSetup' | 'GridTheme' | 'HTMLCode' | 'HTMLCodeFolder' | 'HTMLInclude' | 'HTMLIncludesFolder' | 'HTMLSnippet' | 'HTMLSnippetFolder' | 'HTMLTag' | 'Header' | 'HeaderFolder' | 'Heading' | 'HeadlessSiteSetupRoot' | 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' | 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_UxmIFNNcD8BvR6JmFFbZx6akhkSuYq2XDQUlQUfc6gM = { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' | 'HeadlessSite_68ffa40c5aab45548f774742b163f318' | 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' | 'HeadlessSite_229484893ca144958b9937167dfb5064' | 'HeadlessSite_b28055626acc45a2913a9617398c9730' | 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' | 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' | 'HeadlessSolutionTemplateFolder' | 'HeadlessTenantSetupRoot' | 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' | 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' | 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' | 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' | 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' | 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' | 'HeadlessTenant_94824ac390d748499e5af0275d10811f' | 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' | 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' | 'HeadlessTrustSite' | 'HeadlessVariants' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_K03JPtJ3NPqclv8mEFeFiFxrLZNgqW5QncC2uGSA77Y = { __typename?: 'HeadlessVariantsGrouping' | 'HelpArticlePage' | 'HelpArticlePlatform' | 'HelpArticlePlatformMap' | 'HelpArticlePlatformMappings' | 'HelpArticlePlatformsFolder' | 'HelpArticleSearchPage' | 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' | 'HelpArticleTag' | 'HelpArticleTagsFolder' | 'HelpArticleWildcardPage' | 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' | 'HelpArticlesGroupFolder' | 'HelpTagMap' | 'HelpTagMappings' | 'HeroBanner' | 'Highlight' | 'HighlightBlock' | 'HighlightBlockFolder' | 'HighlightBlockParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_aenpgKLNXFjIwUuTFQwphJOVytmWnXoasHV2tDtjXA = { __typename?: 'HighlightFolder' | 'HighlightItem' | 'HighlightParametersTemplate' | 'Home' | 'HomePage' | 'HomePage_0d3963a8171d4080b5f808618578b631' | 'HomePage_6d95c7d946c74a70be07304cc73a2010' | 'HomePage_b407f259b4e34c7db9a06e8907a56b17' | 'HomePage_cde13c51062d426b95569e8202edc963' | 'HomePage_de9353283a3e41c495ba386aed0540c6' | 'IFrame' | 'IFrameFolder' | 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' | 'IFrameParametersTemplate' | 'IFrame_0da12d476de24dfeb4d0f513489bfea1' | 'IFrame_88a6f65f2b78491bb3770b06e48883e1' | 'Icon' | 'IconFolder' | 'Image' | 'ImageFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_CDmoRsf7y8h5Ar2oUgFnNgiYg5Wm5MFB5sWqwpfoA = { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' | 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' | 'ImageParametersTemplate' | 'Image_83bc563c6320490092f8204bff81586a' | 'Image_15185b0e641844499f934ff03b7ee032' | 'Image_d885df8cb2d64007b34b2bbafb527304' | 'Infographics' | 'InfographicsFolder' | 'InputValidationStep' | 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' | 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' | 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' | 'IntegerFacet' | 'IntroCopy' | 'IntroCopyFolder' | 'InvestmentTrustAssetClass' | 'InvestmentTrustAssetClassFolder' | 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' | 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' | 'InvestmentTrustRegion' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_ksNkj4Kf7YkGtU7HnM7rStY7hriXb1uCPaAwDo94Q = { __typename?: 'InvestmentTrustRegionFolder' | 'InvestmentTrustStyleFolder' | 'InvestorType' | 'InvestorTypesFolder' | 'ItemQueriesFolder' | 'ItemRights' | 'JSBeaconSettings' | 'JSONCheckbox' | 'JSONContent' | 'JSONDate' | 'JSONFile' | 'JSONImage' | 'JSONLayout' | 'JSONList' | 'JSONMultilistReference' | 'JSONPlaceholder' | 'JSONQuery' | 'JSONResults' | 'JSONRichText' | 'JSONScriban' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_bMHrVLsz7zTHT5CwjCPyMlvDh8syp5BNhgLmOFWY = { __typename?: 'JSONSection' | 'JSONTemplate' | 'JSONText' | 'JSONToken' | 'JSONVariantDefinition' | 'JSONVariants' | 'JSSLayout' | 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' | 'JSSSettings_6b328292f8314ab79885d89a054ca10a' | 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' | 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' | 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' | 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' | 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' | 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' | 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' | 'JSSSiteGrouping' | 'JSSTenantFolder' | 'JavaScriptRendering' | 'JsonRendering' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_uHyHdgbeup55x4fJn0iMgtziabR3eN1yEsBEkbjb5Q = { __typename?: 'JurisdictionStatus' | 'JurisdictionsFolder' | 'KeyHighlightItem' | 'KeyHighlights' | 'KeyHighlightsFolder' | 'KeyHighlightsParametersTemplate' | 'Language' | 'LanguageSelector' | 'LanguagesFolder' | 'LatestPressReleasesParametersTemplate' | 'LayoutServiceVariants' | 'LimitedDisplayFolder' | 'LimitedDisplayOption' | 'Link' | 'LinkList' | 'LinkListFolder' | 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' | 'LinkList_33c9207e3b0446068ef54ca99a97c776' | 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' | 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_T3o1wLwUnreOMfGErcoS5389oEEJtqeZlHP8vd3gA = { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' | 'Link_930f134d56784b35bfd1b77f9d0115f1' | 'Link_e24e0789a05848bfabb6c69c0e60b6b7' | 'LinksFolder' | 'List' | 'ListFacet' | 'ListFolder' | 'ListItem' | 'ListParametersTemplate' | 'ListStyle' | 'ListStyleItem' | 'ListingHeroBanner' | 'ListingHeroParametersTemplate' | 'LiteratureAuthorization' | 'LiteratureAuthorizationsFolder' | 'LiteratureHubSearchPage' | 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' | 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' | 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' | 'LoadMore' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_BiFBNsNFG239ill5wF74Fp0WARoTWU8lZUEROfPJZvM = { __typename?: 'LoadMoreFolder' | 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' | 'LocationFilter' | 'LocationFilterFolder' | 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' | 'Log' | 'Login' | 'Login_abed54dc4f7840ddac562289c9c849d8' | 'LogoTextBlockItem' | 'LogoTextBlocks' | 'LogoTextBlocksFolder' | 'Logout' | 'Logout_c2294d8235a6452a94b15eb5e543b602' | 'ManagedRangeFilter' | 'ManagedRangeFilterFolder' | 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' | 'ManagedRangeItem' | 'Map' | 'MapParameters' | 'MapsFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_G1e6Uvc81Pa7r6RKtchIZa50YYxIpwUNf0ONxBs4Bl0 = { __typename?: 'MapsProvider' | 'MediaBlock' | 'MediaBlockFolder' | 'MediaBlockParametersTemplate' | 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' | 'MediaLinkParameters' | 'MediaVirtualFolder' | 'MegaNavigation' | 'MegaNavigationFolder' | 'MetaBranding' | 'MetaRenderingParameters' | 'MetadataPartialDesign' | 'Model' | 'ModelIterator' | 'MyLocationPOI' | 'Navigation' | 'NavigationCategory' | 'NavigationFilter' | 'NavigationFilterFolder' | 'NavigationLink' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_WDgsk5S4YhtQoVJsDxcSUkTfZcwxXcb1NO0cFSqYNGs = { __typename?: 'NavigationSubcategory' | 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' | 'OneTrustSettings' | 'OptimiserConfiguration' | 'OptimiserConfigurationSection' | 'OptimizedFile' | 'OracleCDPSettings' | 'OverlayContent' | 'OverlayFolderTemplate' | 'Ownership' | 'OwnershipFolder' | 'POI' | 'POIFolder' | 'POIType' | 'POIs' | 'PageBranchesFolder' | 'PageContent' | 'PageContentFolder' | 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' | 'PageDesign' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_IWJynIRPteI7yBdYHGdbMI4cyxoxfNlbtSN7B20y4M = { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' | 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' | 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' | 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' | 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' | 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' | 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' | 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' | 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' | 'PageDesign_1105b8f81e00426bbf1fc840742d827b' | 'PageDesigns' | 'PageDesigns_3af52e70e982424b9c85e355542500c9' | 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' | 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' | 'PageDesigns_99a71bba507746729c3fb29b04abee23' | 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' | 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' | 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' | 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' | 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_D3YGmHHw8WNoPLjhaKccTYlBxHImWKx0FJmY7FY = { __typename?: 'PageLevelTabs' | 'PageLevelTabsFolder' | 'PageList' | 'PageSelector' | 'PageSelectorConfiguration' | 'PageSelectorFolder' | 'PageSelector_59a7bb775f8c435ab810291abde80e63' | 'PageSize' | 'PageSizeFolder' | 'PageSize_b682562e0af64b3e9e3b45273bbe152d' | 'PageTheme' | 'PageThemesFolder' | 'Page_4f49a81db3664f198b89cab92f377d7a' | 'Page_5e66d86353544fe6a27d3b894984d50f' | 'Page_84f342ad2d0646b9aa9a818201145ca2' | 'Page_718df200be51463d93edf4d77ab7a49e' | 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' | 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' | 'Page_dae7821153e14dbabb0ddf0b53a90aaf' | 'Page_fa608b3e6aeb426388a059d89caabada' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_5d6qs4EGU5QLch38FcFTz9usooPsSE3WceHdwYputc = { __typename?: 'Pagging' | 'Pagination' | 'PaginationFolder' | 'Paragraph' | 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' | 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' | 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' | 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' | 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' | 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' | 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' | 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' | 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' | 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' | 'PartialDesigns' | 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' | 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' | 'PartialDesigns_36c869ded22040929ce829f6ed643c66' | 'PartialDesigns_1943dc73710a430895515a342c84b037' | 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_B9w2udyDmdxORyQ5clNDVxDKQqarcHNAPO2AP3es = { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' | 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' | 'PartialDesigns_d216303f58d8425688da8cd30d00afab' | 'PartialDesigns_facda26791204fa9a0363344348f2c42' | 'PerformanceChartSettings' | 'PerformanceChartTimePeriod' | 'PerformanceChartTimePeriodFolder' | 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' | 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' | 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' | 'Placeholder_1ca0304be5b64810821154426f1752c2' | 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' | 'PlainHtmlParametersTemplate' | 'Playlist' | 'PlaylistFolder' | 'PlaylistParametersTemplate' | 'Podcast' | 'PodcastFolder' | 'PodcastPage' | 'PodcastPressReleasePage' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_AdqeB4aKdR2MyUECPtovrc95H3CJ6Ig98U7CdiLGaIM = { __typename?: 'PoiTypes' | 'PostDeleteStep' | 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' | 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' | 'PostDeleteStep_b20857895385413883f096f3767cb156' | 'PostSetupStep' | 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' | 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' | 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' | 'PreDeleteStep' | 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' | 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' | 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' | 'PreDeleteValidationStep' | 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' | 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' | 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' | 'Presentation' | 'Presentation_0a70fa7389234a6eabf34134f25f3221' | 'PressReleaseContentType' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_drzV1CJMhZ88IeARb30GphbrzYOHnyNZjm3CgUbIWk = { __typename?: 'PressReleaseContentTypesFolder' | 'PressReleaseFilter' | 'PressReleasePage' | 'PressReleasePlatform' | 'PressReleasePlatformsFolder' | 'PressReleaseSearchPage' | 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' | 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' | 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' | 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' | 'PressReleaseWildcardPage' | 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' | 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' | 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' | 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' | 'PressReleasesGroupFolder' | 'PrivacyWarning' | 'ProjectFolder' | 'Promo' | 'PromoFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU = { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' | 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' | 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' | 'Promo_dfed4457d760457abec1c0dccdc44381' | 'PromotedContent' | 'PromotedContentFolder' | 'PropertyListingCard' | 'PropertyListingCards' | 'PropertyListingCategory' | 'PropertyListingFolder' | 'Query_98b413525a4b4067b92418a4b50f0a53' | 'QuickLinks' | 'QuickLinksFolder' | 'QuickLinksParametersTemplate' | 'QuotationBlockItem' | 'QuotationBlocks' | 'QuotationBlocksFolder' | 'QuotationBlocksParametersTemplate' | 'Quote' | 'QuoteFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 = { __typename?: 'QuoteParametersTemplate' | 'RadiusFilter' | 'RadiusFilterFolder' | 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' | 'RadiusScheme' | 'RadiusSchemeValue' | 'RangeSliderFilter' | 'RangeSliderFilterFolder' | 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' | 'RecentArticles' | 'Redirect' | 'RedirectMap' | 'RedirectMaps' | 'Region' | 'RegionLanguages' | 'RegionLanguagesFolder' | 'RelatedArticles' | 'RelatedArticlesParametersTemplate' | 'RenderEngineType' | 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg = { __typename?: 'RenderingHost' | 'ResizableIFramePage' | 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' | 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' | 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' | 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' | 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' | 'ResponsiveImage' | 'ResultsCount' | 'ResultsCountFolder' | 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' | 'ResultsVariantSelector' | 'RichText' | 'RichTextFolder' | 'RichText_0f3b73366112418c8bbab0526f3887ce' | 'RichText_efcfd8f6596745f48f85b5421928205d' | 'RiskImageMapping' | 'RiskImageMappings' | 'RiskLevelOption' | 'RiskLevelOptionFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc = { __typename?: 'RiskWarning' | 'RiskWarningFolder' | 'RiskWarningParametersTemplate' | 'RolePlaceholder' | 'RowSplitter' | 'RowSplitter_340c887da1d1415b9678c763af74ea97' | 'Rule' | 'SDRLogoMapping' | 'SDRLogoMappings' | 'SDRTypeOption' | 'SDRTypeOptionFolder' | 'SXAJSSLayout' | 'SXARole' | 'SXAStandardValuesFolder' | 'SalesforceAlertMessage' | 'SalesforceCheckBox' | 'SalesforceCheckBoxType' | 'SalesforceConditionalRadioButton' | 'SalesforceConditionalRadioButtons' | 'SalesforceDateInput' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM = { __typename?: 'SalesforceDropdown' | 'SalesforceDropdownOption' | 'SalesforceHiddenField' | 'SalesforceInput' | 'SalesforceInputType' | 'SalesforceIntegratedForm' | 'SalesforceIntegratedFormTypesFolder' | 'SalesforceRepeatableSubSection' | 'SalesforceRichTextArea' | 'SalesforceSection' | 'SalesforceSortCodeInput' | 'SalesforceSubmissionType' | 'Scope' | 'ScopesFolder' | 'Scriban' | 'Scripts' | 'SearchBox' | 'SearchBoxFolder' | 'SearchBox_1c04fd611d874590acfe9cc186865ab3' | 'SearchFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo = { __typename?: 'SearchResults' | 'SearchResultsFolder' | 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' | 'SecondaryHeroBannerParametersTemplate' | 'SectionHeading' | 'SectionHeadingFolder' | 'SectionHeadingParametersTemplate' | 'SectionHeadingType' | 'SectionHeadingTypeFolder' | 'SectionSelector' | 'SectionSelectorFolder' | 'SectionSelectorTab' | 'Security_33077d51ebad4d1cb4a83b79f51dba13' | 'Series' | 'SeriesFolder' | 'Settings' | 'SettingsFolder' | 'Settings_6c82caca67dc464195698faad083230e' | 'SharePriceSettings' | 'SharedArticlesFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs = { __typename?: 'SharedContentFolder' | 'SharedFolder' | 'SharedHelpArticlesFolder' | 'SharedPressReleasesFolder' | 'SharedSettingsFolder' | 'SharedSitesSettings' | 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' | 'Showcase' | 'ShowcaseFolder' | 'ShowcaseItem' | 'ShowcaseParametersTemplate' | 'Site' | 'SiteContentFolder' | 'SiteDefinition' | 'SiteEntryDisclaimer' | 'SiteFolder' | 'SiteGrouping' | 'SiteManagement' | 'SiteSecurityItemPointer' | 'SiteSelector' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo = { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' | 'SiteSetupRoot' | 'SiteTheme' | 'Site_e46f3af239fa4866a1577017c4b2a40c' | 'SitecoreFormWrapperParametersTemplate' | 'SitecoreRole' | 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' | 'SkipLink' | 'SkipLinkParameters' | 'SkipLinksFolder' | 'Snippet' | 'SnippetItem' | 'SnippetsFolder' | 'SocialLoginWrapper' | 'SocialMediaButtons' | 'SocialMediaFolder' | 'SocialMediaShare' | 'SocialMediaTemplate' | 'SocialNetwork' | 'SocialNetworkFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU = { __typename?: 'SocialNetworkLink' | 'SolutionTemplate' | 'SortResults' | 'SortResultsFolder' | 'Sorting' | 'SortingGroups' | 'SpotifyPodcast' | 'SpotifyPodcastFolder' | 'StickyCTA' | 'StickyCTAFolder' | 'StickyCTAParametersTemplate' | 'StrategiesInFocusFolder' | 'StrategyInFocus' | 'Style' | 'Styles' | 'Styles_9c0dac2808aa4b44bc2153363206f6a5' | 'SubscriptionBannerParametersTemplate' | 'Tab' | 'TabItem' | 'TableOfContents' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 = { __typename?: 'TableOfContentsFolder' | 'TableOfContentsSection' | 'TableOfContentsSubsection' | 'Tabs' | 'TabsFolder' | 'Tabs_f26a9560ccf148c59542800e837caf7a' | 'Tag' | 'TagCloud' | 'TagFolder' | 'TagList' | 'TeamBiographySettings' | 'TeamListingCards' | 'TeamListingCardsFolder' | 'TeamMember' | 'TeamMemberCard' | 'TeamMembers' | 'TeamMembersParentPage' | 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' | 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' | 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk = { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' | 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' | 'TeamMembersWildcardPage' | 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' | 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' | 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' | 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' | 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' | 'TeamProfileCards' | 'TeamProfileCardsFolder' | 'TechzoneArticlePage' | 'Tenant' | 'TenantFolder' | 'TenantSecurityItemPointer' | 'TenantSetupRoot' | 'TertieryHeroBanner' | 'TertieryHeroBannerParametersTemplate' | 'Text' | 'TextBlock' | 'TextBlockHeadingParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 = { __typename?: 'TextBlockHeadingType' | 'TextBlockHeadingTypeFolder' | 'TextBlockLinkType' | 'TextBlockLinkTypeFolder' | 'TextBlocks' | 'TextBlocksFolder' | 'TextBlocksParametersTemplate' | 'TextFolder' | 'TextFolder_b762d56787f5493cbb480c455d834457' | 'Text_b8f5894cb4934016bf784090b0a2fd16' | 'Theme' | 'ThemeTag' | 'ThemeTagsFolder' | 'ThemingMode' | 'ThemingModes' | 'Tile' | 'TileLink' | 'TileParametersTemplate' | 'TileSizeOption' | 'TileSizeOptionFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 = { __typename?: 'TilesFolder' | 'TilesParametersTemplate' | 'Title' | 'Title_a82e893105754175917de904ef7e6dbe' | 'Toggle' | 'ToggleFolder' | 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' | 'Transformation' | 'TrustArticleHeroParametersTemplate' | 'TrustFinder' | 'TrustFinderFilterOption' | 'TrustRegion' | 'TrustType' | 'TrustTypesFolder' | 'Twitter' | 'TwitterApp' | 'TwitterApps' | 'TwitterFolder' | 'TwitterParametersTemplate' | 'TwitterSettings' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w = { __typename?: 'UnknownItem' | 'UnminifiedFile' | 'UpgradeScript' | 'UpgradeScriptLibrary' | 'VariantComponentField' | 'VariantDateField' | 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' | 'VariantPlaceholder' | 'VariantReference' | 'VariantSection' | 'VariantTemplate' | 'VariantText' | 'VariantToken' | 'Variants' | 'VectorFolder' | 'VectorTile' | 'VectorTileLink' | 'VectorTilesFolder' | 'VectorTilesParametersTemplate' | 'Version_95ebc23204774dc38ad3465d5fe8da2f' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU = { __typename?: 'Video' | 'VideoCountOption' | 'VideoCountOptions' | 'VideoFolder' | 'VideoFolder_bba49474673e468186ba8b1a20e067a9' | 'VideoPage' | 'VideoParameters' | 'VideoParametersTemplate' | 'VideoPressReleasePage' | 'Video_4bc649610a894242be2dc5026090cf49' | '_AssetsOptimization' | '_BackgroundImage' | '_CompatibleThemes' | '_CompositeTheme' | '_CustomMetadata' | '_CustomRenderingViewPath' | '_DatasourceBehaviour' | '_Favicon' | '_FormsFolderLocation' | '_FundSettings' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 = { __typename?: '_HasValidUrlName' | '_LocalDataLink' | '_Login' | '_OpenGraphMetadata' | '_PageDesignTheme' | '_PageSearchScope' | '_SearchCriteria' | '_SearchableWithoutRelatedItems' | '_SeoMetadata' | '_SiteTheme' | '_SitemapSettings' | '_StickyNote' | '_Styleable' | '_TwitterMetadata' | '_Webinar' | '_WildcardSource' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_InvestmentTrustStyle = (
  { __typename?: 'InvestmentTrustStyle' }
  & { name: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_InvestmentTrustStyle_name_TextField> }
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem = TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_dxYboWowVqXyFEQIHTW4KbhL0lHEcueHzhBbeD0999E | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_UCMOSvPffh5Tlps5EZhWVbLbLYAlnbiakefGIxYg2c | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_xOJlvcBbMeSH2ZalUPaTM5ZeT2yOsFIN0h3Iv01is | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_TgBsOnUPPY6QvMRCjrAA0aJn3wFokEUMSDZlsVd9leA | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_1Fa5VAiUYUP8Bw87eryyMTnXaWA3g3Hakldosv8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_ulsOVUMq3wDI6F3tyWyLZ3nyaAUzdauAXpbf8QIk | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_xUQOkj0GMlc5wv60bmQQj73AHXxb38nIGTeN1leA | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_t5cfgcaU3rr0AvX2OG5htlgnm2iWMKRTcTxzGBh8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_4mXqXPHUZr4otYDSpYWX8Y4XMpULNT8i6kWuAJEVV8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_eeK09Y7wkhG5t6ox2MHbp12nGtLVIravFt2ix25Urx8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_QxspLemKohwcfn6MLuzq31LoWJcDWhvc6FyIrdg3Y | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_pLSvoSlIZBlpRr0oqseIDsMYsAtAKahN2CujcRmUG4 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_bAtMrDx88rUB43hbWgykdpxX2U1q1LBRCJ4YGeZd4 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_3TTCxtPd167YL33nF9XBmmHbkUnxZovqTZClaQHWlMw | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_cjYnlIs8UAaiaQsoGXfmJs6J5mZumcliSqpOQJJTEs | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_06OIScbuurQrCIv2RnyRnUL8yzZFIOkwx4bqVVJ1U8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_P8mpedaaoE314gdziPbBwa0OJmnSKCgK7OuMwTvh8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_riDg0AYVm42AlYT43jww1Ay107z2R3VQxYQLo3qt4w | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_rOmfpST6oLo347EYJ7Raz1NFUvjdcKoBJzJr0H9BgZ0 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_OotNkMr3fBFvpnup0QnIBAKz5eVEb0STNbTDByrUc | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_OVU4NcIdr6UAPevtvSSCtiep2KkZxR5zGCVShCeVdM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_PqG8IayP279sjtPG4vxuPRJW1hTc9wDd0Y6bxgfrj9M | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_jX8959OSsL1J6OXLEoQhYbwRZXji5sxbF5Emcsd7hk | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_nG2WofEr8CM8keV1x8PUfr4FiOA16RD19JEgZKAwYOw | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_phPzDO2Ka14Ao7Iqi5urCuijJRssi4yX4Ebgh3FcnbI | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_Cng12S8NWxtlSTgmXuOQLEDPix0BbRxa4F0cvSsv1c | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_Q1eQ5zKp1DmJrdMkqNxGrBxP1DirJ86dHnlUL7O6I | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_UxmIFNNcD8BvR6JmFFbZx6akhkSuYq2XDQUlQUfc6gM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_K03JPtJ3NPqclv8mEFeFiFxrLZNgqW5QncC2uGSA77Y | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_aenpgKLNXFjIwUuTFQwphJOVytmWnXoasHV2tDtjXA | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_CDmoRsf7y8h5Ar2oUgFnNgiYg5Wm5MFB5sWqwpfoA | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_ksNkj4Kf7YkGtU7HnM7rStY7hriXb1uCPaAwDo94Q | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_bMHrVLsz7zTHT5CwjCPyMlvDh8syp5BNhgLmOFWY | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_uHyHdgbeup55x4fJn0iMgtziabR3eN1yEsBEkbjb5Q | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_T3o1wLwUnreOMfGErcoS5389oEEJtqeZlHP8vd3gA | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_BiFBNsNFG239ill5wF74Fp0WARoTWU8lZUEROfPJZvM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_G1e6Uvc81Pa7r6RKtchIZa50YYxIpwUNf0ONxBs4Bl0 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_WDgsk5S4YhtQoVJsDxcSUkTfZcwxXcb1NO0cFSqYNGs | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_IWJynIRPteI7yBdYHGdbMI4cyxoxfNlbtSN7B20y4M | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_D3YGmHHw8WNoPLjhaKccTYlBxHImWKx0FJmY7FY | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_5d6qs4EGU5QLch38FcFTz9usooPsSE3WceHdwYputc | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_B9w2udyDmdxORyQ5clNDVxDKQqarcHNAPO2AP3es | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_AdqeB4aKdR2MyUECPtovrc95H3CJ6Ig98U7CdiLGaIM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_drzV1CJMhZ88IeARb30GphbrzYOHnyNZjm3CgUbIWk | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem_InvestmentTrustStyle;

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField = (
  { __typename?: 'LookupField' }
  & Pick<Types.LookupField, 'targetId'>
  & { targetItem: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField_targetItem> }
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_InvestmentTrustAssetClass_name_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM = { __typename?: 'Accordion' | 'AccordionFolder' | 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' | 'AccordionItem' | 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' | 'AccordionParametersTemplate' | 'AccordionPresentation' | 'AccordionPresentationFolder' | 'Accordion_02d060598cc14423a9ac9ff2365176b7' | 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' | 'AddItem' | 'AddItem_1e1b739ec3784909941d171aca7362e5' | 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' | 'AddItem_de8c75222f3241288f20342f479894eb' | 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' | 'AddThisParameters' | 'AggregatedFacetFilter' | 'AlertMessage' | 'AlertMessageFolder' | 'AlertMessageParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_dxYboWowVqXyFEQIHTW4KbhL0lHEcueHzhBbeD0999E = { __typename?: 'AlertMessageType' | 'AllertMessageTypeFolder' | 'Archive' | 'ArticleAuthor' | 'ArticleAuthorsFolder' | 'ArticleCategoriesFolder' | 'ArticleCategory' | 'ArticleChapter' | 'ArticleChapters' | 'ArticleContentType' | 'ArticleContentTypesFolder' | 'ArticleFilter' | 'ArticleFilterOption' | 'ArticleFootnote' | 'ArticleFootnoteLink' | 'ArticleFootnoteText' | 'ArticleInfogramTile' | 'ArticleInfogramTileParametersTemplate' | 'ArticlePage' | 'ArticleRegion' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_UCMOSvPffh5Tlps5EZhWVbLbLYAlnbiakefGIxYg2c = { __typename?: 'ArticleRegionsFolder' | 'ArticleSearchPage' | 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' | 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' | 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' | 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' | 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' | 'ArticleSeriesCollection' | 'ArticleSeriesFolder' | 'ArticleSettings' | 'ArticleSubscriptionBanner' | 'ArticleSubscriptionBannerFolder' | 'ArticleTag' | 'ArticleTagsFolder' | 'ArticleTeamAuthor' | 'ArticleTileParametersTemplate' | 'ArticleTilesParametersTemplate' | 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' | 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' | 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_xOJlvcBbMeSH2ZalUPaTM5ZeT2yOsFIN0h3Iv01is = { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' | 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' | 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' | 'ArticlesGroupFolder' | 'AttachThemeExtension' | 'AutomaticDocumentListings' | 'AutomaticDocumentListingsFolder' | 'AvailableJSONRenderings' | 'AvailableMetaRenderings' | 'AvailableRenderings' | 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' | 'AwardsBanner' | 'AwardsBannerFolder' | 'AwardsBannerImage' | 'AwardsBannerParametersTemplate' | 'BYOCWrapperRenderingParameters' | 'BackgroundColorOption' | 'BackgroundColorOptionFolder' | 'BannerFolder' | 'BannerType' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_TgBsOnUPPY6QvMRCjrAA0aJn3wFokEUMSDZlsVd9leA = { __typename?: 'BannerTypeFolder' | 'BaseHeading' | 'BaseHeadingFolder' | 'BoolFacet' | 'BranchesFolder' | 'Breadcrumb' | 'BrowserTitleDefinition' | 'CORSEntry' | 'CORSGrouping' | 'CTAPresentationType' | 'CTAPresentationTypeFolder' | 'C__AbrdnPage' | 'C__ActionBase' | 'C__AdvancedParameter' | 'C__App' | 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' | 'C__ArticleWildcardPage' | 'C__AvailableRenderingsFolder' | 'C__BYOCRenderingParameters' | 'C__BackgroundParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_1Fa5VAiUYUP8Bw87eryyMTnXaWA3g3Hakldosv8 = { __typename?: 'C__BaseCTA' | 'C__BasePage' | 'C__BasePage_037da552a5524fe4aeee331f57ac1378' | 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' | 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' | 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' | 'C__BasePage_728c97b5c56146d9807e21018a972bb5' | 'C__BasePage_6105875085f346729dfc8d133b481f26' | 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' | 'C__BaseRenderingParameters' | 'C__BaseTheme' | 'C__BaseVariantField' | 'C__Class' | 'C__CompositeGroup' | 'C__CompositeSection' | 'C__EloquaForm' | 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' | 'C__ExtendedOptions' | 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' | 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_ulsOVUMq3wDI6F3tyWyLZ3nyaAUzdauAXpbf8QIk = { __typename?: 'C__FEaaSRenderingParameters' | 'C__FacetSelectorConfigBase' | 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' | 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' | 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' | 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' | 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' | 'C__GlobalDatasourceBehavior' | 'C__GridDefinition' | 'C__GridItemBase' | 'C__GridParameters' | 'C__HeadlessSite' | 'C__HeadlessTenant' | 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' | 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' | 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' | 'C__IAllowEmpty' | 'C__IBaseVariantDefinition' | 'C__IBoosting' | 'C__ICacheable' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_xUQOkj0GMlc5wv60bmQQj73AHXxb38nIGTeN1leA = { __typename?: 'C__ICompatibleRenderings' | 'C__IComponentVariant' | 'C__IControlType' | 'C__IDynamicPlaceholder' | 'C__IFEaaSComponentsDataSourceTemplates' | 'C__IFEaaSComponentsEditorScriptURL' | 'C__IIcon' | 'C__ILocation' | 'C__IPaginable' | 'C__IPagination' | 'C__IPoi' | 'C__IRenderingId' | 'C__ISplitter' | 'C__IStyling' | 'C__IVariantDefinition' | 'C__InvestmentTrustPage' | 'C__JSONField' | 'C__JSONReference' | 'C__JSSData' | 'C__JSSSettings' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_t5cfgcaU3rr0AvX2OG5htlgnm2iWMKRTcTxzGBh8 = { __typename?: 'C__JSSSiteFolder' | 'C__JssRootFolder' | 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' | 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' | 'C__Page' | 'C__PageData' | 'C__PageDesignFolder' | 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' | 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' | 'C__PartialDesign' | 'C__PartialDesignFolder' | 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' | 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' | 'C__PlaceholderWrapper' | 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' | 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' | 'C__RedirectMapGrouping' | 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' | 'C__Route' | 'C__SimpleVideo' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_4mXqXPHUZr4otYDSpYWX8Y4XMpULNT8i6kWuAJEVV8 = { __typename?: 'C__SiteSettingsFolder' | 'C__SitemapSettings' | 'C__StandardTemplate' | 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' | 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' | 'C__TrustFolder' | 'C__VariantDefinition' | 'C__VariantField' | 'C__VariantsGrouping' | 'C___AdvancedItem' | 'C___Arguments' | 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' | 'C___Article' | 'C___ArticlePageWorkflow' | 'C___ArticleSearchPage' | 'C___ArticleWildcard' | 'C___AssetServiceThemeMode' | 'C___BaseArticle' | 'C___BaseDataFolder' | 'C___BaseHelpArticle' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_eeK09Y7wkhG5t6ox2MHbp12nGtLVIravFt2ix25Urx8 = { __typename?: 'C___BaseInvestmentTrust' | 'C___BaseJSSTenant' | 'C___BasePage' | 'C___BasePageDesign' | 'C___BasePageDesignFolder' | 'C___BasePartialDesign' | 'C___BasePartialDesignFolder' | 'C___BasePlaceholder' | 'C___BasePlaceholderSettingsFolder' | 'C___BasePresentation' | 'C___BasePressRelease' | 'C___BaseRenderingParameters' | 'C___BaseSXAStandardValuesFolder' | 'C___BaseSettings' | 'C___BaseSharedSitesSettings' | 'C___BaseSiteDefinition' | 'C___BaseSiteFolder' | 'C___BaseSiteGrouping' | 'C___BaseSiteRoot' | 'C___BaseTenant' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_QxspLemKohwcfn6MLuzq31LoWJcDWhvc6FyIrdg3Y = { __typename?: 'C___BaseTenantFolder' | 'C___BucketRules' | 'C___CORS' | 'C___Content' | 'C___ContentType' | 'C___DataAttributes' | 'C___DatasourceWorkflow' | 'C___Dependencies' | 'C___Description' | 'C___DesignTemplateMapping' | 'C___Designable' | 'C___EditType' | 'C___EditType_8a9f84baaa124c5d9096935714809da4' | 'C___EditingTheme' | 'C___Enabled' | 'C___ErrorHandling' | 'C___ExternalArticle' | 'C___Fields' | 'C___FilteredArticlesParent' | 'C___FilteredArticlesWildcard' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_pLSvoSlIZBlpRr0oqseIDsMYsAtAKahN2CujcRmUG4 = { __typename?: 'C___Footnotes' | 'C___FundDetailsWildcard' | 'C___FundFormAvailability' | 'C___FundMetadataPage' | 'C___FundSearchPage' | 'C___FundsFolder' | 'C___FundsFormsFolder' | 'C___FundsLiteratureFolder' | 'C___FundsShareclassesDetailsWildcard' | 'C___GridMapping' | 'C___HelpArticle' | 'C___HelpArticleSearchPage' | 'C___HelpArticleWildcard' | 'C___HorizonDatasourceGrouping' | 'C___Icon' | 'C___IncludeByDefault' | 'C___IncludeIfInstalled' | 'C___InternalArticle' | 'C___InternetExplorerCompatibilityMode' | 'C___IsSystemModule' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_bAtMrDx88rUB43hbWgykdpxX2U1q1LBRCJ4YGeZd4 = { __typename?: 'C___JSONVariantPaging' | 'C___JSONVariantsBase' | 'C___LimitedDisplay' | 'C___LinkAttributes' | 'C___LinkSettings' | 'C___LiteratureHubSearchPage' | 'C___ManualKeyInformation' | 'C___MemberOf' | 'C___MetadataPage' | 'C___Modules' | 'C___Name' | 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' | 'C___Name_299cdb154745448a807868d401248eaa' | 'C___Name_b88cf88159a54a19991e71038751cb60' | 'C___Navigable' | 'C___NavigablePage' | 'C___PageContent' | 'C___PageWorkflow' | 'C___PerSiteStandardValues' | 'C___Podcast' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_3TTCxtPd167YL33nF9XBmmHbkUnxZovqTZClaQHWlMw = { __typename?: 'C___PodcastPressRelease' | 'C___PremiumContentPage' | 'C___PressRelease' | 'C___PressReleaseContentType' | 'C___PressReleaseSearchPage' | 'C___PressReleaseWildcard' | 'C___ProtectedTheme' | 'C___PublishingGroupingTemplate' | 'C___RenderingRelatedParameters' | 'C___RenderingVariantsBase' | 'C___RenderingsList' | 'C___RobotsContent' | 'C___RoleDomain' | 'C___RoleName' | 'C___RoleType' | 'C___SalesforceCommonValidations' | 'C___SalesforceFieldId' | 'C___SalesforceFieldTitle' | 'C___SalesforceFieldValue' | 'C___Script' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_cjYnlIs8UAaiaQsoGXfmJs6J5mZumcliSqpOQJJTEs = { __typename?: 'C___SearchSignature' | 'C___Searchable' | 'C___SecurityItemPointer' | 'C___SharedArticles' | 'C___SharedContent' | 'C___SharedHelpArticles' | 'C___SharedPage' | 'C___SharedPressReleases' | 'C___SharedRoot' | 'C___SharedSettings' | 'C___SiteContent' | 'C___SiteFolder' | 'C___SiteMediaLibrary' | 'C___SiteSettings' | 'C___SiteTemplate' | 'C___SitecoreClientSiteManaging' | 'C___Sitemap' | 'C___SitemapMediaItems' | 'C___SlidersRangeSettings' | 'C___SolutionTemplateContent' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_06OIScbuurQrCIv2RnyRnUL8yzZFIOkwx4bqVVJ1U8 = { __typename?: 'C___SolutionTemplateDescription' | 'C___SolutionTemplateName' | 'C___SortOrder' | 'C___StackBreakpoint' | 'C___Statistics' | 'C___SupportedLanguages' | 'C___Taggable' | 'C___TeamMembersParentPage' | 'C___TeamMembersWildcard' | 'C___TechzoneArticle' | 'C___Template' | 'C___Title' | 'C___Type' | 'C___Validation' | 'C___VariantPaging' | 'C___VectorTile' | 'C___VectorTileLink' | 'C___Video' | 'C___VideoPressRelease' | 'C___Width' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_P8mpedaaoE314gdziPbBwa0OJmnSKCgK7OuMwTvh8 = { __typename?: 'C___WildcardPage' | 'CacheSetting' | 'Caching_26fce9bf0256458d8281a713a5bf5520' | 'CalendarEvent' | 'CallOutSection' | 'CallOutSectionDropdownOption' | 'CallOutSectionFolder' | 'CallOutSectionParametersTemplate' | 'CallToAction' | 'CallToActionFolder' | 'CapabilitiesFolder' | 'Capability' | 'CapabilityMap' | 'CapabilityMappings' | 'Carousel' | 'CarouselFolder' | 'CarouselSlide' | 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' | 'Checkbox' | 'ChecklistFilter' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_riDg0AYVm42AlYT43jww1Ay107z2R3VQxYQLo3qt4w = { __typename?: 'ChecklistFilterFolder' | 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' | 'ColumnSplitter' | 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' | 'CompatibilityMode' | 'ComponentConfiguration' | 'ComponentThemeConfiguration' | 'ComponentThemesConfiguration' | 'ComponentsConfigurations' | 'ConfigurationFolder' | 'Container' | 'ContainerOption' | 'ContainerOptionsFolder' | 'ContainerParametersTemplate' | 'Container_45130bdbbae34edcaea87b68b9d94c7f' | 'ContentBlock' | 'ContentBlockFolder' | 'ContentToken' | 'ContentTokenFolder' | 'ContentType' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_rOmfpST6oLo347EYJ7Raz1NFUvjdcKoBJzJr0H9BgZ0 = { __typename?: 'CorporateTheme' | 'CorporateThemesFolder' | 'Country' | 'CountryISOCode' | 'CountryISOCodesFolder' | 'CustomerReviewFolder' | 'CustomerReviewTile' | 'CustomerReviewTileParametersTemplate' | 'DataBridgeDocumentCategoryMap' | 'DataBridgeFund' | 'DataBridgeFundRangeName' | 'DataBridgeSettingsFolder' | 'DataBridgeShareClass' | 'DataFolder' | 'DatasourceConfiguration' | 'DatasourceConfigurations' | 'DatasourceWorkflowAction' | 'DateFacet' | 'DateFilter' | 'DateFilterFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_OotNkMr3fBFvpnup0QnIBAKz5eVEb0STNbTDByrUc = { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' | 'DefaultColumnLayout' | 'DefaultShareclassMapping' | 'DefaultShareclassMappings' | 'DescriptiveHighlight' | 'DescriptiveHighlightFolder' | 'DescriptiveHighlightItem' | 'DescriptiveHighlightParametersTemplate' | 'Device' | 'Device_7c27ec70f42e40428a0fabaa2f8eda18' | 'Devices' | 'DictionaryFolder' | 'DisqusParameters' | 'DistanceFacet' | 'Divider' | 'DocumentItem' | 'DocumentListings' | 'DocumentListingsFolder' | 'DocumentTypeFolder' | 'DominantLanguageMapping' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_OVU4NcIdr6UAPevtvSSCtiep2KkZxR5zGCVShCeVdM = { __typename?: 'Dropdown' | 'DropdownFilter' | 'DropdownFilterFolder' | 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' | 'EditEditingTheme' | 'EditFrame' | 'EditModePanel' | 'EditSiteItem' | 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' | 'EditSiteTheme' | 'EditTenantTemplate' | 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' | 'EditType' | 'EloquaFormFolder' | 'EloquaFundForm' | 'Enum' | 'Enums' | 'ErrorPage' | 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' | 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_PqG8IayP279sjtPG4vxuPRJW1hTc9wDd0Y6bxgfrj9M = { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' | 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' | 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' | 'EventCalendarParameters' | 'EventList' | 'EventListParameters' | 'EventTypes' | 'EventsFolder' | 'ExecuteScript' | 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' | 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' | 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' | 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' | 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' | 'ExtendSiteTheme' | 'ExternalLiterature' | 'FEaaSWrapperRenderingParameters' | 'FacebookCommentsParametersTemplate' | 'FacetSlider' | 'FacetSliderFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_jX8959OSsL1J6OXLEoQhYbwRZXji5sxbF5Emcsd7hk = { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' | 'FacetSummary' | 'FacetSummaryFolder' | 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' | 'FacetsGrouping' | 'FakeNavigationItem' | 'FeatureBanner' | 'FeatureBannerParametersTemplate' | 'FeaturedArticles' | 'FeaturedArticlesFolder' | 'FeaturedTheme' | 'FeaturedThemesFolder' | 'Feed' | 'FeedFolder' | 'FeedParameters' | 'FieldEditor' | 'FieldRenderer' | 'FileList' | 'FileListFolder' | 'FileListParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_nG2WofEr8CM8keV1x8PUfr4FiOA16RD19JEgZKAwYOw = { __typename?: 'File_04129321770849c1801baee196e1c0a8' | 'FilterCriteria' | 'FilterCriteriaFolder' | 'FilterTaxonomyOption' | 'FilterTaxonomyOptions' | 'FilteredArticlesParentPage' | 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' | 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' | 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' | 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' | 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' | 'FilteredArticlesWildcardPage' | 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' | 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' | 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' | 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' | 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' | 'Flip' | 'FlipFolder' | 'Flip_5ef078504c044b839dafefd752cfaba8' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_phPzDO2Ka14Ao7Iqi5urCuijJRssi4yX4Ebgh3FcnbI = { __typename?: 'Flipside' | 'FloatFacet' | 'Footer' | 'FooterFolder' | 'FooterLink' | 'FormRenderingParameters' | 'FundAssetClass' | 'FundAssetClassesFolder' | 'FundDetailsWildcardPage' | 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' | 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' | 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' | 'FundFormsFolder' | 'FundInFocus' | 'FundInFocusShareClass' | 'FundSearchPage' | 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' | 'FundSearchPage_5806f83c03bc443380678ff955f4310f' | 'FundSearchPage_7432205c04214a419ca064c4cb37501c' | 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_Cng12S8NWxtlSTgmXuOQLEDPix0BbRxa4F0cvSsv1c = { __typename?: 'FundSettings' | 'FundShareclassDetailsWildcardPage' | 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' | 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' | 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' | 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' | 'FundSubAssetClass' | 'FundSubAssetClassesFolder' | 'FundsExternalLiteratureFolder' | 'FundsFolder' | 'FundsInFocusFolder' | 'FundsInFocusParametersTemplate' | 'FundsLiteratureFolder' | 'FundsLiteratureMappingsFolder' | 'Gallery' | 'GalleryFolder' | 'GalleryImage' | 'GalleryParametersTemplate' | 'GalleryVideo' | 'GatedAccordionContainer' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_Q1eQ5zKp1DmJrdMkqNxGrBxP1DirJ86dHnlUL7O6I = { __typename?: 'GlobalLanguageSelector' | 'GlobalNavigationBar' | 'GoogleAnalytics' | 'GoogleTagManager' | 'GoogleTagManagerFolder' | 'GridSetup' | 'GridTheme' | 'HTMLCode' | 'HTMLCodeFolder' | 'HTMLInclude' | 'HTMLIncludesFolder' | 'HTMLSnippet' | 'HTMLSnippetFolder' | 'HTMLTag' | 'Header' | 'HeaderFolder' | 'Heading' | 'HeadlessSiteSetupRoot' | 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' | 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_UxmIFNNcD8BvR6JmFFbZx6akhkSuYq2XDQUlQUfc6gM = { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' | 'HeadlessSite_68ffa40c5aab45548f774742b163f318' | 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' | 'HeadlessSite_229484893ca144958b9937167dfb5064' | 'HeadlessSite_b28055626acc45a2913a9617398c9730' | 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' | 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' | 'HeadlessSolutionTemplateFolder' | 'HeadlessTenantSetupRoot' | 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' | 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' | 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' | 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' | 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' | 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' | 'HeadlessTenant_94824ac390d748499e5af0275d10811f' | 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' | 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' | 'HeadlessTrustSite' | 'HeadlessVariants' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_K03JPtJ3NPqclv8mEFeFiFxrLZNgqW5QncC2uGSA77Y = { __typename?: 'HeadlessVariantsGrouping' | 'HelpArticlePage' | 'HelpArticlePlatform' | 'HelpArticlePlatformMap' | 'HelpArticlePlatformMappings' | 'HelpArticlePlatformsFolder' | 'HelpArticleSearchPage' | 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' | 'HelpArticleTag' | 'HelpArticleTagsFolder' | 'HelpArticleWildcardPage' | 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' | 'HelpArticlesGroupFolder' | 'HelpTagMap' | 'HelpTagMappings' | 'HeroBanner' | 'Highlight' | 'HighlightBlock' | 'HighlightBlockFolder' | 'HighlightBlockParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_aenpgKLNXFjIwUuTFQwphJOVytmWnXoasHV2tDtjXA = { __typename?: 'HighlightFolder' | 'HighlightItem' | 'HighlightParametersTemplate' | 'Home' | 'HomePage' | 'HomePage_0d3963a8171d4080b5f808618578b631' | 'HomePage_6d95c7d946c74a70be07304cc73a2010' | 'HomePage_b407f259b4e34c7db9a06e8907a56b17' | 'HomePage_cde13c51062d426b95569e8202edc963' | 'HomePage_de9353283a3e41c495ba386aed0540c6' | 'IFrame' | 'IFrameFolder' | 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' | 'IFrameParametersTemplate' | 'IFrame_0da12d476de24dfeb4d0f513489bfea1' | 'IFrame_88a6f65f2b78491bb3770b06e48883e1' | 'Icon' | 'IconFolder' | 'Image' | 'ImageFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_DP25HpTqyGLzsqg5W0VRj6RIKtHhscJzZ1qawr8VJU = { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' | 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' | 'ImageParametersTemplate' | 'Image_83bc563c6320490092f8204bff81586a' | 'Image_15185b0e641844499f934ff03b7ee032' | 'Image_d885df8cb2d64007b34b2bbafb527304' | 'Infographics' | 'InfographicsFolder' | 'InputValidationStep' | 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' | 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' | 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' | 'IntegerFacet' | 'IntroCopy' | 'IntroCopyFolder' | 'InvestmentTrustAssetClassFolder' | 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' | 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' | 'InvestmentTrustRegion' | 'InvestmentTrustRegionFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_TFM8XAFL3R0W5BBj4PhNwCAwPErC6NwFNoclkK5Ozfg = { __typename?: 'InvestmentTrustStyle' | 'InvestmentTrustStyleFolder' | 'InvestorType' | 'InvestorTypesFolder' | 'ItemQueriesFolder' | 'ItemRights' | 'JSBeaconSettings' | 'JSONCheckbox' | 'JSONContent' | 'JSONDate' | 'JSONFile' | 'JSONImage' | 'JSONLayout' | 'JSONList' | 'JSONMultilistReference' | 'JSONPlaceholder' | 'JSONQuery' | 'JSONResults' | 'JSONRichText' | 'JSONScriban' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_bMHrVLsz7zTHT5CwjCPyMlvDh8syp5BNhgLmOFWY = { __typename?: 'JSONSection' | 'JSONTemplate' | 'JSONText' | 'JSONToken' | 'JSONVariantDefinition' | 'JSONVariants' | 'JSSLayout' | 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' | 'JSSSettings_6b328292f8314ab79885d89a054ca10a' | 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' | 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' | 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' | 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' | 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' | 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' | 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' | 'JSSSiteGrouping' | 'JSSTenantFolder' | 'JavaScriptRendering' | 'JsonRendering' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_uHyHdgbeup55x4fJn0iMgtziabR3eN1yEsBEkbjb5Q = { __typename?: 'JurisdictionStatus' | 'JurisdictionsFolder' | 'KeyHighlightItem' | 'KeyHighlights' | 'KeyHighlightsFolder' | 'KeyHighlightsParametersTemplate' | 'Language' | 'LanguageSelector' | 'LanguagesFolder' | 'LatestPressReleasesParametersTemplate' | 'LayoutServiceVariants' | 'LimitedDisplayFolder' | 'LimitedDisplayOption' | 'Link' | 'LinkList' | 'LinkListFolder' | 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' | 'LinkList_33c9207e3b0446068ef54ca99a97c776' | 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' | 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_T3o1wLwUnreOMfGErcoS5389oEEJtqeZlHP8vd3gA = { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' | 'Link_930f134d56784b35bfd1b77f9d0115f1' | 'Link_e24e0789a05848bfabb6c69c0e60b6b7' | 'LinksFolder' | 'List' | 'ListFacet' | 'ListFolder' | 'ListItem' | 'ListParametersTemplate' | 'ListStyle' | 'ListStyleItem' | 'ListingHeroBanner' | 'ListingHeroParametersTemplate' | 'LiteratureAuthorization' | 'LiteratureAuthorizationsFolder' | 'LiteratureHubSearchPage' | 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' | 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' | 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' | 'LoadMore' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_BiFBNsNFG239ill5wF74Fp0WARoTWU8lZUEROfPJZvM = { __typename?: 'LoadMoreFolder' | 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' | 'LocationFilter' | 'LocationFilterFolder' | 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' | 'Log' | 'Login' | 'Login_abed54dc4f7840ddac562289c9c849d8' | 'LogoTextBlockItem' | 'LogoTextBlocks' | 'LogoTextBlocksFolder' | 'Logout' | 'Logout_c2294d8235a6452a94b15eb5e543b602' | 'ManagedRangeFilter' | 'ManagedRangeFilterFolder' | 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' | 'ManagedRangeItem' | 'Map' | 'MapParameters' | 'MapsFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_G1e6Uvc81Pa7r6RKtchIZa50YYxIpwUNf0ONxBs4Bl0 = { __typename?: 'MapsProvider' | 'MediaBlock' | 'MediaBlockFolder' | 'MediaBlockParametersTemplate' | 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' | 'MediaLinkParameters' | 'MediaVirtualFolder' | 'MegaNavigation' | 'MegaNavigationFolder' | 'MetaBranding' | 'MetaRenderingParameters' | 'MetadataPartialDesign' | 'Model' | 'ModelIterator' | 'MyLocationPOI' | 'Navigation' | 'NavigationCategory' | 'NavigationFilter' | 'NavigationFilterFolder' | 'NavigationLink' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_WDgsk5S4YhtQoVJsDxcSUkTfZcwxXcb1NO0cFSqYNGs = { __typename?: 'NavigationSubcategory' | 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' | 'OneTrustSettings' | 'OptimiserConfiguration' | 'OptimiserConfigurationSection' | 'OptimizedFile' | 'OracleCDPSettings' | 'OverlayContent' | 'OverlayFolderTemplate' | 'Ownership' | 'OwnershipFolder' | 'POI' | 'POIFolder' | 'POIType' | 'POIs' | 'PageBranchesFolder' | 'PageContent' | 'PageContentFolder' | 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' | 'PageDesign' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_IWJynIRPteI7yBdYHGdbMI4cyxoxfNlbtSN7B20y4M = { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' | 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' | 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' | 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' | 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' | 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' | 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' | 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' | 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' | 'PageDesign_1105b8f81e00426bbf1fc840742d827b' | 'PageDesigns' | 'PageDesigns_3af52e70e982424b9c85e355542500c9' | 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' | 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' | 'PageDesigns_99a71bba507746729c3fb29b04abee23' | 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' | 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' | 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' | 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' | 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_D3YGmHHw8WNoPLjhaKccTYlBxHImWKx0FJmY7FY = { __typename?: 'PageLevelTabs' | 'PageLevelTabsFolder' | 'PageList' | 'PageSelector' | 'PageSelectorConfiguration' | 'PageSelectorFolder' | 'PageSelector_59a7bb775f8c435ab810291abde80e63' | 'PageSize' | 'PageSizeFolder' | 'PageSize_b682562e0af64b3e9e3b45273bbe152d' | 'PageTheme' | 'PageThemesFolder' | 'Page_4f49a81db3664f198b89cab92f377d7a' | 'Page_5e66d86353544fe6a27d3b894984d50f' | 'Page_84f342ad2d0646b9aa9a818201145ca2' | 'Page_718df200be51463d93edf4d77ab7a49e' | 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' | 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' | 'Page_dae7821153e14dbabb0ddf0b53a90aaf' | 'Page_fa608b3e6aeb426388a059d89caabada' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_5d6qs4EGU5QLch38FcFTz9usooPsSE3WceHdwYputc = { __typename?: 'Pagging' | 'Pagination' | 'PaginationFolder' | 'Paragraph' | 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' | 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' | 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' | 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' | 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' | 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' | 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' | 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' | 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' | 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' | 'PartialDesigns' | 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' | 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' | 'PartialDesigns_36c869ded22040929ce829f6ed643c66' | 'PartialDesigns_1943dc73710a430895515a342c84b037' | 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_B9w2udyDmdxORyQ5clNDVxDKQqarcHNAPO2AP3es = { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' | 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' | 'PartialDesigns_d216303f58d8425688da8cd30d00afab' | 'PartialDesigns_facda26791204fa9a0363344348f2c42' | 'PerformanceChartSettings' | 'PerformanceChartTimePeriod' | 'PerformanceChartTimePeriodFolder' | 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' | 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' | 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' | 'Placeholder_1ca0304be5b64810821154426f1752c2' | 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' | 'PlainHtmlParametersTemplate' | 'Playlist' | 'PlaylistFolder' | 'PlaylistParametersTemplate' | 'Podcast' | 'PodcastFolder' | 'PodcastPage' | 'PodcastPressReleasePage' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_AdqeB4aKdR2MyUECPtovrc95H3CJ6Ig98U7CdiLGaIM = { __typename?: 'PoiTypes' | 'PostDeleteStep' | 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' | 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' | 'PostDeleteStep_b20857895385413883f096f3767cb156' | 'PostSetupStep' | 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' | 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' | 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' | 'PreDeleteStep' | 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' | 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' | 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' | 'PreDeleteValidationStep' | 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' | 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' | 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' | 'Presentation' | 'Presentation_0a70fa7389234a6eabf34134f25f3221' | 'PressReleaseContentType' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_drzV1CJMhZ88IeARb30GphbrzYOHnyNZjm3CgUbIWk = { __typename?: 'PressReleaseContentTypesFolder' | 'PressReleaseFilter' | 'PressReleasePage' | 'PressReleasePlatform' | 'PressReleasePlatformsFolder' | 'PressReleaseSearchPage' | 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' | 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' | 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' | 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' | 'PressReleaseWildcardPage' | 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' | 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' | 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' | 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' | 'PressReleasesGroupFolder' | 'PrivacyWarning' | 'ProjectFolder' | 'Promo' | 'PromoFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU = { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' | 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' | 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' | 'Promo_dfed4457d760457abec1c0dccdc44381' | 'PromotedContent' | 'PromotedContentFolder' | 'PropertyListingCard' | 'PropertyListingCards' | 'PropertyListingCategory' | 'PropertyListingFolder' | 'Query_98b413525a4b4067b92418a4b50f0a53' | 'QuickLinks' | 'QuickLinksFolder' | 'QuickLinksParametersTemplate' | 'QuotationBlockItem' | 'QuotationBlocks' | 'QuotationBlocksFolder' | 'QuotationBlocksParametersTemplate' | 'Quote' | 'QuoteFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 = { __typename?: 'QuoteParametersTemplate' | 'RadiusFilter' | 'RadiusFilterFolder' | 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' | 'RadiusScheme' | 'RadiusSchemeValue' | 'RangeSliderFilter' | 'RangeSliderFilterFolder' | 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' | 'RecentArticles' | 'Redirect' | 'RedirectMap' | 'RedirectMaps' | 'Region' | 'RegionLanguages' | 'RegionLanguagesFolder' | 'RelatedArticles' | 'RelatedArticlesParametersTemplate' | 'RenderEngineType' | 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg = { __typename?: 'RenderingHost' | 'ResizableIFramePage' | 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' | 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' | 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' | 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' | 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' | 'ResponsiveImage' | 'ResultsCount' | 'ResultsCountFolder' | 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' | 'ResultsVariantSelector' | 'RichText' | 'RichTextFolder' | 'RichText_0f3b73366112418c8bbab0526f3887ce' | 'RichText_efcfd8f6596745f48f85b5421928205d' | 'RiskImageMapping' | 'RiskImageMappings' | 'RiskLevelOption' | 'RiskLevelOptionFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc = { __typename?: 'RiskWarning' | 'RiskWarningFolder' | 'RiskWarningParametersTemplate' | 'RolePlaceholder' | 'RowSplitter' | 'RowSplitter_340c887da1d1415b9678c763af74ea97' | 'Rule' | 'SDRLogoMapping' | 'SDRLogoMappings' | 'SDRTypeOption' | 'SDRTypeOptionFolder' | 'SXAJSSLayout' | 'SXARole' | 'SXAStandardValuesFolder' | 'SalesforceAlertMessage' | 'SalesforceCheckBox' | 'SalesforceCheckBoxType' | 'SalesforceConditionalRadioButton' | 'SalesforceConditionalRadioButtons' | 'SalesforceDateInput' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM = { __typename?: 'SalesforceDropdown' | 'SalesforceDropdownOption' | 'SalesforceHiddenField' | 'SalesforceInput' | 'SalesforceInputType' | 'SalesforceIntegratedForm' | 'SalesforceIntegratedFormTypesFolder' | 'SalesforceRepeatableSubSection' | 'SalesforceRichTextArea' | 'SalesforceSection' | 'SalesforceSortCodeInput' | 'SalesforceSubmissionType' | 'Scope' | 'ScopesFolder' | 'Scriban' | 'Scripts' | 'SearchBox' | 'SearchBoxFolder' | 'SearchBox_1c04fd611d874590acfe9cc186865ab3' | 'SearchFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo = { __typename?: 'SearchResults' | 'SearchResultsFolder' | 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' | 'SecondaryHeroBannerParametersTemplate' | 'SectionHeading' | 'SectionHeadingFolder' | 'SectionHeadingParametersTemplate' | 'SectionHeadingType' | 'SectionHeadingTypeFolder' | 'SectionSelector' | 'SectionSelectorFolder' | 'SectionSelectorTab' | 'Security_33077d51ebad4d1cb4a83b79f51dba13' | 'Series' | 'SeriesFolder' | 'Settings' | 'SettingsFolder' | 'Settings_6c82caca67dc464195698faad083230e' | 'SharePriceSettings' | 'SharedArticlesFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs = { __typename?: 'SharedContentFolder' | 'SharedFolder' | 'SharedHelpArticlesFolder' | 'SharedPressReleasesFolder' | 'SharedSettingsFolder' | 'SharedSitesSettings' | 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' | 'Showcase' | 'ShowcaseFolder' | 'ShowcaseItem' | 'ShowcaseParametersTemplate' | 'Site' | 'SiteContentFolder' | 'SiteDefinition' | 'SiteEntryDisclaimer' | 'SiteFolder' | 'SiteGrouping' | 'SiteManagement' | 'SiteSecurityItemPointer' | 'SiteSelector' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo = { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' | 'SiteSetupRoot' | 'SiteTheme' | 'Site_e46f3af239fa4866a1577017c4b2a40c' | 'SitecoreFormWrapperParametersTemplate' | 'SitecoreRole' | 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' | 'SkipLink' | 'SkipLinkParameters' | 'SkipLinksFolder' | 'Snippet' | 'SnippetItem' | 'SnippetsFolder' | 'SocialLoginWrapper' | 'SocialMediaButtons' | 'SocialMediaFolder' | 'SocialMediaShare' | 'SocialMediaTemplate' | 'SocialNetwork' | 'SocialNetworkFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU = { __typename?: 'SocialNetworkLink' | 'SolutionTemplate' | 'SortResults' | 'SortResultsFolder' | 'Sorting' | 'SortingGroups' | 'SpotifyPodcast' | 'SpotifyPodcastFolder' | 'StickyCTA' | 'StickyCTAFolder' | 'StickyCTAParametersTemplate' | 'StrategiesInFocusFolder' | 'StrategyInFocus' | 'Style' | 'Styles' | 'Styles_9c0dac2808aa4b44bc2153363206f6a5' | 'SubscriptionBannerParametersTemplate' | 'Tab' | 'TabItem' | 'TableOfContents' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 = { __typename?: 'TableOfContentsFolder' | 'TableOfContentsSection' | 'TableOfContentsSubsection' | 'Tabs' | 'TabsFolder' | 'Tabs_f26a9560ccf148c59542800e837caf7a' | 'Tag' | 'TagCloud' | 'TagFolder' | 'TagList' | 'TeamBiographySettings' | 'TeamListingCards' | 'TeamListingCardsFolder' | 'TeamMember' | 'TeamMemberCard' | 'TeamMembers' | 'TeamMembersParentPage' | 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' | 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' | 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk = { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' | 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' | 'TeamMembersWildcardPage' | 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' | 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' | 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' | 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' | 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' | 'TeamProfileCards' | 'TeamProfileCardsFolder' | 'TechzoneArticlePage' | 'Tenant' | 'TenantFolder' | 'TenantSecurityItemPointer' | 'TenantSetupRoot' | 'TertieryHeroBanner' | 'TertieryHeroBannerParametersTemplate' | 'Text' | 'TextBlock' | 'TextBlockHeadingParametersTemplate' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 = { __typename?: 'TextBlockHeadingType' | 'TextBlockHeadingTypeFolder' | 'TextBlockLinkType' | 'TextBlockLinkTypeFolder' | 'TextBlocks' | 'TextBlocksFolder' | 'TextBlocksParametersTemplate' | 'TextFolder' | 'TextFolder_b762d56787f5493cbb480c455d834457' | 'Text_b8f5894cb4934016bf784090b0a2fd16' | 'Theme' | 'ThemeTag' | 'ThemeTagsFolder' | 'ThemingMode' | 'ThemingModes' | 'Tile' | 'TileLink' | 'TileParametersTemplate' | 'TileSizeOption' | 'TileSizeOptionFolder' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 = { __typename?: 'TilesFolder' | 'TilesParametersTemplate' | 'Title' | 'Title_a82e893105754175917de904ef7e6dbe' | 'Toggle' | 'ToggleFolder' | 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' | 'Transformation' | 'TrustArticleHeroParametersTemplate' | 'TrustFinder' | 'TrustFinderFilterOption' | 'TrustRegion' | 'TrustType' | 'TrustTypesFolder' | 'Twitter' | 'TwitterApp' | 'TwitterApps' | 'TwitterFolder' | 'TwitterParametersTemplate' | 'TwitterSettings' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w = { __typename?: 'UnknownItem' | 'UnminifiedFile' | 'UpgradeScript' | 'UpgradeScriptLibrary' | 'VariantComponentField' | 'VariantDateField' | 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' | 'VariantPlaceholder' | 'VariantReference' | 'VariantSection' | 'VariantTemplate' | 'VariantText' | 'VariantToken' | 'Variants' | 'VectorFolder' | 'VectorTile' | 'VectorTileLink' | 'VectorTilesFolder' | 'VectorTilesParametersTemplate' | 'Version_95ebc23204774dc38ad3465d5fe8da2f' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU = { __typename?: 'Video' | 'VideoCountOption' | 'VideoCountOptions' | 'VideoFolder' | 'VideoFolder_bba49474673e468186ba8b1a20e067a9' | 'VideoPage' | 'VideoParameters' | 'VideoParametersTemplate' | 'VideoPressReleasePage' | 'Video_4bc649610a894242be2dc5026090cf49' | '_AssetsOptimization' | '_BackgroundImage' | '_CompatibleThemes' | '_CompositeTheme' | '_CustomMetadata' | '_CustomRenderingViewPath' | '_DatasourceBehaviour' | '_Favicon' | '_FormsFolderLocation' | '_FundSettings' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 = { __typename?: '_HasValidUrlName' | '_LocalDataLink' | '_Login' | '_OpenGraphMetadata' | '_PageDesignTheme' | '_PageSearchScope' | '_SearchCriteria' | '_SearchableWithoutRelatedItems' | '_SeoMetadata' | '_SiteTheme' | '_SitemapSettings' | '_StickyNote' | '_Styleable' | '_TwitterMetadata' | '_Webinar' | '_WildcardSource' };

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_InvestmentTrustAssetClass = (
  { __typename?: 'InvestmentTrustAssetClass' }
  & { name: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_InvestmentTrustAssetClass_name_TextField> }
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem = TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_dxYboWowVqXyFEQIHTW4KbhL0lHEcueHzhBbeD0999E | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_UCMOSvPffh5Tlps5EZhWVbLbLYAlnbiakefGIxYg2c | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_xOJlvcBbMeSH2ZalUPaTM5ZeT2yOsFIN0h3Iv01is | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_TgBsOnUPPY6QvMRCjrAA0aJn3wFokEUMSDZlsVd9leA | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_1Fa5VAiUYUP8Bw87eryyMTnXaWA3g3Hakldosv8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_ulsOVUMq3wDI6F3tyWyLZ3nyaAUzdauAXpbf8QIk | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_xUQOkj0GMlc5wv60bmQQj73AHXxb38nIGTeN1leA | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_t5cfgcaU3rr0AvX2OG5htlgnm2iWMKRTcTxzGBh8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_4mXqXPHUZr4otYDSpYWX8Y4XMpULNT8i6kWuAJEVV8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_eeK09Y7wkhG5t6ox2MHbp12nGtLVIravFt2ix25Urx8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_QxspLemKohwcfn6MLuzq31LoWJcDWhvc6FyIrdg3Y | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_pLSvoSlIZBlpRr0oqseIDsMYsAtAKahN2CujcRmUG4 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_bAtMrDx88rUB43hbWgykdpxX2U1q1LBRCJ4YGeZd4 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_3TTCxtPd167YL33nF9XBmmHbkUnxZovqTZClaQHWlMw | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_cjYnlIs8UAaiaQsoGXfmJs6J5mZumcliSqpOQJJTEs | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_06OIScbuurQrCIv2RnyRnUL8yzZFIOkwx4bqVVJ1U8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_P8mpedaaoE314gdziPbBwa0OJmnSKCgK7OuMwTvh8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_riDg0AYVm42AlYT43jww1Ay107z2R3VQxYQLo3qt4w | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_rOmfpST6oLo347EYJ7Raz1NFUvjdcKoBJzJr0H9BgZ0 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_OotNkMr3fBFvpnup0QnIBAKz5eVEb0STNbTDByrUc | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_OVU4NcIdr6UAPevtvSSCtiep2KkZxR5zGCVShCeVdM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_PqG8IayP279sjtPG4vxuPRJW1hTc9wDd0Y6bxgfrj9M | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_jX8959OSsL1J6OXLEoQhYbwRZXji5sxbF5Emcsd7hk | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_nG2WofEr8CM8keV1x8PUfr4FiOA16RD19JEgZKAwYOw | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_phPzDO2Ka14Ao7Iqi5urCuijJRssi4yX4Ebgh3FcnbI | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_Cng12S8NWxtlSTgmXuOQLEDPix0BbRxa4F0cvSsv1c | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_Q1eQ5zKp1DmJrdMkqNxGrBxP1DirJ86dHnlUL7O6I | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_UxmIFNNcD8BvR6JmFFbZx6akhkSuYq2XDQUlQUfc6gM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_K03JPtJ3NPqclv8mEFeFiFxrLZNgqW5QncC2uGSA77Y | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_aenpgKLNXFjIwUuTFQwphJOVytmWnXoasHV2tDtjXA | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_DP25HpTqyGLzsqg5W0VRj6RIKtHhscJzZ1qawr8VJU | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_TFM8XAFL3R0W5BBj4PhNwCAwPErC6NwFNoclkK5Ozfg | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_bMHrVLsz7zTHT5CwjCPyMlvDh8syp5BNhgLmOFWY | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_uHyHdgbeup55x4fJn0iMgtziabR3eN1yEsBEkbjb5Q | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_T3o1wLwUnreOMfGErcoS5389oEEJtqeZlHP8vd3gA | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_BiFBNsNFG239ill5wF74Fp0WARoTWU8lZUEROfPJZvM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_G1e6Uvc81Pa7r6RKtchIZa50YYxIpwUNf0ONxBs4Bl0 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_WDgsk5S4YhtQoVJsDxcSUkTfZcwxXcb1NO0cFSqYNGs | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_IWJynIRPteI7yBdYHGdbMI4cyxoxfNlbtSN7B20y4M | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_D3YGmHHw8WNoPLjhaKccTYlBxHImWKx0FJmY7FY | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_5d6qs4EGU5QLch38FcFTz9usooPsSE3WceHdwYputc | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_B9w2udyDmdxORyQ5clNDVxDKQqarcHNAPO2AP3es | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_AdqeB4aKdR2MyUECPtovrc95H3CJ6Ig98U7CdiLGaIM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_drzV1CJMhZ88IeARb30GphbrzYOHnyNZjm3CgUbIWk | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem_InvestmentTrustAssetClass;

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField = (
  { __typename?: 'LookupField' }
  & Pick<Types.LookupField, 'targetId'>
  & { targetItem: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField_targetItem> }
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustId_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustName_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustDescription_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustImage_ImageField = (
  { __typename?: 'ImageField' }
  & Pick<Types.ImageField, 'src' | 'alt'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustIsHidden_CheckboxField = (
  { __typename?: 'CheckboxField' }
  & Pick<Types.CheckboxField, 'boolValue'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Accordion = (
  { __typename?: 'Accordion' }
  & Pick<Types.Accordion, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AccordionFolder = (
  { __typename?: 'AccordionFolder' }
  & Pick<Types.AccordionFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 = (
  { __typename?: 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' }
  & Pick<Types.AccordionFolder_03f88fb497884025b46f2cb249f4fcd6, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AccordionItem = (
  { __typename?: 'AccordionItem' }
  & Pick<Types.AccordionItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AccordionItem_8cf671721b2d489e809f4c23db5ab2da = (
  { __typename?: 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' }
  & Pick<Types.AccordionItem_8cf671721b2d489e809f4c23db5ab2da, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AccordionParametersTemplate = (
  { __typename?: 'AccordionParametersTemplate' }
  & Pick<Types.AccordionParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AccordionPresentation = (
  { __typename?: 'AccordionPresentation' }
  & Pick<Types.AccordionPresentation, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AccordionPresentationFolder = (
  { __typename?: 'AccordionPresentationFolder' }
  & Pick<Types.AccordionPresentationFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Accordion_02d060598cc14423a9ac9ff2365176b7 = (
  { __typename?: 'Accordion_02d060598cc14423a9ac9ff2365176b7' }
  & Pick<Types.Accordion_02d060598cc14423a9ac9ff2365176b7, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 = (
  { __typename?: 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' }
  & Pick<Types.Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AddItem = (
  { __typename?: 'AddItem' }
  & Pick<Types.AddItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AddItem_1e1b739ec3784909941d171aca7362e5 = (
  { __typename?: 'AddItem_1e1b739ec3784909941d171aca7362e5' }
  & Pick<Types.AddItem_1e1b739ec3784909941d171aca7362e5, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 = (
  { __typename?: 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' }
  & Pick<Types.AddItem_3aea335cd06d45b1841acbc8d2d1ce40, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AddItem_de8c75222f3241288f20342f479894eb = (
  { __typename?: 'AddItem_de8c75222f3241288f20342f479894eb' }
  & Pick<Types.AddItem_De8c75222f3241288f20342f479894eb, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AddItem_ea8a3f269ccd443a95f571b868a94bd0 = (
  { __typename?: 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' }
  & Pick<Types.AddItem_Ea8a3f269ccd443a95f571b868a94bd0, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AddThisParameters = (
  { __typename?: 'AddThisParameters' }
  & Pick<Types.AddThisParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AggregatedFacetFilter = (
  { __typename?: 'AggregatedFacetFilter' }
  & Pick<Types.AggregatedFacetFilter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AlertMessage = (
  { __typename?: 'AlertMessage' }
  & Pick<Types.AlertMessage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AlertMessageFolder = (
  { __typename?: 'AlertMessageFolder' }
  & Pick<Types.AlertMessageFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AlertMessageParametersTemplate = (
  { __typename?: 'AlertMessageParametersTemplate' }
  & Pick<Types.AlertMessageParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AlertMessageType = (
  { __typename?: 'AlertMessageType' }
  & Pick<Types.AlertMessageType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AllertMessageTypeFolder = (
  { __typename?: 'AllertMessageTypeFolder' }
  & Pick<Types.AllertMessageTypeFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Archive = (
  { __typename?: 'Archive' }
  & Pick<Types.Archive, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleAuthor = (
  { __typename?: 'ArticleAuthor' }
  & Pick<Types.ArticleAuthor, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleAuthorsFolder = (
  { __typename?: 'ArticleAuthorsFolder' }
  & Pick<Types.ArticleAuthorsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleCategoriesFolder = (
  { __typename?: 'ArticleCategoriesFolder' }
  & Pick<Types.ArticleCategoriesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleCategory = (
  { __typename?: 'ArticleCategory' }
  & Pick<Types.ArticleCategory, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleChapter = (
  { __typename?: 'ArticleChapter' }
  & Pick<Types.ArticleChapter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleChapters = (
  { __typename?: 'ArticleChapters' }
  & Pick<Types.ArticleChapters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleContentType = (
  { __typename?: 'ArticleContentType' }
  & Pick<Types.ArticleContentType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleContentTypesFolder = (
  { __typename?: 'ArticleContentTypesFolder' }
  & Pick<Types.ArticleContentTypesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleFilter = (
  { __typename?: 'ArticleFilter' }
  & Pick<Types.ArticleFilter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleFilterOption = (
  { __typename?: 'ArticleFilterOption' }
  & Pick<Types.ArticleFilterOption, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleFootnote = (
  { __typename?: 'ArticleFootnote' }
  & Pick<Types.ArticleFootnote, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleFootnoteLink = (
  { __typename?: 'ArticleFootnoteLink' }
  & Pick<Types.ArticleFootnoteLink, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleFootnoteText = (
  { __typename?: 'ArticleFootnoteText' }
  & Pick<Types.ArticleFootnoteText, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleInfogramTile = (
  { __typename?: 'ArticleInfogramTile' }
  & Pick<Types.ArticleInfogramTile, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleInfogramTileParametersTemplate = (
  { __typename?: 'ArticleInfogramTileParametersTemplate' }
  & Pick<Types.ArticleInfogramTileParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticlePage = (
  { __typename?: 'ArticlePage' }
  & Pick<Types.ArticlePage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleRegion = (
  { __typename?: 'ArticleRegion' }
  & Pick<Types.ArticleRegion, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleRegionsFolder = (
  { __typename?: 'ArticleRegionsFolder' }
  & Pick<Types.ArticleRegionsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleSearchPage = (
  { __typename?: 'ArticleSearchPage' }
  & Pick<Types.ArticleSearchPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c = (
  { __typename?: 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' }
  & Pick<Types.ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 = (
  { __typename?: 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' }
  & Pick<Types.ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_be414ff574ac4203abb2694811443e25 = (
  { __typename?: 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' }
  & Pick<Types.ArticleSearchPage_Be414ff574ac4203abb2694811443e25, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c = (
  { __typename?: 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' }
  & Pick<Types.ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 = (
  { __typename?: 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' }
  & Pick<Types.ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleSeriesCollection = (
  { __typename?: 'ArticleSeriesCollection' }
  & Pick<Types.ArticleSeriesCollection, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleSeriesFolder = (
  { __typename?: 'ArticleSeriesFolder' }
  & Pick<Types.ArticleSeriesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleSettings = (
  { __typename?: 'ArticleSettings' }
  & Pick<Types.ArticleSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBanner = (
  { __typename?: 'ArticleSubscriptionBanner' }
  & Pick<Types.ArticleSubscriptionBanner, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBannerFolder = (
  { __typename?: 'ArticleSubscriptionBannerFolder' }
  & Pick<Types.ArticleSubscriptionBannerFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleTag = (
  { __typename?: 'ArticleTag' }
  & Pick<Types.ArticleTag, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleTagsFolder = (
  { __typename?: 'ArticleTagsFolder' }
  & Pick<Types.ArticleTagsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleTeamAuthor = (
  { __typename?: 'ArticleTeamAuthor' }
  & Pick<Types.ArticleTeamAuthor, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleTileParametersTemplate = (
  { __typename?: 'ArticleTileParametersTemplate' }
  & Pick<Types.ArticleTileParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleTilesParametersTemplate = (
  { __typename?: 'ArticleTilesParametersTemplate' }
  & Pick<Types.ArticleTilesParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f = (
  { __typename?: 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' }
  & Pick<Types.ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 = (
  { __typename?: 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' }
  & Pick<Types.ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca = (
  { __typename?: 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' }
  & Pick<Types.ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c = (
  { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' }
  & Pick<Types.ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 = (
  { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' }
  & Pick<Types.ArticleWildcardPage_405b20252077400383d3b47f09f88b47, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b = (
  { __typename?: 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' }
  & Pick<Types.ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ArticlesGroupFolder = (
  { __typename?: 'ArticlesGroupFolder' }
  & Pick<Types.ArticlesGroupFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AttachThemeExtension = (
  { __typename?: 'AttachThemeExtension' }
  & Pick<Types.AttachThemeExtension, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListings = (
  { __typename?: 'AutomaticDocumentListings' }
  & Pick<Types.AutomaticDocumentListings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListingsFolder = (
  { __typename?: 'AutomaticDocumentListingsFolder' }
  & Pick<Types.AutomaticDocumentListingsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AvailableJSONRenderings = (
  { __typename?: 'AvailableJSONRenderings' }
  & Pick<Types.AvailableJsonRenderings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AvailableMetaRenderings = (
  { __typename?: 'AvailableMetaRenderings' }
  & Pick<Types.AvailableMetaRenderings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AvailableRenderings = (
  { __typename?: 'AvailableRenderings' }
  & Pick<Types.AvailableRenderings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb = (
  { __typename?: 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' }
  & Pick<Types.AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AwardsBanner = (
  { __typename?: 'AwardsBanner' }
  & Pick<Types.AwardsBanner, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AwardsBannerFolder = (
  { __typename?: 'AwardsBannerFolder' }
  & Pick<Types.AwardsBannerFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AwardsBannerImage = (
  { __typename?: 'AwardsBannerImage' }
  & Pick<Types.AwardsBannerImage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_AwardsBannerParametersTemplate = (
  { __typename?: 'AwardsBannerParametersTemplate' }
  & Pick<Types.AwardsBannerParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_BYOCWrapperRenderingParameters = (
  { __typename?: 'BYOCWrapperRenderingParameters' }
  & Pick<Types.ByocWrapperRenderingParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_BackgroundColorOption = (
  { __typename?: 'BackgroundColorOption' }
  & Pick<Types.BackgroundColorOption, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_BackgroundColorOptionFolder = (
  { __typename?: 'BackgroundColorOptionFolder' }
  & Pick<Types.BackgroundColorOptionFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_BannerFolder = (
  { __typename?: 'BannerFolder' }
  & Pick<Types.BannerFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_BannerType = (
  { __typename?: 'BannerType' }
  & Pick<Types.BannerType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_BannerTypeFolder = (
  { __typename?: 'BannerTypeFolder' }
  & Pick<Types.BannerTypeFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_BaseHeading = (
  { __typename?: 'BaseHeading' }
  & Pick<Types.BaseHeading, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_BaseHeadingFolder = (
  { __typename?: 'BaseHeadingFolder' }
  & Pick<Types.BaseHeadingFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_BoolFacet = (
  { __typename?: 'BoolFacet' }
  & Pick<Types.BoolFacet, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_BranchesFolder = (
  { __typename?: 'BranchesFolder' }
  & Pick<Types.BranchesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Breadcrumb = (
  { __typename?: 'Breadcrumb' }
  & Pick<Types.Breadcrumb, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_BrowserTitleDefinition = (
  { __typename?: 'BrowserTitleDefinition' }
  & Pick<Types.BrowserTitleDefinition, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CORSEntry = (
  { __typename?: 'CORSEntry' }
  & Pick<Types.CorsEntry, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CORSGrouping = (
  { __typename?: 'CORSGrouping' }
  & Pick<Types.CorsGrouping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CTAPresentationType = (
  { __typename?: 'CTAPresentationType' }
  & Pick<Types.CtaPresentationType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CTAPresentationTypeFolder = (
  { __typename?: 'CTAPresentationTypeFolder' }
  & Pick<Types.CtaPresentationTypeFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__AbrdnPage = (
  { __typename?: 'C__AbrdnPage' }
  & Pick<Types.C__AbrdnPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__ActionBase = (
  { __typename?: 'C__ActionBase' }
  & Pick<Types.C__ActionBase, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__AdvancedParameter = (
  { __typename?: 'C__AdvancedParameter' }
  & Pick<Types.C__AdvancedParameter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__App = (
  { __typename?: 'C__App' }
  & Pick<Types.C__App, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c = (
  { __typename?: 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' }
  & Pick<Types.C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__ArticleWildcardPage = (
  { __typename?: 'C__ArticleWildcardPage' }
  & Pick<Types.C__ArticleWildcardPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__AvailableRenderingsFolder = (
  { __typename?: 'C__AvailableRenderingsFolder' }
  & Pick<Types.C__AvailableRenderingsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__BYOCRenderingParameters = (
  { __typename?: 'C__BYOCRenderingParameters' }
  & Pick<Types.C__ByocRenderingParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__BackgroundParametersTemplate = (
  { __typename?: 'C__BackgroundParametersTemplate' }
  & Pick<Types.C__BackgroundParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__BaseCTA = (
  { __typename?: 'C__BaseCTA' }
  & Pick<Types.C__BaseCta, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__BasePage = (
  { __typename?: 'C__BasePage' }
  & Pick<Types.C__BasePage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__BasePage_037da552a5524fe4aeee331f57ac1378 = (
  { __typename?: 'C__BasePage_037da552a5524fe4aeee331f57ac1378' }
  & Pick<Types.C__BasePage_037da552a5524fe4aeee331f57ac1378, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f = (
  { __typename?: 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' }
  & Pick<Types.C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__BasePage_315fd21bebf04c9d9f00bae191442f1d = (
  { __typename?: 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' }
  & Pick<Types.C__BasePage_315fd21bebf04c9d9f00bae191442f1d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd = (
  { __typename?: 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' }
  & Pick<Types.C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__BasePage_728c97b5c56146d9807e21018a972bb5 = (
  { __typename?: 'C__BasePage_728c97b5c56146d9807e21018a972bb5' }
  & Pick<Types.C__BasePage_728c97b5c56146d9807e21018a972bb5, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__BasePage_6105875085f346729dfc8d133b481f26 = (
  { __typename?: 'C__BasePage_6105875085f346729dfc8d133b481f26' }
  & Pick<Types.C__BasePage_6105875085f346729dfc8d133b481f26, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b = (
  { __typename?: 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' }
  & Pick<Types.C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__BaseRenderingParameters = (
  { __typename?: 'C__BaseRenderingParameters' }
  & Pick<Types.C__BaseRenderingParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__BaseTheme = (
  { __typename?: 'C__BaseTheme' }
  & Pick<Types.C__BaseTheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__BaseVariantField = (
  { __typename?: 'C__BaseVariantField' }
  & Pick<Types.C__BaseVariantField, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__Class = (
  { __typename?: 'C__Class' }
  & Pick<Types.C__Class, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__CompositeGroup = (
  { __typename?: 'C__CompositeGroup' }
  & Pick<Types.C__CompositeGroup, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__CompositeSection = (
  { __typename?: 'C__CompositeSection' }
  & Pick<Types.C__CompositeSection, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__EloquaForm = (
  { __typename?: 'C__EloquaForm' }
  & Pick<Types.C__EloquaForm, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d = (
  { __typename?: 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' }
  & Pick<Types.C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions = (
  { __typename?: 'C__ExtendedOptions' }
  & Pick<Types.C__ExtendedOptions, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 = (
  { __typename?: 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' }
  & Pick<Types.C__ExtendedOptions_2964fb4257a6440fb192218443904c90, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 = (
  { __typename?: 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' }
  & Pick<Types.C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__FEaaSRenderingParameters = (
  { __typename?: 'C__FEaaSRenderingParameters' }
  & Pick<Types.C__FEaaSRenderingParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__FacetSelectorConfigBase = (
  { __typename?: 'C__FacetSelectorConfigBase' }
  & Pick<Types.C__FacetSelectorConfigBase, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 = (
  { __typename?: 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' }
  & Pick<Types.C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b = (
  { __typename?: 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' }
  & Pick<Types.C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 = (
  { __typename?: 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' }
  & Pick<Types.C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 = (
  { __typename?: 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' }
  & Pick<Types.C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc = (
  { __typename?: 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' }
  & Pick<Types.C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__GlobalDatasourceBehavior = (
  { __typename?: 'C__GlobalDatasourceBehavior' }
  & Pick<Types.C__GlobalDatasourceBehavior, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__GridDefinition = (
  { __typename?: 'C__GridDefinition' }
  & Pick<Types.C__GridDefinition, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__GridItemBase = (
  { __typename?: 'C__GridItemBase' }
  & Pick<Types.C__GridItemBase, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__GridParameters = (
  { __typename?: 'C__GridParameters' }
  & Pick<Types.C__GridParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__HeadlessSite = (
  { __typename?: 'C__HeadlessSite' }
  & Pick<Types.C__HeadlessSite, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__HeadlessTenant = (
  { __typename?: 'C__HeadlessTenant' }
  & Pick<Types.C__HeadlessTenant, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b = (
  { __typename?: 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' }
  & Pick<Types.C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d = (
  { __typename?: 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' }
  & Pick<Types.C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d = (
  { __typename?: 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' }
  & Pick<Types.C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IAllowEmpty = (
  { __typename?: 'C__IAllowEmpty' }
  & Pick<Types.C__IAllowEmpty, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IBaseVariantDefinition = (
  { __typename?: 'C__IBaseVariantDefinition' }
  & Pick<Types.C__IBaseVariantDefinition, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IBoosting = (
  { __typename?: 'C__IBoosting' }
  & Pick<Types.C__IBoosting, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__ICacheable = (
  { __typename?: 'C__ICacheable' }
  & Pick<Types.C__ICacheable, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__ICompatibleRenderings = (
  { __typename?: 'C__ICompatibleRenderings' }
  & Pick<Types.C__ICompatibleRenderings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IComponentVariant = (
  { __typename?: 'C__IComponentVariant' }
  & Pick<Types.C__IComponentVariant, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IControlType = (
  { __typename?: 'C__IControlType' }
  & Pick<Types.C__IControlType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IDynamicPlaceholder = (
  { __typename?: 'C__IDynamicPlaceholder' }
  & Pick<Types.C__IDynamicPlaceholder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsDataSourceTemplates = (
  { __typename?: 'C__IFEaaSComponentsDataSourceTemplates' }
  & Pick<Types.C__IfEaaSComponentsDataSourceTemplates, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsEditorScriptURL = (
  { __typename?: 'C__IFEaaSComponentsEditorScriptURL' }
  & Pick<Types.C__IfEaaSComponentsEditorScriptUrl, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IIcon = (
  { __typename?: 'C__IIcon' }
  & Pick<Types.C__IIcon, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__ILocation = (
  { __typename?: 'C__ILocation' }
  & Pick<Types.C__ILocation, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IPaginable = (
  { __typename?: 'C__IPaginable' }
  & Pick<Types.C__IPaginable, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IPagination = (
  { __typename?: 'C__IPagination' }
  & Pick<Types.C__IPagination, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IPoi = (
  { __typename?: 'C__IPoi' }
  & Pick<Types.C__IPoi, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IRenderingId = (
  { __typename?: 'C__IRenderingId' }
  & Pick<Types.C__IRenderingId, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__ISplitter = (
  { __typename?: 'C__ISplitter' }
  & Pick<Types.C__ISplitter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IStyling = (
  { __typename?: 'C__IStyling' }
  & Pick<Types.C__IStyling, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__IVariantDefinition = (
  { __typename?: 'C__IVariantDefinition' }
  & Pick<Types.C__IVariantDefinition, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage = (
  { __typename?: 'C__InvestmentTrustPage' }
  & Pick<Types.C__InvestmentTrustPage, 'id'>
  & { trustRegion: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField>, trustLink: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustLink_LinkField>, trustStyle: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField>, trustAssetClass: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField>, trustId: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustId_TextField>, trustName: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustName_TextField>, trustDescription: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustDescription_TextField>, trustImage: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustImage_ImageField>, trustIsHidden: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustIsHidden_CheckboxField> }
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__JSONField = (
  { __typename?: 'C__JSONField' }
  & Pick<Types.C__JsonField, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__JSONReference = (
  { __typename?: 'C__JSONReference' }
  & Pick<Types.C__JsonReference, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__JSSData = (
  { __typename?: 'C__JSSData' }
  & Pick<Types.C__JssData, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__JSSSettings = (
  { __typename?: 'C__JSSSettings' }
  & Pick<Types.C__JssSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__JSSSiteFolder = (
  { __typename?: 'C__JSSSiteFolder' }
  & Pick<Types.C__JssSiteFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__JssRootFolder = (
  { __typename?: 'C__JssRootFolder' }
  & Pick<Types.C__JssRootFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 = (
  { __typename?: 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' }
  & Pick<Types.C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__Navigation_e6d98f24d01c419e871a4617125a49ed = (
  { __typename?: 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' }
  & Pick<Types.C__Navigation_E6d98f24d01c419e871a4617125a49ed, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__Page = (
  { __typename?: 'C__Page' }
  & Pick<Types.C__Page, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__PageData = (
  { __typename?: 'C__PageData' }
  & Pick<Types.C__PageData, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder = (
  { __typename?: 'C__PageDesignFolder' }
  & Pick<Types.C__PageDesignFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd = (
  { __typename?: 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' }
  & Pick<Types.C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 = (
  { __typename?: 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' }
  & Pick<Types.C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__PartialDesign = (
  { __typename?: 'C__PartialDesign' }
  & Pick<Types.C__PartialDesign, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder = (
  { __typename?: 'C__PartialDesignFolder' }
  & Pick<Types.C__PartialDesignFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d = (
  { __typename?: 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' }
  & Pick<Types.C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d = (
  { __typename?: 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' }
  & Pick<Types.C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__PlaceholderWrapper = (
  { __typename?: 'C__PlaceholderWrapper' }
  & Pick<Types.C__PlaceholderWrapper, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac = (
  { __typename?: 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' }
  & Pick<Types.C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b = (
  { __typename?: 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' }
  & Pick<Types.C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__RedirectMapGrouping = (
  { __typename?: 'C__RedirectMapGrouping' }
  & Pick<Types.C__RedirectMapGrouping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 = (
  { __typename?: 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' }
  & Pick<Types.C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__Route = (
  { __typename?: 'C__Route' }
  & Pick<Types.C__Route, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__SimpleVideo = (
  { __typename?: 'C__SimpleVideo' }
  & Pick<Types.C__SimpleVideo, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__SiteSettingsFolder = (
  { __typename?: 'C__SiteSettingsFolder' }
  & Pick<Types.C__SiteSettingsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__SitemapSettings = (
  { __typename?: 'C__SitemapSettings' }
  & Pick<Types.C__SitemapSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__StandardTemplate = (
  { __typename?: 'C__StandardTemplate' }
  & Pick<Types.C__StandardTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c = (
  { __typename?: 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' }
  & Pick<Types.C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 = (
  { __typename?: 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' }
  & Pick<Types.C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__TrustFolder = (
  { __typename?: 'C__TrustFolder' }
  & Pick<Types.C__TrustFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__VariantDefinition = (
  { __typename?: 'C__VariantDefinition' }
  & Pick<Types.C__VariantDefinition, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__VariantField = (
  { __typename?: 'C__VariantField' }
  & Pick<Types.C__VariantField, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C__VariantsGrouping = (
  { __typename?: 'C__VariantsGrouping' }
  & Pick<Types.C__VariantsGrouping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___AdvancedItem = (
  { __typename?: 'C___AdvancedItem' }
  & Pick<Types.C___AdvancedItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Arguments = (
  { __typename?: 'C___Arguments' }
  & Pick<Types.C___Arguments, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 = (
  { __typename?: 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' }
  & Pick<Types.C___Arguments_33fab87cd52f44319a1f589ba7c1e287, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Article = (
  { __typename?: 'C___Article' }
  & Pick<Types.C___Article, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___ArticlePageWorkflow = (
  { __typename?: 'C___ArticlePageWorkflow' }
  & Pick<Types.C___ArticlePageWorkflow, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___ArticleSearchPage = (
  { __typename?: 'C___ArticleSearchPage' }
  & Pick<Types.C___ArticleSearchPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___ArticleWildcard = (
  { __typename?: 'C___ArticleWildcard' }
  & Pick<Types.C___ArticleWildcard, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___AssetServiceThemeMode = (
  { __typename?: 'C___AssetServiceThemeMode' }
  & Pick<Types.C___AssetServiceThemeMode, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseArticle = (
  { __typename?: 'C___BaseArticle' }
  & Pick<Types.C___BaseArticle, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseDataFolder = (
  { __typename?: 'C___BaseDataFolder' }
  & Pick<Types.C___BaseDataFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseHelpArticle = (
  { __typename?: 'C___BaseHelpArticle' }
  & Pick<Types.C___BaseHelpArticle, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseInvestmentTrust = (
  { __typename?: 'C___BaseInvestmentTrust' }
  & Pick<Types.C___BaseInvestmentTrust, 'id'>
  & { trustRegion: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField>, trustLink: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustLink_LinkField>, trustStyle: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField>, trustAssetClass: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField>, trustId: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustId_TextField>, trustName: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustName_TextField>, trustDescription: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustDescription_TextField>, trustImage: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustImage_ImageField>, trustIsHidden: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustIsHidden_CheckboxField> }
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseJSSTenant = (
  { __typename?: 'C___BaseJSSTenant' }
  & Pick<Types.C___BaseJssTenant, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BasePage = (
  { __typename?: 'C___BasePage' }
  & Pick<Types.C___BasePage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BasePageDesign = (
  { __typename?: 'C___BasePageDesign' }
  & Pick<Types.C___BasePageDesign, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BasePageDesignFolder = (
  { __typename?: 'C___BasePageDesignFolder' }
  & Pick<Types.C___BasePageDesignFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BasePartialDesign = (
  { __typename?: 'C___BasePartialDesign' }
  & Pick<Types.C___BasePartialDesign, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BasePartialDesignFolder = (
  { __typename?: 'C___BasePartialDesignFolder' }
  & Pick<Types.C___BasePartialDesignFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BasePlaceholder = (
  { __typename?: 'C___BasePlaceholder' }
  & Pick<Types.C___BasePlaceholder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BasePlaceholderSettingsFolder = (
  { __typename?: 'C___BasePlaceholderSettingsFolder' }
  & Pick<Types.C___BasePlaceholderSettingsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BasePresentation = (
  { __typename?: 'C___BasePresentation' }
  & Pick<Types.C___BasePresentation, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BasePressRelease = (
  { __typename?: 'C___BasePressRelease' }
  & Pick<Types.C___BasePressRelease, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseRenderingParameters = (
  { __typename?: 'C___BaseRenderingParameters' }
  & Pick<Types.C___BaseRenderingParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseSXAStandardValuesFolder = (
  { __typename?: 'C___BaseSXAStandardValuesFolder' }
  & Pick<Types.C___BaseSxaStandardValuesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseSettings = (
  { __typename?: 'C___BaseSettings' }
  & Pick<Types.C___BaseSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseSharedSitesSettings = (
  { __typename?: 'C___BaseSharedSitesSettings' }
  & Pick<Types.C___BaseSharedSitesSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseSiteDefinition = (
  { __typename?: 'C___BaseSiteDefinition' }
  & Pick<Types.C___BaseSiteDefinition, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseSiteFolder = (
  { __typename?: 'C___BaseSiteFolder' }
  & Pick<Types.C___BaseSiteFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseSiteGrouping = (
  { __typename?: 'C___BaseSiteGrouping' }
  & Pick<Types.C___BaseSiteGrouping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseSiteRoot = (
  { __typename?: 'C___BaseSiteRoot' }
  & Pick<Types.C___BaseSiteRoot, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseTenant = (
  { __typename?: 'C___BaseTenant' }
  & Pick<Types.C___BaseTenant, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BaseTenantFolder = (
  { __typename?: 'C___BaseTenantFolder' }
  & Pick<Types.C___BaseTenantFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___BucketRules = (
  { __typename?: 'C___BucketRules' }
  & Pick<Types.C___BucketRules, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___CORS = (
  { __typename?: 'C___CORS' }
  & Pick<Types.C___Cors, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Content = (
  { __typename?: 'C___Content' }
  & Pick<Types.C___Content, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___ContentType = (
  { __typename?: 'C___ContentType' }
  & Pick<Types.C___ContentType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___DataAttributes = (
  { __typename?: 'C___DataAttributes' }
  & Pick<Types.C___DataAttributes, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___DatasourceWorkflow = (
  { __typename?: 'C___DatasourceWorkflow' }
  & Pick<Types.C___DatasourceWorkflow, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Dependencies = (
  { __typename?: 'C___Dependencies' }
  & Pick<Types.C___Dependencies, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Description = (
  { __typename?: 'C___Description' }
  & Pick<Types.C___Description, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___DesignTemplateMapping = (
  { __typename?: 'C___DesignTemplateMapping' }
  & Pick<Types.C___DesignTemplateMapping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Designable = (
  { __typename?: 'C___Designable' }
  & Pick<Types.C___Designable, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___EditType = (
  { __typename?: 'C___EditType' }
  & Pick<Types.C___EditType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___EditType_8a9f84baaa124c5d9096935714809da4 = (
  { __typename?: 'C___EditType_8a9f84baaa124c5d9096935714809da4' }
  & Pick<Types.C___EditType_8a9f84baaa124c5d9096935714809da4, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___EditingTheme = (
  { __typename?: 'C___EditingTheme' }
  & Pick<Types.C___EditingTheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Enabled = (
  { __typename?: 'C___Enabled' }
  & Pick<Types.C___Enabled, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___ErrorHandling = (
  { __typename?: 'C___ErrorHandling' }
  & Pick<Types.C___ErrorHandling, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___ExternalArticle = (
  { __typename?: 'C___ExternalArticle' }
  & Pick<Types.C___ExternalArticle, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Fields = (
  { __typename?: 'C___Fields' }
  & Pick<Types.C___Fields, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesParent = (
  { __typename?: 'C___FilteredArticlesParent' }
  & Pick<Types.C___FilteredArticlesParent, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesWildcard = (
  { __typename?: 'C___FilteredArticlesWildcard' }
  & Pick<Types.C___FilteredArticlesWildcard, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Footnotes = (
  { __typename?: 'C___Footnotes' }
  & Pick<Types.C___Footnotes, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___FundDetailsWildcard = (
  { __typename?: 'C___FundDetailsWildcard' }
  & Pick<Types.C___FundDetailsWildcard, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___FundFormAvailability = (
  { __typename?: 'C___FundFormAvailability' }
  & Pick<Types.C___FundFormAvailability, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___FundMetadataPage = (
  { __typename?: 'C___FundMetadataPage' }
  & Pick<Types.C___FundMetadataPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___FundSearchPage = (
  { __typename?: 'C___FundSearchPage' }
  & Pick<Types.C___FundSearchPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___FundsFolder = (
  { __typename?: 'C___FundsFolder' }
  & Pick<Types.C___FundsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___FundsFormsFolder = (
  { __typename?: 'C___FundsFormsFolder' }
  & Pick<Types.C___FundsFormsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___FundsLiteratureFolder = (
  { __typename?: 'C___FundsLiteratureFolder' }
  & Pick<Types.C___FundsLiteratureFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___FundsShareclassesDetailsWildcard = (
  { __typename?: 'C___FundsShareclassesDetailsWildcard' }
  & Pick<Types.C___FundsShareclassesDetailsWildcard, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___GridMapping = (
  { __typename?: 'C___GridMapping' }
  & Pick<Types.C___GridMapping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___HelpArticle = (
  { __typename?: 'C___HelpArticle' }
  & Pick<Types.C___HelpArticle, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___HelpArticleSearchPage = (
  { __typename?: 'C___HelpArticleSearchPage' }
  & Pick<Types.C___HelpArticleSearchPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___HelpArticleWildcard = (
  { __typename?: 'C___HelpArticleWildcard' }
  & Pick<Types.C___HelpArticleWildcard, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___HorizonDatasourceGrouping = (
  { __typename?: 'C___HorizonDatasourceGrouping' }
  & Pick<Types.C___HorizonDatasourceGrouping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Icon = (
  { __typename?: 'C___Icon' }
  & Pick<Types.C___Icon, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___IncludeByDefault = (
  { __typename?: 'C___IncludeByDefault' }
  & Pick<Types.C___IncludeByDefault, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___IncludeIfInstalled = (
  { __typename?: 'C___IncludeIfInstalled' }
  & Pick<Types.C___IncludeIfInstalled, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___InternalArticle = (
  { __typename?: 'C___InternalArticle' }
  & Pick<Types.C___InternalArticle, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___InternetExplorerCompatibilityMode = (
  { __typename?: 'C___InternetExplorerCompatibilityMode' }
  & Pick<Types.C___InternetExplorerCompatibilityMode, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___IsSystemModule = (
  { __typename?: 'C___IsSystemModule' }
  & Pick<Types.C___IsSystemModule, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___JSONVariantPaging = (
  { __typename?: 'C___JSONVariantPaging' }
  & Pick<Types.C___JsonVariantPaging, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___JSONVariantsBase = (
  { __typename?: 'C___JSONVariantsBase' }
  & Pick<Types.C___JsonVariantsBase, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___LimitedDisplay = (
  { __typename?: 'C___LimitedDisplay' }
  & Pick<Types.C___LimitedDisplay, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___LinkAttributes = (
  { __typename?: 'C___LinkAttributes' }
  & Pick<Types.C___LinkAttributes, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___LinkSettings = (
  { __typename?: 'C___LinkSettings' }
  & Pick<Types.C___LinkSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___LiteratureHubSearchPage = (
  { __typename?: 'C___LiteratureHubSearchPage' }
  & Pick<Types.C___LiteratureHubSearchPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___ManualKeyInformation = (
  { __typename?: 'C___ManualKeyInformation' }
  & Pick<Types.C___ManualKeyInformation, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___MemberOf = (
  { __typename?: 'C___MemberOf' }
  & Pick<Types.C___MemberOf, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___MetadataPage = (
  { __typename?: 'C___MetadataPage' }
  & Pick<Types.C___MetadataPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Modules = (
  { __typename?: 'C___Modules' }
  & Pick<Types.C___Modules, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Name = (
  { __typename?: 'C___Name' }
  & Pick<Types.C___Name, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d = (
  { __typename?: 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' }
  & Pick<Types.C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Name_299cdb154745448a807868d401248eaa = (
  { __typename?: 'C___Name_299cdb154745448a807868d401248eaa' }
  & Pick<Types.C___Name_299cdb154745448a807868d401248eaa, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Name_b88cf88159a54a19991e71038751cb60 = (
  { __typename?: 'C___Name_b88cf88159a54a19991e71038751cb60' }
  & Pick<Types.C___Name_B88cf88159a54a19991e71038751cb60, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Navigable = (
  { __typename?: 'C___Navigable' }
  & Pick<Types.C___Navigable, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___NavigablePage = (
  { __typename?: 'C___NavigablePage' }
  & Pick<Types.C___NavigablePage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___PageContent = (
  { __typename?: 'C___PageContent' }
  & Pick<Types.C___PageContent, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___PageWorkflow = (
  { __typename?: 'C___PageWorkflow' }
  & Pick<Types.C___PageWorkflow, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___PerSiteStandardValues = (
  { __typename?: 'C___PerSiteStandardValues' }
  & Pick<Types.C___PerSiteStandardValues, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Podcast = (
  { __typename?: 'C___Podcast' }
  & Pick<Types.C___Podcast, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___PodcastPressRelease = (
  { __typename?: 'C___PodcastPressRelease' }
  & Pick<Types.C___PodcastPressRelease, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___PremiumContentPage = (
  { __typename?: 'C___PremiumContentPage' }
  & Pick<Types.C___PremiumContentPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___PressRelease = (
  { __typename?: 'C___PressRelease' }
  & Pick<Types.C___PressRelease, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___PressReleaseContentType = (
  { __typename?: 'C___PressReleaseContentType' }
  & Pick<Types.C___PressReleaseContentType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___PressReleaseSearchPage = (
  { __typename?: 'C___PressReleaseSearchPage' }
  & Pick<Types.C___PressReleaseSearchPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___PressReleaseWildcard = (
  { __typename?: 'C___PressReleaseWildcard' }
  & Pick<Types.C___PressReleaseWildcard, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___ProtectedTheme = (
  { __typename?: 'C___ProtectedTheme' }
  & Pick<Types.C___ProtectedTheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___PublishingGroupingTemplate = (
  { __typename?: 'C___PublishingGroupingTemplate' }
  & Pick<Types.C___PublishingGroupingTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___RenderingRelatedParameters = (
  { __typename?: 'C___RenderingRelatedParameters' }
  & Pick<Types.C___RenderingRelatedParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___RenderingVariantsBase = (
  { __typename?: 'C___RenderingVariantsBase' }
  & Pick<Types.C___RenderingVariantsBase, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___RenderingsList = (
  { __typename?: 'C___RenderingsList' }
  & Pick<Types.C___RenderingsList, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___RobotsContent = (
  { __typename?: 'C___RobotsContent' }
  & Pick<Types.C___RobotsContent, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___RoleDomain = (
  { __typename?: 'C___RoleDomain' }
  & Pick<Types.C___RoleDomain, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___RoleName = (
  { __typename?: 'C___RoleName' }
  & Pick<Types.C___RoleName, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___RoleType = (
  { __typename?: 'C___RoleType' }
  & Pick<Types.C___RoleType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SalesforceCommonValidations = (
  { __typename?: 'C___SalesforceCommonValidations' }
  & Pick<Types.C___SalesforceCommonValidations, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldId = (
  { __typename?: 'C___SalesforceFieldId' }
  & Pick<Types.C___SalesforceFieldId, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldTitle = (
  { __typename?: 'C___SalesforceFieldTitle' }
  & Pick<Types.C___SalesforceFieldTitle, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldValue = (
  { __typename?: 'C___SalesforceFieldValue' }
  & Pick<Types.C___SalesforceFieldValue, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Script = (
  { __typename?: 'C___Script' }
  & Pick<Types.C___Script, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SearchSignature = (
  { __typename?: 'C___SearchSignature' }
  & Pick<Types.C___SearchSignature, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Searchable = (
  { __typename?: 'C___Searchable' }
  & Pick<Types.C___Searchable, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SecurityItemPointer = (
  { __typename?: 'C___SecurityItemPointer' }
  & Pick<Types.C___SecurityItemPointer, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SharedArticles = (
  { __typename?: 'C___SharedArticles' }
  & Pick<Types.C___SharedArticles, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SharedContent = (
  { __typename?: 'C___SharedContent' }
  & Pick<Types.C___SharedContent, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SharedHelpArticles = (
  { __typename?: 'C___SharedHelpArticles' }
  & Pick<Types.C___SharedHelpArticles, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SharedPage = (
  { __typename?: 'C___SharedPage' }
  & Pick<Types.C___SharedPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SharedPressReleases = (
  { __typename?: 'C___SharedPressReleases' }
  & Pick<Types.C___SharedPressReleases, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SharedRoot = (
  { __typename?: 'C___SharedRoot' }
  & Pick<Types.C___SharedRoot, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SharedSettings = (
  { __typename?: 'C___SharedSettings' }
  & Pick<Types.C___SharedSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SiteContent = (
  { __typename?: 'C___SiteContent' }
  & Pick<Types.C___SiteContent, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SiteFolder = (
  { __typename?: 'C___SiteFolder' }
  & Pick<Types.C___SiteFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SiteMediaLibrary = (
  { __typename?: 'C___SiteMediaLibrary' }
  & Pick<Types.C___SiteMediaLibrary, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SiteSettings = (
  { __typename?: 'C___SiteSettings' }
  & Pick<Types.C___SiteSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SiteTemplate = (
  { __typename?: 'C___SiteTemplate' }
  & Pick<Types.C___SiteTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SitecoreClientSiteManaging = (
  { __typename?: 'C___SitecoreClientSiteManaging' }
  & Pick<Types.C___SitecoreClientSiteManaging, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Sitemap = (
  { __typename?: 'C___Sitemap' }
  & Pick<Types.C___Sitemap, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SitemapMediaItems = (
  { __typename?: 'C___SitemapMediaItems' }
  & Pick<Types.C___SitemapMediaItems, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SlidersRangeSettings = (
  { __typename?: 'C___SlidersRangeSettings' }
  & Pick<Types.C___SlidersRangeSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateContent = (
  { __typename?: 'C___SolutionTemplateContent' }
  & Pick<Types.C___SolutionTemplateContent, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateDescription = (
  { __typename?: 'C___SolutionTemplateDescription' }
  & Pick<Types.C___SolutionTemplateDescription, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateName = (
  { __typename?: 'C___SolutionTemplateName' }
  & Pick<Types.C___SolutionTemplateName, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SortOrder = (
  { __typename?: 'C___SortOrder' }
  & Pick<Types.C___SortOrder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___StackBreakpoint = (
  { __typename?: 'C___StackBreakpoint' }
  & Pick<Types.C___StackBreakpoint, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Statistics = (
  { __typename?: 'C___Statistics' }
  & Pick<Types.C___Statistics, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___SupportedLanguages = (
  { __typename?: 'C___SupportedLanguages' }
  & Pick<Types.C___SupportedLanguages, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Taggable = (
  { __typename?: 'C___Taggable' }
  & Pick<Types.C___Taggable, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___TeamMembersParentPage = (
  { __typename?: 'C___TeamMembersParentPage' }
  & Pick<Types.C___TeamMembersParentPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___TeamMembersWildcard = (
  { __typename?: 'C___TeamMembersWildcard' }
  & Pick<Types.C___TeamMembersWildcard, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___TechzoneArticle = (
  { __typename?: 'C___TechzoneArticle' }
  & Pick<Types.C___TechzoneArticle, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Template = (
  { __typename?: 'C___Template' }
  & Pick<Types.C___Template, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Title = (
  { __typename?: 'C___Title' }
  & Pick<Types.C___Title, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Type = (
  { __typename?: 'C___Type' }
  & Pick<Types.C___Type, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Validation = (
  { __typename?: 'C___Validation' }
  & Pick<Types.C___Validation, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___VariantPaging = (
  { __typename?: 'C___VariantPaging' }
  & Pick<Types.C___VariantPaging, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___VectorTile = (
  { __typename?: 'C___VectorTile' }
  & Pick<Types.C___VectorTile, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___VectorTileLink = (
  { __typename?: 'C___VectorTileLink' }
  & Pick<Types.C___VectorTileLink, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Video = (
  { __typename?: 'C___Video' }
  & Pick<Types.C___Video, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___VideoPressRelease = (
  { __typename?: 'C___VideoPressRelease' }
  & Pick<Types.C___VideoPressRelease, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___Width = (
  { __typename?: 'C___Width' }
  & Pick<Types.C___Width, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_C___WildcardPage = (
  { __typename?: 'C___WildcardPage' }
  & Pick<Types.C___WildcardPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CacheSetting = (
  { __typename?: 'CacheSetting' }
  & Pick<Types.CacheSetting, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Caching_26fce9bf0256458d8281a713a5bf5520 = (
  { __typename?: 'Caching_26fce9bf0256458d8281a713a5bf5520' }
  & Pick<Types.Caching_26fce9bf0256458d8281a713a5bf5520, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CalendarEvent = (
  { __typename?: 'CalendarEvent' }
  & Pick<Types.CalendarEvent, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CallOutSection = (
  { __typename?: 'CallOutSection' }
  & Pick<Types.CallOutSection, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CallOutSectionDropdownOption = (
  { __typename?: 'CallOutSectionDropdownOption' }
  & Pick<Types.CallOutSectionDropdownOption, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CallOutSectionFolder = (
  { __typename?: 'CallOutSectionFolder' }
  & Pick<Types.CallOutSectionFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CallOutSectionParametersTemplate = (
  { __typename?: 'CallOutSectionParametersTemplate' }
  & Pick<Types.CallOutSectionParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CallToAction = (
  { __typename?: 'CallToAction' }
  & Pick<Types.CallToAction, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CallToActionFolder = (
  { __typename?: 'CallToActionFolder' }
  & Pick<Types.CallToActionFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CapabilitiesFolder = (
  { __typename?: 'CapabilitiesFolder' }
  & Pick<Types.CapabilitiesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Capability = (
  { __typename?: 'Capability' }
  & Pick<Types.Capability, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CapabilityMap = (
  { __typename?: 'CapabilityMap' }
  & Pick<Types.CapabilityMap, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CapabilityMappings = (
  { __typename?: 'CapabilityMappings' }
  & Pick<Types.CapabilityMappings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Carousel = (
  { __typename?: 'Carousel' }
  & Pick<Types.Carousel, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CarouselFolder = (
  { __typename?: 'CarouselFolder' }
  & Pick<Types.CarouselFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CarouselSlide = (
  { __typename?: 'CarouselSlide' }
  & Pick<Types.CarouselSlide, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Carousel_2b65f0d87ec54834b4aa1753c0f7036b = (
  { __typename?: 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' }
  & Pick<Types.Carousel_2b65f0d87ec54834b4aa1753c0f7036b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Checkbox = (
  { __typename?: 'Checkbox' }
  & Pick<Types.Checkbox, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ChecklistFilter = (
  { __typename?: 'ChecklistFilter' }
  & Pick<Types.ChecklistFilter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ChecklistFilterFolder = (
  { __typename?: 'ChecklistFilterFolder' }
  & Pick<Types.ChecklistFilterFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee = (
  { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' }
  & Pick<Types.ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ColumnSplitter = (
  { __typename?: 'ColumnSplitter' }
  & Pick<Types.ColumnSplitter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 = (
  { __typename?: 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' }
  & Pick<Types.ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CompatibilityMode = (
  { __typename?: 'CompatibilityMode' }
  & Pick<Types.CompatibilityMode, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ComponentConfiguration = (
  { __typename?: 'ComponentConfiguration' }
  & Pick<Types.ComponentConfiguration, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ComponentThemeConfiguration = (
  { __typename?: 'ComponentThemeConfiguration' }
  & Pick<Types.ComponentThemeConfiguration, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ComponentThemesConfiguration = (
  { __typename?: 'ComponentThemesConfiguration' }
  & Pick<Types.ComponentThemesConfiguration, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ComponentsConfigurations = (
  { __typename?: 'ComponentsConfigurations' }
  & Pick<Types.ComponentsConfigurations, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ConfigurationFolder = (
  { __typename?: 'ConfigurationFolder' }
  & Pick<Types.ConfigurationFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Container = (
  { __typename?: 'Container' }
  & Pick<Types.Container, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ContainerOption = (
  { __typename?: 'ContainerOption' }
  & Pick<Types.ContainerOption, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ContainerOptionsFolder = (
  { __typename?: 'ContainerOptionsFolder' }
  & Pick<Types.ContainerOptionsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ContainerParametersTemplate = (
  { __typename?: 'ContainerParametersTemplate' }
  & Pick<Types.ContainerParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Container_45130bdbbae34edcaea87b68b9d94c7f = (
  { __typename?: 'Container_45130bdbbae34edcaea87b68b9d94c7f' }
  & Pick<Types.Container_45130bdbbae34edcaea87b68b9d94c7f, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ContentBlock = (
  { __typename?: 'ContentBlock' }
  & Pick<Types.ContentBlock, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ContentBlockFolder = (
  { __typename?: 'ContentBlockFolder' }
  & Pick<Types.ContentBlockFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ContentToken = (
  { __typename?: 'ContentToken' }
  & Pick<Types.ContentToken, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ContentTokenFolder = (
  { __typename?: 'ContentTokenFolder' }
  & Pick<Types.ContentTokenFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ContentType = (
  { __typename?: 'ContentType' }
  & Pick<Types.ContentType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CorporateTheme = (
  { __typename?: 'CorporateTheme' }
  & Pick<Types.CorporateTheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CorporateThemesFolder = (
  { __typename?: 'CorporateThemesFolder' }
  & Pick<Types.CorporateThemesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Country = (
  { __typename?: 'Country' }
  & Pick<Types.Country, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CountryISOCode = (
  { __typename?: 'CountryISOCode' }
  & Pick<Types.CountryIsoCode, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CountryISOCodesFolder = (
  { __typename?: 'CountryISOCodesFolder' }
  & Pick<Types.CountryIsoCodesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CustomerReviewFolder = (
  { __typename?: 'CustomerReviewFolder' }
  & Pick<Types.CustomerReviewFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CustomerReviewTile = (
  { __typename?: 'CustomerReviewTile' }
  & Pick<Types.CustomerReviewTile, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_CustomerReviewTileParametersTemplate = (
  { __typename?: 'CustomerReviewTileParametersTemplate' }
  & Pick<Types.CustomerReviewTileParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DataBridgeDocumentCategoryMap = (
  { __typename?: 'DataBridgeDocumentCategoryMap' }
  & Pick<Types.DataBridgeDocumentCategoryMap, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DataBridgeFund = (
  { __typename?: 'DataBridgeFund' }
  & Pick<Types.DataBridgeFund, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DataBridgeFundRangeName = (
  { __typename?: 'DataBridgeFundRangeName' }
  & Pick<Types.DataBridgeFundRangeName, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DataBridgeSettingsFolder = (
  { __typename?: 'DataBridgeSettingsFolder' }
  & Pick<Types.DataBridgeSettingsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DataBridgeShareClass = (
  { __typename?: 'DataBridgeShareClass' }
  & Pick<Types.DataBridgeShareClass, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DataFolder = (
  { __typename?: 'DataFolder' }
  & Pick<Types.DataFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DatasourceConfiguration = (
  { __typename?: 'DatasourceConfiguration' }
  & Pick<Types.DatasourceConfiguration, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DatasourceConfigurations = (
  { __typename?: 'DatasourceConfigurations' }
  & Pick<Types.DatasourceConfigurations, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DatasourceWorkflowAction = (
  { __typename?: 'DatasourceWorkflowAction' }
  & Pick<Types.DatasourceWorkflowAction, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DateFacet = (
  { __typename?: 'DateFacet' }
  & Pick<Types.DateFacet, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DateFilter = (
  { __typename?: 'DateFilter' }
  & Pick<Types.DateFilter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DateFilterFolder = (
  { __typename?: 'DateFilterFolder' }
  & Pick<Types.DateFilterFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 = (
  { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' }
  & Pick<Types.DateFilter_Ad89c1f1e99148ef865938ab13aa28f1, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DefaultColumnLayout = (
  { __typename?: 'DefaultColumnLayout' }
  & Pick<Types.DefaultColumnLayout, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DefaultShareclassMapping = (
  { __typename?: 'DefaultShareclassMapping' }
  & Pick<Types.DefaultShareclassMapping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DefaultShareclassMappings = (
  { __typename?: 'DefaultShareclassMappings' }
  & Pick<Types.DefaultShareclassMappings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DescriptiveHighlight = (
  { __typename?: 'DescriptiveHighlight' }
  & Pick<Types.DescriptiveHighlight, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightFolder = (
  { __typename?: 'DescriptiveHighlightFolder' }
  & Pick<Types.DescriptiveHighlightFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightItem = (
  { __typename?: 'DescriptiveHighlightItem' }
  & Pick<Types.DescriptiveHighlightItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightParametersTemplate = (
  { __typename?: 'DescriptiveHighlightParametersTemplate' }
  & Pick<Types.DescriptiveHighlightParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Device = (
  { __typename?: 'Device' }
  & Pick<Types.Device, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Device_7c27ec70f42e40428a0fabaa2f8eda18 = (
  { __typename?: 'Device_7c27ec70f42e40428a0fabaa2f8eda18' }
  & Pick<Types.Device_7c27ec70f42e40428a0fabaa2f8eda18, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Devices = (
  { __typename?: 'Devices' }
  & Pick<Types.Devices, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DictionaryFolder = (
  { __typename?: 'DictionaryFolder' }
  & Pick<Types.DictionaryFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DisqusParameters = (
  { __typename?: 'DisqusParameters' }
  & Pick<Types.DisqusParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DistanceFacet = (
  { __typename?: 'DistanceFacet' }
  & Pick<Types.DistanceFacet, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Divider = (
  { __typename?: 'Divider' }
  & Pick<Types.Divider, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DocumentItem = (
  { __typename?: 'DocumentItem' }
  & Pick<Types.DocumentItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DocumentListings = (
  { __typename?: 'DocumentListings' }
  & Pick<Types.DocumentListings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DocumentListingsFolder = (
  { __typename?: 'DocumentListingsFolder' }
  & Pick<Types.DocumentListingsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DocumentTypeFolder = (
  { __typename?: 'DocumentTypeFolder' }
  & Pick<Types.DocumentTypeFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DominantLanguageMapping = (
  { __typename?: 'DominantLanguageMapping' }
  & Pick<Types.DominantLanguageMapping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Dropdown = (
  { __typename?: 'Dropdown' }
  & Pick<Types.Dropdown, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DropdownFilter = (
  { __typename?: 'DropdownFilter' }
  & Pick<Types.DropdownFilter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DropdownFilterFolder = (
  { __typename?: 'DropdownFilterFolder' }
  & Pick<Types.DropdownFilterFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d = (
  { __typename?: 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' }
  & Pick<Types.DropdownFilter_790c0f2c16214604a6c672b9f8ae830d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EditEditingTheme = (
  { __typename?: 'EditEditingTheme' }
  & Pick<Types.EditEditingTheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EditFrame = (
  { __typename?: 'EditFrame' }
  & Pick<Types.EditFrame, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EditModePanel = (
  { __typename?: 'EditModePanel' }
  & Pick<Types.EditModePanel, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EditSiteItem = (
  { __typename?: 'EditSiteItem' }
  & Pick<Types.EditSiteItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EditSiteItem_f040db0387fe4e10ae4053c63175e31b = (
  { __typename?: 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' }
  & Pick<Types.EditSiteItem_F040db0387fe4e10ae4053c63175e31b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EditSiteTheme = (
  { __typename?: 'EditSiteTheme' }
  & Pick<Types.EditSiteTheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EditTenantTemplate = (
  { __typename?: 'EditTenantTemplate' }
  & Pick<Types.EditTenantTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 = (
  { __typename?: 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' }
  & Pick<Types.EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EditType = (
  { __typename?: 'EditType' }
  & Pick<Types.EditType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EloquaFormFolder = (
  { __typename?: 'EloquaFormFolder' }
  & Pick<Types.EloquaFormFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EloquaFundForm = (
  { __typename?: 'EloquaFundForm' }
  & Pick<Types.EloquaFundForm, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Enum = (
  { __typename?: 'Enum' }
  & Pick<Types.Enum, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Enums = (
  { __typename?: 'Enums' }
  & Pick<Types.Enums, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ErrorPage = (
  { __typename?: 'ErrorPage' }
  & Pick<Types.ErrorPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 = (
  { __typename?: 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' }
  & Pick<Types.ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ErrorPage_4dbccce416d1491f94198496e3f77c6d = (
  { __typename?: 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' }
  & Pick<Types.ErrorPage_4dbccce416d1491f94198496e3f77c6d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ErrorPage_45d797cc048740ffb693214883ff35c2 = (
  { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' }
  & Pick<Types.ErrorPage_45d797cc048740ffb693214883ff35c2, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 = (
  { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' }
  & Pick<Types.ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 = (
  { __typename?: 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' }
  & Pick<Types.ErrorPage_A7dfa49761224679bf9949fffacd5fa1, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EventCalendarParameters = (
  { __typename?: 'EventCalendarParameters' }
  & Pick<Types.EventCalendarParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EventList = (
  { __typename?: 'EventList' }
  & Pick<Types.EventList, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EventListParameters = (
  { __typename?: 'EventListParameters' }
  & Pick<Types.EventListParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EventTypes = (
  { __typename?: 'EventTypes' }
  & Pick<Types.EventTypes, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_EventsFolder = (
  { __typename?: 'EventsFolder' }
  & Pick<Types.EventsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ExecuteScript = (
  { __typename?: 'ExecuteScript' }
  & Pick<Types.ExecuteScript, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f = (
  { __typename?: 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' }
  & Pick<Types.ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a = (
  { __typename?: 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' }
  & Pick<Types.ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca = (
  { __typename?: 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' }
  & Pick<Types.ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de = (
  { __typename?: 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' }
  & Pick<Types.ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb = (
  { __typename?: 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' }
  & Pick<Types.ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ExtendSiteTheme = (
  { __typename?: 'ExtendSiteTheme' }
  & Pick<Types.ExtendSiteTheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ExternalLiterature = (
  { __typename?: 'ExternalLiterature' }
  & Pick<Types.ExternalLiterature, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FEaaSWrapperRenderingParameters = (
  { __typename?: 'FEaaSWrapperRenderingParameters' }
  & Pick<Types.FEaaSWrapperRenderingParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FacebookCommentsParametersTemplate = (
  { __typename?: 'FacebookCommentsParametersTemplate' }
  & Pick<Types.FacebookCommentsParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FacetSlider = (
  { __typename?: 'FacetSlider' }
  & Pick<Types.FacetSlider, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FacetSliderFolder = (
  { __typename?: 'FacetSliderFolder' }
  & Pick<Types.FacetSliderFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 = (
  { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' }
  & Pick<Types.FacetSlider_995ce2c7319f478b84fe22053ac85bb7, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FacetSummary = (
  { __typename?: 'FacetSummary' }
  & Pick<Types.FacetSummary, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FacetSummaryFolder = (
  { __typename?: 'FacetSummaryFolder' }
  & Pick<Types.FacetSummaryFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 = (
  { __typename?: 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' }
  & Pick<Types.FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FacetsGrouping = (
  { __typename?: 'FacetsGrouping' }
  & Pick<Types.FacetsGrouping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FakeNavigationItem = (
  { __typename?: 'FakeNavigationItem' }
  & Pick<Types.FakeNavigationItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FeatureBanner = (
  { __typename?: 'FeatureBanner' }
  & Pick<Types.FeatureBanner, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FeatureBannerParametersTemplate = (
  { __typename?: 'FeatureBannerParametersTemplate' }
  & Pick<Types.FeatureBannerParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FeaturedArticles = (
  { __typename?: 'FeaturedArticles' }
  & Pick<Types.FeaturedArticles, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FeaturedArticlesFolder = (
  { __typename?: 'FeaturedArticlesFolder' }
  & Pick<Types.FeaturedArticlesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FeaturedTheme = (
  { __typename?: 'FeaturedTheme' }
  & Pick<Types.FeaturedTheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FeaturedThemesFolder = (
  { __typename?: 'FeaturedThemesFolder' }
  & Pick<Types.FeaturedThemesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Feed = (
  { __typename?: 'Feed' }
  & Pick<Types.Feed, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FeedFolder = (
  { __typename?: 'FeedFolder' }
  & Pick<Types.FeedFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FeedParameters = (
  { __typename?: 'FeedParameters' }
  & Pick<Types.FeedParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FieldEditor = (
  { __typename?: 'FieldEditor' }
  & Pick<Types.FieldEditor, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FieldRenderer = (
  { __typename?: 'FieldRenderer' }
  & Pick<Types.FieldRenderer, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FileList = (
  { __typename?: 'FileList' }
  & Pick<Types.FileList, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FileListFolder = (
  { __typename?: 'FileListFolder' }
  & Pick<Types.FileListFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FileListParametersTemplate = (
  { __typename?: 'FileListParametersTemplate' }
  & Pick<Types.FileListParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_File_04129321770849c1801baee196e1c0a8 = (
  { __typename?: 'File_04129321770849c1801baee196e1c0a8' }
  & Pick<Types.File_04129321770849c1801baee196e1c0a8, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilterCriteria = (
  { __typename?: 'FilterCriteria' }
  & Pick<Types.FilterCriteria, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilterCriteriaFolder = (
  { __typename?: 'FilterCriteriaFolder' }
  & Pick<Types.FilterCriteriaFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOption = (
  { __typename?: 'FilterTaxonomyOption' }
  & Pick<Types.FilterTaxonomyOption, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOptions = (
  { __typename?: 'FilterTaxonomyOptions' }
  & Pick<Types.FilterTaxonomyOptions, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage = (
  { __typename?: 'FilteredArticlesParentPage' }
  & Pick<Types.FilteredArticlesParentPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d = (
  { __typename?: 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' }
  & Pick<Types.FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 = (
  { __typename?: 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' }
  & Pick<Types.FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 = (
  { __typename?: 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' }
  & Pick<Types.FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 = (
  { __typename?: 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' }
  & Pick<Types.FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce = (
  { __typename?: 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' }
  & Pick<Types.FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage = (
  { __typename?: 'FilteredArticlesWildcardPage' }
  & Pick<Types.FilteredArticlesWildcardPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e = (
  { __typename?: 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' }
  & Pick<Types.FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 = (
  { __typename?: 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' }
  & Pick<Types.FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 = (
  { __typename?: 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' }
  & Pick<Types.FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 = (
  { __typename?: 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' }
  & Pick<Types.FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 = (
  { __typename?: 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' }
  & Pick<Types.FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Flip = (
  { __typename?: 'Flip' }
  & Pick<Types.Flip, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FlipFolder = (
  { __typename?: 'FlipFolder' }
  & Pick<Types.FlipFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Flip_5ef078504c044b839dafefd752cfaba8 = (
  { __typename?: 'Flip_5ef078504c044b839dafefd752cfaba8' }
  & Pick<Types.Flip_5ef078504c044b839dafefd752cfaba8, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Flipside = (
  { __typename?: 'Flipside' }
  & Pick<Types.Flipside, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FloatFacet = (
  { __typename?: 'FloatFacet' }
  & Pick<Types.FloatFacet, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Footer = (
  { __typename?: 'Footer' }
  & Pick<Types.Footer, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FooterFolder = (
  { __typename?: 'FooterFolder' }
  & Pick<Types.FooterFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FooterLink = (
  { __typename?: 'FooterLink' }
  & Pick<Types.FooterLink, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FormRenderingParameters = (
  { __typename?: 'FormRenderingParameters' }
  & Pick<Types.FormRenderingParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundAssetClass = (
  { __typename?: 'FundAssetClass' }
  & Pick<Types.FundAssetClass, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundAssetClassesFolder = (
  { __typename?: 'FundAssetClassesFolder' }
  & Pick<Types.FundAssetClassesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage = (
  { __typename?: 'FundDetailsWildcardPage' }
  & Pick<Types.FundDetailsWildcardPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 = (
  { __typename?: 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' }
  & Pick<Types.FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f = (
  { __typename?: 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' }
  & Pick<Types.FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b = (
  { __typename?: 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' }
  & Pick<Types.FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundFormsFolder = (
  { __typename?: 'FundFormsFolder' }
  & Pick<Types.FundFormsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundInFocus = (
  { __typename?: 'FundInFocus' }
  & Pick<Types.FundInFocus, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundInFocusShareClass = (
  { __typename?: 'FundInFocusShareClass' }
  & Pick<Types.FundInFocusShareClass, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundSearchPage = (
  { __typename?: 'FundSearchPage' }
  & Pick<Types.FundSearchPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundSearchPage_5505b84dba1f47c7b8054749d802d926 = (
  { __typename?: 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' }
  & Pick<Types.FundSearchPage_5505b84dba1f47c7b8054749d802d926, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundSearchPage_5806f83c03bc443380678ff955f4310f = (
  { __typename?: 'FundSearchPage_5806f83c03bc443380678ff955f4310f' }
  & Pick<Types.FundSearchPage_5806f83c03bc443380678ff955f4310f, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundSearchPage_7432205c04214a419ca064c4cb37501c = (
  { __typename?: 'FundSearchPage_7432205c04214a419ca064c4cb37501c' }
  & Pick<Types.FundSearchPage_7432205c04214a419ca064c4cb37501c, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a = (
  { __typename?: 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' }
  & Pick<Types.FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundSettings = (
  { __typename?: 'FundSettings' }
  & Pick<Types.FundSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage = (
  { __typename?: 'FundShareclassDetailsWildcardPage' }
  & Pick<Types.FundShareclassDetailsWildcardPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c = (
  { __typename?: 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' }
  & Pick<Types.FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 = (
  { __typename?: 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' }
  & Pick<Types.FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc = (
  { __typename?: 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' }
  & Pick<Types.FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee = (
  { __typename?: 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' }
  & Pick<Types.FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundSubAssetClass = (
  { __typename?: 'FundSubAssetClass' }
  & Pick<Types.FundSubAssetClass, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundSubAssetClassesFolder = (
  { __typename?: 'FundSubAssetClassesFolder' }
  & Pick<Types.FundSubAssetClassesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundsExternalLiteratureFolder = (
  { __typename?: 'FundsExternalLiteratureFolder' }
  & Pick<Types.FundsExternalLiteratureFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundsFolder = (
  { __typename?: 'FundsFolder' }
  & Pick<Types.FundsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundsInFocusFolder = (
  { __typename?: 'FundsInFocusFolder' }
  & Pick<Types.FundsInFocusFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundsInFocusParametersTemplate = (
  { __typename?: 'FundsInFocusParametersTemplate' }
  & Pick<Types.FundsInFocusParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundsLiteratureFolder = (
  { __typename?: 'FundsLiteratureFolder' }
  & Pick<Types.FundsLiteratureFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_FundsLiteratureMappingsFolder = (
  { __typename?: 'FundsLiteratureMappingsFolder' }
  & Pick<Types.FundsLiteratureMappingsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Gallery = (
  { __typename?: 'Gallery' }
  & Pick<Types.Gallery, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_GalleryFolder = (
  { __typename?: 'GalleryFolder' }
  & Pick<Types.GalleryFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_GalleryImage = (
  { __typename?: 'GalleryImage' }
  & Pick<Types.GalleryImage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_GalleryParametersTemplate = (
  { __typename?: 'GalleryParametersTemplate' }
  & Pick<Types.GalleryParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_GalleryVideo = (
  { __typename?: 'GalleryVideo' }
  & Pick<Types.GalleryVideo, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_GatedAccordionContainer = (
  { __typename?: 'GatedAccordionContainer' }
  & Pick<Types.GatedAccordionContainer, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_GlobalLanguageSelector = (
  { __typename?: 'GlobalLanguageSelector' }
  & Pick<Types.GlobalLanguageSelector, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_GlobalNavigationBar = (
  { __typename?: 'GlobalNavigationBar' }
  & Pick<Types.GlobalNavigationBar, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_GoogleAnalytics = (
  { __typename?: 'GoogleAnalytics' }
  & Pick<Types.GoogleAnalytics, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_GoogleTagManager = (
  { __typename?: 'GoogleTagManager' }
  & Pick<Types.GoogleTagManager, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_GoogleTagManagerFolder = (
  { __typename?: 'GoogleTagManagerFolder' }
  & Pick<Types.GoogleTagManagerFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_GridSetup = (
  { __typename?: 'GridSetup' }
  & Pick<Types.GridSetup, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_GridTheme = (
  { __typename?: 'GridTheme' }
  & Pick<Types.GridTheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HTMLCode = (
  { __typename?: 'HTMLCode' }
  & Pick<Types.HtmlCode, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HTMLCodeFolder = (
  { __typename?: 'HTMLCodeFolder' }
  & Pick<Types.HtmlCodeFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HTMLInclude = (
  { __typename?: 'HTMLInclude' }
  & Pick<Types.HtmlInclude, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HTMLIncludesFolder = (
  { __typename?: 'HTMLIncludesFolder' }
  & Pick<Types.HtmlIncludesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HTMLSnippet = (
  { __typename?: 'HTMLSnippet' }
  & Pick<Types.HtmlSnippet, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HTMLSnippetFolder = (
  { __typename?: 'HTMLSnippetFolder' }
  & Pick<Types.HtmlSnippetFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HTMLTag = (
  { __typename?: 'HTMLTag' }
  & Pick<Types.HtmlTag, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Header = (
  { __typename?: 'Header' }
  & Pick<Types.Header, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeaderFolder = (
  { __typename?: 'HeaderFolder' }
  & Pick<Types.HeaderFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Heading = (
  { __typename?: 'Heading' }
  & Pick<Types.Heading, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessSiteSetupRoot = (
  { __typename?: 'HeadlessSiteSetupRoot' }
  & Pick<Types.HeadlessSiteSetupRoot, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b = (
  { __typename?: 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' }
  & Pick<Types.HeadlessSite_00d050988bad49e5b65db1e08b03ca1b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 = (
  { __typename?: 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' }
  & Pick<Types.HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 = (
  { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' }
  & Pick<Types.HeadlessSite_8ca001453c4b4715959d8a05292ecbc5, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_68ffa40c5aab45548f774742b163f318 = (
  { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' }
  & Pick<Types.HeadlessSite_68ffa40c5aab45548f774742b163f318, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 = (
  { __typename?: 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' }
  & Pick<Types.HeadlessSite_89d464c8c03e4b0287e9a878d95d7149, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_229484893ca144958b9937167dfb5064 = (
  { __typename?: 'HeadlessSite_229484893ca144958b9937167dfb5064' }
  & Pick<Types.HeadlessSite_229484893ca144958b9937167dfb5064, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_b28055626acc45a2913a9617398c9730 = (
  { __typename?: 'HeadlessSite_b28055626acc45a2913a9617398c9730' }
  & Pick<Types.HeadlessSite_B28055626acc45a2913a9617398c9730, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_f1cab1661abb450d84d55d938e7699cb = (
  { __typename?: 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' }
  & Pick<Types.HeadlessSite_F1cab1661abb450d84d55d938e7699cb, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 = (
  { __typename?: 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' }
  & Pick<Types.HeadlessSite_F3884baa0e1548f59a6d7154a4559604, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessSolutionTemplateFolder = (
  { __typename?: 'HeadlessSolutionTemplateFolder' }
  & Pick<Types.HeadlessSolutionTemplateFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenantSetupRoot = (
  { __typename?: 'HeadlessTenantSetupRoot' }
  & Pick<Types.HeadlessTenantSetupRoot, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 = (
  { __typename?: 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' }
  & Pick<Types.HeadlessTenant_07248c4700af499eb2a9cb7789f72372, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 = (
  { __typename?: 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' }
  & Pick<Types.HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5d72df6049c74324969205b55767ad7b = (
  { __typename?: 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' }
  & Pick<Types.HeadlessTenant_5d72df6049c74324969205b55767ad7b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 = (
  { __typename?: 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' }
  & Pick<Types.HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_77a403a2094e48afafa60943d349d23d = (
  { __typename?: 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' }
  & Pick<Types.HeadlessTenant_77a403a2094e48afafa60943d349d23d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 = (
  { __typename?: 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' }
  & Pick<Types.HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_94824ac390d748499e5af0275d10811f = (
  { __typename?: 'HeadlessTenant_94824ac390d748499e5af0275d10811f' }
  & Pick<Types.HeadlessTenant_94824ac390d748499e5af0275d10811f, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_4797571864fd40929cf2412c39757ec3 = (
  { __typename?: 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' }
  & Pick<Types.HeadlessTenant_4797571864fd40929cf2412c39757ec3, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 = (
  { __typename?: 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' }
  & Pick<Types.HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessTrustSite = (
  { __typename?: 'HeadlessTrustSite' }
  & Pick<Types.HeadlessTrustSite, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessVariants = (
  { __typename?: 'HeadlessVariants' }
  & Pick<Types.HeadlessVariants, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeadlessVariantsGrouping = (
  { __typename?: 'HeadlessVariantsGrouping' }
  & Pick<Types.HeadlessVariantsGrouping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HelpArticlePage = (
  { __typename?: 'HelpArticlePage' }
  & Pick<Types.HelpArticlePage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HelpArticlePlatform = (
  { __typename?: 'HelpArticlePlatform' }
  & Pick<Types.HelpArticlePlatform, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMap = (
  { __typename?: 'HelpArticlePlatformMap' }
  & Pick<Types.HelpArticlePlatformMap, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMappings = (
  { __typename?: 'HelpArticlePlatformMappings' }
  & Pick<Types.HelpArticlePlatformMappings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformsFolder = (
  { __typename?: 'HelpArticlePlatformsFolder' }
  & Pick<Types.HelpArticlePlatformsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage = (
  { __typename?: 'HelpArticleSearchPage' }
  & Pick<Types.HelpArticleSearchPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 = (
  { __typename?: 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' }
  & Pick<Types.HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HelpArticleTag = (
  { __typename?: 'HelpArticleTag' }
  & Pick<Types.HelpArticleTag, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HelpArticleTagsFolder = (
  { __typename?: 'HelpArticleTagsFolder' }
  & Pick<Types.HelpArticleTagsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage = (
  { __typename?: 'HelpArticleWildcardPage' }
  & Pick<Types.HelpArticleWildcardPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 = (
  { __typename?: 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' }
  & Pick<Types.HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HelpArticlesGroupFolder = (
  { __typename?: 'HelpArticlesGroupFolder' }
  & Pick<Types.HelpArticlesGroupFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HelpTagMap = (
  { __typename?: 'HelpTagMap' }
  & Pick<Types.HelpTagMap, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HelpTagMappings = (
  { __typename?: 'HelpTagMappings' }
  & Pick<Types.HelpTagMappings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HeroBanner = (
  { __typename?: 'HeroBanner' }
  & Pick<Types.HeroBanner, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Highlight = (
  { __typename?: 'Highlight' }
  & Pick<Types.Highlight, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HighlightBlock = (
  { __typename?: 'HighlightBlock' }
  & Pick<Types.HighlightBlock, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HighlightBlockFolder = (
  { __typename?: 'HighlightBlockFolder' }
  & Pick<Types.HighlightBlockFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HighlightBlockParametersTemplate = (
  { __typename?: 'HighlightBlockParametersTemplate' }
  & Pick<Types.HighlightBlockParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HighlightFolder = (
  { __typename?: 'HighlightFolder' }
  & Pick<Types.HighlightFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HighlightItem = (
  { __typename?: 'HighlightItem' }
  & Pick<Types.HighlightItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HighlightParametersTemplate = (
  { __typename?: 'HighlightParametersTemplate' }
  & Pick<Types.HighlightParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Home = (
  { __typename?: 'Home' }
  & Pick<Types.Home, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HomePage = (
  { __typename?: 'HomePage' }
  & Pick<Types.HomePage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HomePage_0d3963a8171d4080b5f808618578b631 = (
  { __typename?: 'HomePage_0d3963a8171d4080b5f808618578b631' }
  & Pick<Types.HomePage_0d3963a8171d4080b5f808618578b631, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HomePage_6d95c7d946c74a70be07304cc73a2010 = (
  { __typename?: 'HomePage_6d95c7d946c74a70be07304cc73a2010' }
  & Pick<Types.HomePage_6d95c7d946c74a70be07304cc73a2010, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HomePage_b407f259b4e34c7db9a06e8907a56b17 = (
  { __typename?: 'HomePage_b407f259b4e34c7db9a06e8907a56b17' }
  & Pick<Types.HomePage_B407f259b4e34c7db9a06e8907a56b17, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HomePage_cde13c51062d426b95569e8202edc963 = (
  { __typename?: 'HomePage_cde13c51062d426b95569e8202edc963' }
  & Pick<Types.HomePage_Cde13c51062d426b95569e8202edc963, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_HomePage_de9353283a3e41c495ba386aed0540c6 = (
  { __typename?: 'HomePage_de9353283a3e41c495ba386aed0540c6' }
  & Pick<Types.HomePage_De9353283a3e41c495ba386aed0540c6, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_IFrame = (
  { __typename?: 'IFrame' }
  & Pick<Types.IFrame, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_IFrameFolder = (
  { __typename?: 'IFrameFolder' }
  & Pick<Types.IFrameFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 = (
  { __typename?: 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' }
  & Pick<Types.IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_IFrameParametersTemplate = (
  { __typename?: 'IFrameParametersTemplate' }
  & Pick<Types.IFrameParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_IFrame_0da12d476de24dfeb4d0f513489bfea1 = (
  { __typename?: 'IFrame_0da12d476de24dfeb4d0f513489bfea1' }
  & Pick<Types.IFrame_0da12d476de24dfeb4d0f513489bfea1, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_IFrame_88a6f65f2b78491bb3770b06e48883e1 = (
  { __typename?: 'IFrame_88a6f65f2b78491bb3770b06e48883e1' }
  & Pick<Types.IFrame_88a6f65f2b78491bb3770b06e48883e1, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Icon = (
  { __typename?: 'Icon' }
  & Pick<Types.Icon, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_IconFolder = (
  { __typename?: 'IconFolder' }
  & Pick<Types.IconFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Image = (
  { __typename?: 'Image' }
  & Pick<Types.Image, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ImageFolder = (
  { __typename?: 'ImageFolder' }
  & Pick<Types.ImageFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ImageFolder_edc00e86cef24d0cbfa264460becc323 = (
  { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' }
  & Pick<Types.ImageFolder_Edc00e86cef24d0cbfa264460becc323, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 = (
  { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' }
  & Pick<Types.ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ImageParametersTemplate = (
  { __typename?: 'ImageParametersTemplate' }
  & Pick<Types.ImageParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Image_83bc563c6320490092f8204bff81586a = (
  { __typename?: 'Image_83bc563c6320490092f8204bff81586a' }
  & Pick<Types.Image_83bc563c6320490092f8204bff81586a, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Image_15185b0e641844499f934ff03b7ee032 = (
  { __typename?: 'Image_15185b0e641844499f934ff03b7ee032' }
  & Pick<Types.Image_15185b0e641844499f934ff03b7ee032, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Image_d885df8cb2d64007b34b2bbafb527304 = (
  { __typename?: 'Image_d885df8cb2d64007b34b2bbafb527304' }
  & Pick<Types.Image_D885df8cb2d64007b34b2bbafb527304, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Infographics = (
  { __typename?: 'Infographics' }
  & Pick<Types.Infographics, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_InfographicsFolder = (
  { __typename?: 'InfographicsFolder' }
  & Pick<Types.InfographicsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_InputValidationStep = (
  { __typename?: 'InputValidationStep' }
  & Pick<Types.InputValidationStep, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_InputValidationStep_088928cf558e40ec87f3342aa9e66757 = (
  { __typename?: 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' }
  & Pick<Types.InputValidationStep_088928cf558e40ec87f3342aa9e66757, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 = (
  { __typename?: 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' }
  & Pick<Types.InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f = (
  { __typename?: 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' }
  & Pick<Types.InputValidationStep_D028fef2babf4ad1bbe74d62a977992f, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_IntegerFacet = (
  { __typename?: 'IntegerFacet' }
  & Pick<Types.IntegerFacet, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_IntroCopy = (
  { __typename?: 'IntroCopy' }
  & Pick<Types.IntroCopy, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_IntroCopyFolder = (
  { __typename?: 'IntroCopyFolder' }
  & Pick<Types.IntroCopyFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClass = (
  { __typename?: 'InvestmentTrustAssetClass' }
  & Pick<Types.InvestmentTrustAssetClass, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClassFolder = (
  { __typename?: 'InvestmentTrustAssetClassFolder' }
  & Pick<Types.InvestmentTrustAssetClassFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 = (
  { __typename?: 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' }
  & Pick<Types.InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73, 'id'>
  & { trustRegion: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField>, trustLink: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustLink_LinkField>, trustStyle: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField>, trustAssetClass: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField>, trustId: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustId_TextField>, trustName: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustName_TextField>, trustDescription: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustDescription_TextField>, trustImage: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustImage_ImageField>, trustIsHidden: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustIsHidden_CheckboxField> }
);

export type TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb = (
  { __typename?: 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' }
  & Pick<Types.InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb, 'id'>
  & { trustRegion: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField>, trustLink: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustLink_LinkField>, trustStyle: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField>, trustAssetClass: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField>, trustId: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustId_TextField>, trustName: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustName_TextField>, trustDescription: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustDescription_TextField>, trustImage: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustImage_ImageField>, trustIsHidden: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustIsHidden_CheckboxField> }
);

export type TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegion = (
  { __typename?: 'InvestmentTrustRegion' }
  & Pick<Types.InvestmentTrustRegion, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegionFolder = (
  { __typename?: 'InvestmentTrustRegionFolder' }
  & Pick<Types.InvestmentTrustRegionFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyle = (
  { __typename?: 'InvestmentTrustStyle' }
  & Pick<Types.InvestmentTrustStyle, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyleFolder = (
  { __typename?: 'InvestmentTrustStyleFolder' }
  & Pick<Types.InvestmentTrustStyleFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_InvestorType = (
  { __typename?: 'InvestorType' }
  & Pick<Types.InvestorType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_InvestorTypesFolder = (
  { __typename?: 'InvestorTypesFolder' }
  & Pick<Types.InvestorTypesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ItemQueriesFolder = (
  { __typename?: 'ItemQueriesFolder' }
  & Pick<Types.ItemQueriesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ItemRights = (
  { __typename?: 'ItemRights' }
  & Pick<Types.ItemRights, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSBeaconSettings = (
  { __typename?: 'JSBeaconSettings' }
  & Pick<Types.JsBeaconSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONCheckbox = (
  { __typename?: 'JSONCheckbox' }
  & Pick<Types.JsonCheckbox, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONContent = (
  { __typename?: 'JSONContent' }
  & Pick<Types.JsonContent, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONDate = (
  { __typename?: 'JSONDate' }
  & Pick<Types.JsonDate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONFile = (
  { __typename?: 'JSONFile' }
  & Pick<Types.JsonFile, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONImage = (
  { __typename?: 'JSONImage' }
  & Pick<Types.JsonImage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONLayout = (
  { __typename?: 'JSONLayout' }
  & Pick<Types.JsonLayout, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONList = (
  { __typename?: 'JSONList' }
  & Pick<Types.JsonList, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONMultilistReference = (
  { __typename?: 'JSONMultilistReference' }
  & Pick<Types.JsonMultilistReference, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONPlaceholder = (
  { __typename?: 'JSONPlaceholder' }
  & Pick<Types.JsonPlaceholder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONQuery = (
  { __typename?: 'JSONQuery' }
  & Pick<Types.JsonQuery, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONResults = (
  { __typename?: 'JSONResults' }
  & Pick<Types.JsonResults, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONRichText = (
  { __typename?: 'JSONRichText' }
  & Pick<Types.JsonRichText, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONScriban = (
  { __typename?: 'JSONScriban' }
  & Pick<Types.JsonScriban, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONSection = (
  { __typename?: 'JSONSection' }
  & Pick<Types.JsonSection, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONTemplate = (
  { __typename?: 'JSONTemplate' }
  & Pick<Types.JsonTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONText = (
  { __typename?: 'JSONText' }
  & Pick<Types.JsonText, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONToken = (
  { __typename?: 'JSONToken' }
  & Pick<Types.JsonToken, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONVariantDefinition = (
  { __typename?: 'JSONVariantDefinition' }
  & Pick<Types.JsonVariantDefinition, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSONVariants = (
  { __typename?: 'JSONVariants' }
  & Pick<Types.JsonVariants, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSSLayout = (
  { __typename?: 'JSSLayout' }
  & Pick<Types.JssLayout, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 = (
  { __typename?: 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' }
  & Pick<Types.JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_6b328292f8314ab79885d89a054ca10a = (
  { __typename?: 'JSSSettings_6b328292f8314ab79885d89a054ca10a' }
  & Pick<Types.JssSettings_6b328292f8314ab79885d89a054ca10a, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff = (
  { __typename?: 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' }
  & Pick<Types.JssSettings_457c9d0b61b84adfaf7f82561ed275ff, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d = (
  { __typename?: 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' }
  & Pick<Types.JssSettings_5045bf85d2ea430b9f41c2e348436e5d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 = (
  { __typename?: 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' }
  & Pick<Types.JssSettings_A767f80d5ad44bfbb8b750a8da144cb5, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_b001fd725bb1476496825a8cb9e995cd = (
  { __typename?: 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' }
  & Pick<Types.JssSettings_B001fd725bb1476496825a8cb9e995cd, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_c643bc8630d14d61a173c7870f5dbbad = (
  { __typename?: 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' }
  & Pick<Types.JssSettings_C643bc8630d14d61a173c7870f5dbbad, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 = (
  { __typename?: 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' }
  & Pick<Types.JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 = (
  { __typename?: 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' }
  & Pick<Types.JssSettings_Ef855d0ba8b04a8e87851d1298266d90, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSSSiteGrouping = (
  { __typename?: 'JSSSiteGrouping' }
  & Pick<Types.JssSiteGrouping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JSSTenantFolder = (
  { __typename?: 'JSSTenantFolder' }
  & Pick<Types.JssTenantFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JavaScriptRendering = (
  { __typename?: 'JavaScriptRendering' }
  & Pick<Types.JavaScriptRendering, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JsonRendering = (
  { __typename?: 'JsonRendering' }
  & Pick<Types.JsonRendering, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JurisdictionStatus = (
  { __typename?: 'JurisdictionStatus' }
  & Pick<Types.JurisdictionStatus, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_JurisdictionsFolder = (
  { __typename?: 'JurisdictionsFolder' }
  & Pick<Types.JurisdictionsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_KeyHighlightItem = (
  { __typename?: 'KeyHighlightItem' }
  & Pick<Types.KeyHighlightItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_KeyHighlights = (
  { __typename?: 'KeyHighlights' }
  & Pick<Types.KeyHighlights, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_KeyHighlightsFolder = (
  { __typename?: 'KeyHighlightsFolder' }
  & Pick<Types.KeyHighlightsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_KeyHighlightsParametersTemplate = (
  { __typename?: 'KeyHighlightsParametersTemplate' }
  & Pick<Types.KeyHighlightsParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Language = (
  { __typename?: 'Language' }
  & Pick<Types.Language, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LanguageSelector = (
  { __typename?: 'LanguageSelector' }
  & Pick<Types.LanguageSelector, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LanguagesFolder = (
  { __typename?: 'LanguagesFolder' }
  & Pick<Types.LanguagesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LatestPressReleasesParametersTemplate = (
  { __typename?: 'LatestPressReleasesParametersTemplate' }
  & Pick<Types.LatestPressReleasesParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LayoutServiceVariants = (
  { __typename?: 'LayoutServiceVariants' }
  & Pick<Types.LayoutServiceVariants, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LimitedDisplayFolder = (
  { __typename?: 'LimitedDisplayFolder' }
  & Pick<Types.LimitedDisplayFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LimitedDisplayOption = (
  { __typename?: 'LimitedDisplayOption' }
  & Pick<Types.LimitedDisplayOption, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Link = (
  { __typename?: 'Link' }
  & Pick<Types.Link, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LinkList = (
  { __typename?: 'LinkList' }
  & Pick<Types.LinkList, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LinkListFolder = (
  { __typename?: 'LinkListFolder' }
  & Pick<Types.LinkListFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 = (
  { __typename?: 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' }
  & Pick<Types.LinkListFolder_C237d144647a4afeaa7b1570f3e3f139, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LinkList_33c9207e3b0446068ef54ca99a97c776 = (
  { __typename?: 'LinkList_33c9207e3b0446068ef54ca99a97c776' }
  & Pick<Types.LinkList_33c9207e3b0446068ef54ca99a97c776, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LinkList_97a593ad273141dc80bfceb5ef6a33b7 = (
  { __typename?: 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' }
  & Pick<Types.LinkList_97a593ad273141dc80bfceb5ef6a33b7, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LinkList_f7561ffcc0d8477fb53d2703a4060be1 = (
  { __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' }
  & Pick<Types.LinkList_F7561ffcc0d8477fb53d2703a4060be1, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Link_68bd1cb5a7624a969ac6cb16ab5882a3 = (
  { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' }
  & Pick<Types.Link_68bd1cb5a7624a969ac6cb16ab5882a3, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Link_930f134d56784b35bfd1b77f9d0115f1 = (
  { __typename?: 'Link_930f134d56784b35bfd1b77f9d0115f1' }
  & Pick<Types.Link_930f134d56784b35bfd1b77f9d0115f1, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Link_e24e0789a05848bfabb6c69c0e60b6b7 = (
  { __typename?: 'Link_e24e0789a05848bfabb6c69c0e60b6b7' }
  & Pick<Types.Link_E24e0789a05848bfabb6c69c0e60b6b7, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LinksFolder = (
  { __typename?: 'LinksFolder' }
  & Pick<Types.LinksFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_List = (
  { __typename?: 'List' }
  & Pick<Types.List, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ListFacet = (
  { __typename?: 'ListFacet' }
  & Pick<Types.ListFacet, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ListFolder = (
  { __typename?: 'ListFolder' }
  & Pick<Types.ListFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ListItem = (
  { __typename?: 'ListItem' }
  & Pick<Types.ListItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ListParametersTemplate = (
  { __typename?: 'ListParametersTemplate' }
  & Pick<Types.ListParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ListStyle = (
  { __typename?: 'ListStyle' }
  & Pick<Types.ListStyle, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ListStyleItem = (
  { __typename?: 'ListStyleItem' }
  & Pick<Types.ListStyleItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ListingHeroBanner = (
  { __typename?: 'ListingHeroBanner' }
  & Pick<Types.ListingHeroBanner, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ListingHeroParametersTemplate = (
  { __typename?: 'ListingHeroParametersTemplate' }
  & Pick<Types.ListingHeroParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LiteratureAuthorization = (
  { __typename?: 'LiteratureAuthorization' }
  & Pick<Types.LiteratureAuthorization, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LiteratureAuthorizationsFolder = (
  { __typename?: 'LiteratureAuthorizationsFolder' }
  & Pick<Types.LiteratureAuthorizationsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage = (
  { __typename?: 'LiteratureHubSearchPage' }
  & Pick<Types.LiteratureHubSearchPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d = (
  { __typename?: 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' }
  & Pick<Types.LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e = (
  { __typename?: 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' }
  & Pick<Types.LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea = (
  { __typename?: 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' }
  & Pick<Types.LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LoadMore = (
  { __typename?: 'LoadMore' }
  & Pick<Types.LoadMore, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LoadMoreFolder = (
  { __typename?: 'LoadMoreFolder' }
  & Pick<Types.LoadMoreFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 = (
  { __typename?: 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' }
  & Pick<Types.LoadMore_7a3a53e06a0144ff8ba52be46e201fe6, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LocationFilter = (
  { __typename?: 'LocationFilter' }
  & Pick<Types.LocationFilter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LocationFilterFolder = (
  { __typename?: 'LocationFilterFolder' }
  & Pick<Types.LocationFilterFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LocationFilter_aaad4aad290744dc90b69e4e83a661ec = (
  { __typename?: 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' }
  & Pick<Types.LocationFilter_Aaad4aad290744dc90b69e4e83a661ec, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Log = (
  { __typename?: 'Log' }
  & Pick<Types.Log, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Login = (
  { __typename?: 'Login' }
  & Pick<Types.Login, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Login_abed54dc4f7840ddac562289c9c849d8 = (
  { __typename?: 'Login_abed54dc4f7840ddac562289c9c849d8' }
  & Pick<Types.Login_Abed54dc4f7840ddac562289c9c849d8, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LogoTextBlockItem = (
  { __typename?: 'LogoTextBlockItem' }
  & Pick<Types.LogoTextBlockItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LogoTextBlocks = (
  { __typename?: 'LogoTextBlocks' }
  & Pick<Types.LogoTextBlocks, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_LogoTextBlocksFolder = (
  { __typename?: 'LogoTextBlocksFolder' }
  & Pick<Types.LogoTextBlocksFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Logout = (
  { __typename?: 'Logout' }
  & Pick<Types.Logout, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Logout_c2294d8235a6452a94b15eb5e543b602 = (
  { __typename?: 'Logout_c2294d8235a6452a94b15eb5e543b602' }
  & Pick<Types.Logout_C2294d8235a6452a94b15eb5e543b602, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter = (
  { __typename?: 'ManagedRangeFilter' }
  & Pick<Types.ManagedRangeFilter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ManagedRangeFilterFolder = (
  { __typename?: 'ManagedRangeFilterFolder' }
  & Pick<Types.ManagedRangeFilterFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 = (
  { __typename?: 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' }
  & Pick<Types.ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ManagedRangeItem = (
  { __typename?: 'ManagedRangeItem' }
  & Pick<Types.ManagedRangeItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Map = (
  { __typename?: 'Map' }
  & Pick<Types.Map, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MapParameters = (
  { __typename?: 'MapParameters' }
  & Pick<Types.MapParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MapsFolder = (
  { __typename?: 'MapsFolder' }
  & Pick<Types.MapsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MapsProvider = (
  { __typename?: 'MapsProvider' }
  & Pick<Types.MapsProvider, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MediaBlock = (
  { __typename?: 'MediaBlock' }
  & Pick<Types.MediaBlock, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MediaBlockFolder = (
  { __typename?: 'MediaBlockFolder' }
  & Pick<Types.MediaBlockFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MediaBlockParametersTemplate = (
  { __typename?: 'MediaBlockParametersTemplate' }
  & Pick<Types.MediaBlockParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MediaFolder_81150e5837f5443fa3c075e14a9321e7 = (
  { __typename?: 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' }
  & Pick<Types.MediaFolder_81150e5837f5443fa3c075e14a9321e7, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MediaLinkParameters = (
  { __typename?: 'MediaLinkParameters' }
  & Pick<Types.MediaLinkParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MediaVirtualFolder = (
  { __typename?: 'MediaVirtualFolder' }
  & Pick<Types.MediaVirtualFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MegaNavigation = (
  { __typename?: 'MegaNavigation' }
  & Pick<Types.MegaNavigation, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MegaNavigationFolder = (
  { __typename?: 'MegaNavigationFolder' }
  & Pick<Types.MegaNavigationFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MetaBranding = (
  { __typename?: 'MetaBranding' }
  & Pick<Types.MetaBranding, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MetaRenderingParameters = (
  { __typename?: 'MetaRenderingParameters' }
  & Pick<Types.MetaRenderingParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MetadataPartialDesign = (
  { __typename?: 'MetadataPartialDesign' }
  & Pick<Types.MetadataPartialDesign, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Model = (
  { __typename?: 'Model' }
  & Pick<Types.Model, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ModelIterator = (
  { __typename?: 'ModelIterator' }
  & Pick<Types.ModelIterator, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_MyLocationPOI = (
  { __typename?: 'MyLocationPOI' }
  & Pick<Types.MyLocationPoi, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Navigation = (
  { __typename?: 'Navigation' }
  & Pick<Types.Navigation, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_NavigationCategory = (
  { __typename?: 'NavigationCategory' }
  & Pick<Types.NavigationCategory, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_NavigationFilter = (
  { __typename?: 'NavigationFilter' }
  & Pick<Types.NavigationFilter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_NavigationFilterFolder = (
  { __typename?: 'NavigationFilterFolder' }
  & Pick<Types.NavigationFilterFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_NavigationLink = (
  { __typename?: 'NavigationLink' }
  & Pick<Types.NavigationLink, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_NavigationSubcategory = (
  { __typename?: 'NavigationSubcategory' }
  & Pick<Types.NavigationSubcategory, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 = (
  { __typename?: 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' }
  & Pick<Types.Navigation_9ce34bf95c934dff841d8f649c2bd6c8, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_OneTrustSettings = (
  { __typename?: 'OneTrustSettings' }
  & Pick<Types.OneTrustSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_OptimiserConfiguration = (
  { __typename?: 'OptimiserConfiguration' }
  & Pick<Types.OptimiserConfiguration, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_OptimiserConfigurationSection = (
  { __typename?: 'OptimiserConfigurationSection' }
  & Pick<Types.OptimiserConfigurationSection, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_OptimizedFile = (
  { __typename?: 'OptimizedFile' }
  & Pick<Types.OptimizedFile, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_OracleCDPSettings = (
  { __typename?: 'OracleCDPSettings' }
  & Pick<Types.OracleCdpSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_OverlayContent = (
  { __typename?: 'OverlayContent' }
  & Pick<Types.OverlayContent, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_OverlayFolderTemplate = (
  { __typename?: 'OverlayFolderTemplate' }
  & Pick<Types.OverlayFolderTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Ownership = (
  { __typename?: 'Ownership' }
  & Pick<Types.Ownership, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_OwnershipFolder = (
  { __typename?: 'OwnershipFolder' }
  & Pick<Types.OwnershipFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_POI = (
  { __typename?: 'POI' }
  & Pick<Types.Poi, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_POIFolder = (
  { __typename?: 'POIFolder' }
  & Pick<Types.PoiFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_POIType = (
  { __typename?: 'POIType' }
  & Pick<Types.PoiType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_POIs = (
  { __typename?: 'POIs' }
  & Pick<Types.PoIs, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageBranchesFolder = (
  { __typename?: 'PageBranchesFolder' }
  & Pick<Types.PageBranchesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageContent = (
  { __typename?: 'PageContent' }
  & Pick<Types.PageContent, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageContentFolder = (
  { __typename?: 'PageContentFolder' }
  & Pick<Types.PageContentFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 = (
  { __typename?: 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' }
  & Pick<Types.PageContent_Ef87e73bc7ff49a2ac599b0be83755c3, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesign = (
  { __typename?: 'PageDesign' }
  & Pick<Types.PageDesign, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 = (
  { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' }
  & Pick<Types.PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 = (
  { __typename?: 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' }
  & Pick<Types.PageDesignFolder_27d4f8be63b045769a4ef3163c935b47, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 = (
  { __typename?: 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' }
  & Pick<Types.PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b = (
  { __typename?: 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' }
  & Pick<Types.PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 = (
  { __typename?: 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' }
  & Pick<Types.PageDesignFolder_720d01f11e5046fa9c4a697f9321f662, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc = (
  { __typename?: 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' }
  & Pick<Types.PageDesignFolder_771a0de7e83f44338c5d78727ead93bc, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 = (
  { __typename?: 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' }
  & Pick<Types.PageDesignFolder_14161ec204984aa7a2a46decadf669f5, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb = (
  { __typename?: 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' }
  & Pick<Types.PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_d84605f786ea482da6ff683f6572821c = (
  { __typename?: 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' }
  & Pick<Types.PageDesignFolder_D84605f786ea482da6ff683f6572821c, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesign_1105b8f81e00426bbf1fc840742d827b = (
  { __typename?: 'PageDesign_1105b8f81e00426bbf1fc840742d827b' }
  & Pick<Types.PageDesign_1105b8f81e00426bbf1fc840742d827b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesigns = (
  { __typename?: 'PageDesigns' }
  & Pick<Types.PageDesigns, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_3af52e70e982424b9c85e355542500c9 = (
  { __typename?: 'PageDesigns_3af52e70e982424b9c85e355542500c9' }
  & Pick<Types.PageDesigns_3af52e70e982424b9c85e355542500c9, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d = (
  { __typename?: 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' }
  & Pick<Types.PageDesigns_9b34083e890b467d8e76b8c3dbbb712d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 = (
  { __typename?: 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' }
  & Pick<Types.PageDesigns_48d2d50a150c4f6283603a4fed5646e0, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_99a71bba507746729c3fb29b04abee23 = (
  { __typename?: 'PageDesigns_99a71bba507746729c3fb29b04abee23' }
  & Pick<Types.PageDesigns_99a71bba507746729c3fb29b04abee23, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 = (
  { __typename?: 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' }
  & Pick<Types.PageDesigns_A0f265b42d6241968b65d3ede7cb59c3, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 = (
  { __typename?: 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' }
  & Pick<Types.PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_b8d9b352c1694b31bd506848b47ca884 = (
  { __typename?: 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' }
  & Pick<Types.PageDesigns_B8d9b352c1694b31bd506848b47ca884, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_d3b2e1466f744df0900bec314f699ef3 = (
  { __typename?: 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' }
  & Pick<Types.PageDesigns_D3b2e1466f744df0900bec314f699ef3, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe = (
  { __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' }
  & Pick<Types.PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageLevelTabs = (
  { __typename?: 'PageLevelTabs' }
  & Pick<Types.PageLevelTabs, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageLevelTabsFolder = (
  { __typename?: 'PageLevelTabsFolder' }
  & Pick<Types.PageLevelTabsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageList = (
  { __typename?: 'PageList' }
  & Pick<Types.PageList, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageSelector = (
  { __typename?: 'PageSelector' }
  & Pick<Types.PageSelector, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageSelectorConfiguration = (
  { __typename?: 'PageSelectorConfiguration' }
  & Pick<Types.PageSelectorConfiguration, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageSelectorFolder = (
  { __typename?: 'PageSelectorFolder' }
  & Pick<Types.PageSelectorFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageSelector_59a7bb775f8c435ab810291abde80e63 = (
  { __typename?: 'PageSelector_59a7bb775f8c435ab810291abde80e63' }
  & Pick<Types.PageSelector_59a7bb775f8c435ab810291abde80e63, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageSize = (
  { __typename?: 'PageSize' }
  & Pick<Types.PageSize, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageSizeFolder = (
  { __typename?: 'PageSizeFolder' }
  & Pick<Types.PageSizeFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageSize_b682562e0af64b3e9e3b45273bbe152d = (
  { __typename?: 'PageSize_b682562e0af64b3e9e3b45273bbe152d' }
  & Pick<Types.PageSize_B682562e0af64b3e9e3b45273bbe152d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageTheme = (
  { __typename?: 'PageTheme' }
  & Pick<Types.PageTheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PageThemesFolder = (
  { __typename?: 'PageThemesFolder' }
  & Pick<Types.PageThemesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Page_4f49a81db3664f198b89cab92f377d7a = (
  { __typename?: 'Page_4f49a81db3664f198b89cab92f377d7a' }
  & Pick<Types.Page_4f49a81db3664f198b89cab92f377d7a, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Page_5e66d86353544fe6a27d3b894984d50f = (
  { __typename?: 'Page_5e66d86353544fe6a27d3b894984d50f' }
  & Pick<Types.Page_5e66d86353544fe6a27d3b894984d50f, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Page_84f342ad2d0646b9aa9a818201145ca2 = (
  { __typename?: 'Page_84f342ad2d0646b9aa9a818201145ca2' }
  & Pick<Types.Page_84f342ad2d0646b9aa9a818201145ca2, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Page_718df200be51463d93edf4d77ab7a49e = (
  { __typename?: 'Page_718df200be51463d93edf4d77ab7a49e' }
  & Pick<Types.Page_718df200be51463d93edf4d77ab7a49e, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Page_b61d5babe46f4ef39f27b57c4ccefdf7 = (
  { __typename?: 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' }
  & Pick<Types.Page_B61d5babe46f4ef39f27b57c4ccefdf7, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Page_cfd6e04697e24f3cb9eb41b79afc35dc = (
  { __typename?: 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' }
  & Pick<Types.Page_Cfd6e04697e24f3cb9eb41b79afc35dc, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Page_dae7821153e14dbabb0ddf0b53a90aaf = (
  { __typename?: 'Page_dae7821153e14dbabb0ddf0b53a90aaf' }
  & Pick<Types.Page_Dae7821153e14dbabb0ddf0b53a90aaf, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Page_fa608b3e6aeb426388a059d89caabada = (
  { __typename?: 'Page_fa608b3e6aeb426388a059d89caabada' }
  & Pick<Types.Page_Fa608b3e6aeb426388a059d89caabada, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Pagging = (
  { __typename?: 'Pagging' }
  & Pick<Types.Pagging, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Pagination = (
  { __typename?: 'Pagination' }
  & Pick<Types.Pagination, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PaginationFolder = (
  { __typename?: 'PaginationFolder' }
  & Pick<Types.PaginationFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Paragraph = (
  { __typename?: 'Paragraph' }
  & Pick<Types.Paragraph, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d = (
  { __typename?: 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' }
  & Pick<Types.PartialDesignFolder_8cf20a4412b746ee801218122c955b2d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b = (
  { __typename?: 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' }
  & Pick<Types.PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 = (
  { __typename?: 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' }
  & Pick<Types.PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b = (
  { __typename?: 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' }
  & Pick<Types.PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 = (
  { __typename?: 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' }
  & Pick<Types.PartialDesignFolder_828b5ff144cd4150bcdfe54084165112, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_89098e3089aa4062a77346d608caac90 = (
  { __typename?: 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' }
  & Pick<Types.PartialDesignFolder_89098e3089aa4062a77346d608caac90, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_1695576fb93647d7842ed17730278c32 = (
  { __typename?: 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' }
  & Pick<Types.PartialDesignFolder_1695576fb93647d7842ed17730278c32, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc = (
  { __typename?: 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' }
  & Pick<Types.PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a = (
  { __typename?: 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' }
  & Pick<Types.PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 = (
  { __typename?: 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' }
  & Pick<Types.PartialDesign_Fd2059fd60434dfe8c04e2437ce87634, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns = (
  { __typename?: 'PartialDesigns' }
  & Pick<Types.PartialDesigns, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec = (
  { __typename?: 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' }
  & Pick<Types.PartialDesigns_043d3ad0ac4445dba03afc3550d088ec, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 = (
  { __typename?: 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' }
  & Pick<Types.PartialDesigns_0310a4bf20d1441c886a0418c53e30f4, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_36c869ded22040929ce829f6ed643c66 = (
  { __typename?: 'PartialDesigns_36c869ded22040929ce829f6ed643c66' }
  & Pick<Types.PartialDesigns_36c869ded22040929ce829f6ed643c66, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_1943dc73710a430895515a342c84b037 = (
  { __typename?: 'PartialDesigns_1943dc73710a430895515a342c84b037' }
  & Pick<Types.PartialDesigns_1943dc73710a430895515a342c84b037, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 = (
  { __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' }
  & Pick<Types.PartialDesigns_B1e2a6790a1442d8bafa66317b8be117, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e = (
  { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' }
  & Pick<Types.PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_d52704ed3b704a53abb4292105f687ad = (
  { __typename?: 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' }
  & Pick<Types.PartialDesigns_D52704ed3b704a53abb4292105f687ad, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_d216303f58d8425688da8cd30d00afab = (
  { __typename?: 'PartialDesigns_d216303f58d8425688da8cd30d00afab' }
  & Pick<Types.PartialDesigns_D216303f58d8425688da8cd30d00afab, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_facda26791204fa9a0363344348f2c42 = (
  { __typename?: 'PartialDesigns_facda26791204fa9a0363344348f2c42' }
  & Pick<Types.PartialDesigns_Facda26791204fa9a0363344348f2c42, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PerformanceChartSettings = (
  { __typename?: 'PerformanceChartSettings' }
  & Pick<Types.PerformanceChartSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriod = (
  { __typename?: 'PerformanceChartTimePeriod' }
  & Pick<Types.PerformanceChartTimePeriod, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriodFolder = (
  { __typename?: 'PerformanceChartTimePeriodFolder' }
  & Pick<Types.PerformanceChartTimePeriodFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 = (
  { __typename?: 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' }
  & Pick<Types.PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d = (
  { __typename?: 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' }
  & Pick<Types.PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba = (
  { __typename?: 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' }
  & Pick<Types.PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Placeholder_1ca0304be5b64810821154426f1752c2 = (
  { __typename?: 'Placeholder_1ca0304be5b64810821154426f1752c2' }
  & Pick<Types.Placeholder_1ca0304be5b64810821154426f1752c2, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c = (
  { __typename?: 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' }
  & Pick<Types.Placeholder_D2a6884c04d54089a64ed27ca9d68d4c, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PlainHtmlParametersTemplate = (
  { __typename?: 'PlainHtmlParametersTemplate' }
  & Pick<Types.PlainHtmlParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Playlist = (
  { __typename?: 'Playlist' }
  & Pick<Types.Playlist, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PlaylistFolder = (
  { __typename?: 'PlaylistFolder' }
  & Pick<Types.PlaylistFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PlaylistParametersTemplate = (
  { __typename?: 'PlaylistParametersTemplate' }
  & Pick<Types.PlaylistParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Podcast = (
  { __typename?: 'Podcast' }
  & Pick<Types.Podcast, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PodcastFolder = (
  { __typename?: 'PodcastFolder' }
  & Pick<Types.PodcastFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PodcastPage = (
  { __typename?: 'PodcastPage' }
  & Pick<Types.PodcastPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PodcastPressReleasePage = (
  { __typename?: 'PodcastPressReleasePage' }
  & Pick<Types.PodcastPressReleasePage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PoiTypes = (
  { __typename?: 'PoiTypes' }
  & Pick<Types.PoiTypes, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PostDeleteStep = (
  { __typename?: 'PostDeleteStep' }
  & Pick<Types.PostDeleteStep, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 = (
  { __typename?: 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' }
  & Pick<Types.PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a = (
  { __typename?: 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' }
  & Pick<Types.PostDeleteStep_78d6ec9b66e34763987003cf314ee37a, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PostDeleteStep_b20857895385413883f096f3767cb156 = (
  { __typename?: 'PostDeleteStep_b20857895385413883f096f3767cb156' }
  & Pick<Types.PostDeleteStep_B20857895385413883f096f3767cb156, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PostSetupStep = (
  { __typename?: 'PostSetupStep' }
  & Pick<Types.PostSetupStep, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PostSetupStep_6fac654e22154a419a1d59197bebc0fe = (
  { __typename?: 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' }
  & Pick<Types.PostSetupStep_6fac654e22154a419a1d59197bebc0fe, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f = (
  { __typename?: 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' }
  & Pick<Types.PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PostSetupStep_341738aa44fe490e90ff7010a3c2463b = (
  { __typename?: 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' }
  & Pick<Types.PostSetupStep_341738aa44fe490e90ff7010a3c2463b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PreDeleteStep = (
  { __typename?: 'PreDeleteStep' }
  & Pick<Types.PreDeleteStep, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 = (
  { __typename?: 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' }
  & Pick<Types.PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b = (
  { __typename?: 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' }
  & Pick<Types.PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PreDeleteStep_f0daf401190f45468bda8568d08e161d = (
  { __typename?: 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' }
  & Pick<Types.PreDeleteStep_F0daf401190f45468bda8568d08e161d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep = (
  { __typename?: 'PreDeleteValidationStep' }
  & Pick<Types.PreDeleteValidationStep, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f = (
  { __typename?: 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' }
  & Pick<Types.PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f = (
  { __typename?: 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' }
  & Pick<Types.PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e = (
  { __typename?: 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' }
  & Pick<Types.PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Presentation = (
  { __typename?: 'Presentation' }
  & Pick<Types.Presentation, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Presentation_0a70fa7389234a6eabf34134f25f3221 = (
  { __typename?: 'Presentation_0a70fa7389234a6eabf34134f25f3221' }
  & Pick<Types.Presentation_0a70fa7389234a6eabf34134f25f3221, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleaseContentType = (
  { __typename?: 'PressReleaseContentType' }
  & Pick<Types.PressReleaseContentType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleaseContentTypesFolder = (
  { __typename?: 'PressReleaseContentTypesFolder' }
  & Pick<Types.PressReleaseContentTypesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleaseFilter = (
  { __typename?: 'PressReleaseFilter' }
  & Pick<Types.PressReleaseFilter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleasePage = (
  { __typename?: 'PressReleasePage' }
  & Pick<Types.PressReleasePage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleasePlatform = (
  { __typename?: 'PressReleasePlatform' }
  & Pick<Types.PressReleasePlatform, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleasePlatformsFolder = (
  { __typename?: 'PressReleasePlatformsFolder' }
  & Pick<Types.PressReleasePlatformsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage = (
  { __typename?: 'PressReleaseSearchPage' }
  & Pick<Types.PressReleaseSearchPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f = (
  { __typename?: 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' }
  & Pick<Types.PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 = (
  { __typename?: 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' }
  & Pick<Types.PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d = (
  { __typename?: 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' }
  & Pick<Types.PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 = (
  { __typename?: 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' }
  & Pick<Types.PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage = (
  { __typename?: 'PressReleaseWildcardPage' }
  & Pick<Types.PressReleaseWildcardPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e = (
  { __typename?: 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' }
  & Pick<Types.PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 = (
  { __typename?: 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' }
  & Pick<Types.PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 = (
  { __typename?: 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' }
  & Pick<Types.PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 = (
  { __typename?: 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' }
  & Pick<Types.PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PressReleasesGroupFolder = (
  { __typename?: 'PressReleasesGroupFolder' }
  & Pick<Types.PressReleasesGroupFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PrivacyWarning = (
  { __typename?: 'PrivacyWarning' }
  & Pick<Types.PrivacyWarning, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ProjectFolder = (
  { __typename?: 'ProjectFolder' }
  & Pick<Types.ProjectFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Promo = (
  { __typename?: 'Promo' }
  & Pick<Types.Promo, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PromoFolder = (
  { __typename?: 'PromoFolder' }
  & Pick<Types.PromoFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PromoFolder_f07cbe8973ae4de692172570260cac6e = (
  { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' }
  & Pick<Types.PromoFolder_F07cbe8973ae4de692172570260cac6e, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 = (
  { __typename?: 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' }
  & Pick<Types.Promo_7f21f14d096b4f27bbccf115c6e6f6f1, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Promo_881869ca7f5845ea8b34ad1bfd3551a8 = (
  { __typename?: 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' }
  & Pick<Types.Promo_881869ca7f5845ea8b34ad1bfd3551a8, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Promo_dfed4457d760457abec1c0dccdc44381 = (
  { __typename?: 'Promo_dfed4457d760457abec1c0dccdc44381' }
  & Pick<Types.Promo_Dfed4457d760457abec1c0dccdc44381, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PromotedContent = (
  { __typename?: 'PromotedContent' }
  & Pick<Types.PromotedContent, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PromotedContentFolder = (
  { __typename?: 'PromotedContentFolder' }
  & Pick<Types.PromotedContentFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PropertyListingCard = (
  { __typename?: 'PropertyListingCard' }
  & Pick<Types.PropertyListingCard, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PropertyListingCards = (
  { __typename?: 'PropertyListingCards' }
  & Pick<Types.PropertyListingCards, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PropertyListingCategory = (
  { __typename?: 'PropertyListingCategory' }
  & Pick<Types.PropertyListingCategory, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_PropertyListingFolder = (
  { __typename?: 'PropertyListingFolder' }
  & Pick<Types.PropertyListingFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Query_98b413525a4b4067b92418a4b50f0a53 = (
  { __typename?: 'Query_98b413525a4b4067b92418a4b50f0a53' }
  & Pick<Types.Query_98b413525a4b4067b92418a4b50f0a53, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_QuickLinks = (
  { __typename?: 'QuickLinks' }
  & Pick<Types.QuickLinks, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_QuickLinksFolder = (
  { __typename?: 'QuickLinksFolder' }
  & Pick<Types.QuickLinksFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_QuickLinksParametersTemplate = (
  { __typename?: 'QuickLinksParametersTemplate' }
  & Pick<Types.QuickLinksParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_QuotationBlockItem = (
  { __typename?: 'QuotationBlockItem' }
  & Pick<Types.QuotationBlockItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_QuotationBlocks = (
  { __typename?: 'QuotationBlocks' }
  & Pick<Types.QuotationBlocks, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_QuotationBlocksFolder = (
  { __typename?: 'QuotationBlocksFolder' }
  & Pick<Types.QuotationBlocksFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_QuotationBlocksParametersTemplate = (
  { __typename?: 'QuotationBlocksParametersTemplate' }
  & Pick<Types.QuotationBlocksParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Quote = (
  { __typename?: 'Quote' }
  & Pick<Types.Quote, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_QuoteFolder = (
  { __typename?: 'QuoteFolder' }
  & Pick<Types.QuoteFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_QuoteParametersTemplate = (
  { __typename?: 'QuoteParametersTemplate' }
  & Pick<Types.QuoteParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RadiusFilter = (
  { __typename?: 'RadiusFilter' }
  & Pick<Types.RadiusFilter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RadiusFilterFolder = (
  { __typename?: 'RadiusFilterFolder' }
  & Pick<Types.RadiusFilterFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 = (
  { __typename?: 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' }
  & Pick<Types.RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RadiusScheme = (
  { __typename?: 'RadiusScheme' }
  & Pick<Types.RadiusScheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RadiusSchemeValue = (
  { __typename?: 'RadiusSchemeValue' }
  & Pick<Types.RadiusSchemeValue, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RangeSliderFilter = (
  { __typename?: 'RangeSliderFilter' }
  & Pick<Types.RangeSliderFilter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RangeSliderFilterFolder = (
  { __typename?: 'RangeSliderFilterFolder' }
  & Pick<Types.RangeSliderFilterFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 = (
  { __typename?: 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' }
  & Pick<Types.RangeSliderFilter_0a1787c296b54d40828522564a5d8e03, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RecentArticles = (
  { __typename?: 'RecentArticles' }
  & Pick<Types.RecentArticles, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Redirect = (
  { __typename?: 'Redirect' }
  & Pick<Types.Redirect, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RedirectMap = (
  { __typename?: 'RedirectMap' }
  & Pick<Types.RedirectMap, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RedirectMaps = (
  { __typename?: 'RedirectMaps' }
  & Pick<Types.RedirectMaps, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Region = (
  { __typename?: 'Region' }
  & Pick<Types.Region, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RegionLanguages = (
  { __typename?: 'RegionLanguages' }
  & Pick<Types.RegionLanguages, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RegionLanguagesFolder = (
  { __typename?: 'RegionLanguagesFolder' }
  & Pick<Types.RegionLanguagesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RelatedArticles = (
  { __typename?: 'RelatedArticles' }
  & Pick<Types.RelatedArticles, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RelatedArticlesParametersTemplate = (
  { __typename?: 'RelatedArticlesParametersTemplate' }
  & Pick<Types.RelatedArticlesParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RenderEngineType = (
  { __typename?: 'RenderEngineType' }
  & Pick<Types.RenderEngineType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RenderingFolder_840d4a46550349ecbf9dbd090946c63d = (
  { __typename?: 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' }
  & Pick<Types.RenderingFolder_840d4a46550349ecbf9dbd090946c63d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RenderingHost = (
  { __typename?: 'RenderingHost' }
  & Pick<Types.RenderingHost, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ResizableIFramePage = (
  { __typename?: 'ResizableIFramePage' }
  & Pick<Types.ResizableIFramePage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 = (
  { __typename?: 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' }
  & Pick<Types.ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 = (
  { __typename?: 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' }
  & Pick<Types.ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 = (
  { __typename?: 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' }
  & Pick<Types.ResizableIFramePage_B58eacfb27f5417bb536141f94b92521, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 = (
  { __typename?: 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' }
  & Pick<Types.ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_f460ab055585441892023750e7cef6b7 = (
  { __typename?: 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' }
  & Pick<Types.ResizableIFramePage_F460ab055585441892023750e7cef6b7, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ResponsiveImage = (
  { __typename?: 'ResponsiveImage' }
  & Pick<Types.ResponsiveImage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ResultsCount = (
  { __typename?: 'ResultsCount' }
  & Pick<Types.ResultsCount, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ResultsCountFolder = (
  { __typename?: 'ResultsCountFolder' }
  & Pick<Types.ResultsCountFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 = (
  { __typename?: 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' }
  & Pick<Types.ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ResultsVariantSelector = (
  { __typename?: 'ResultsVariantSelector' }
  & Pick<Types.ResultsVariantSelector, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RichText = (
  { __typename?: 'RichText' }
  & Pick<Types.RichText, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RichTextFolder = (
  { __typename?: 'RichTextFolder' }
  & Pick<Types.RichTextFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RichText_0f3b73366112418c8bbab0526f3887ce = (
  { __typename?: 'RichText_0f3b73366112418c8bbab0526f3887ce' }
  & Pick<Types.RichText_0f3b73366112418c8bbab0526f3887ce, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RichText_efcfd8f6596745f48f85b5421928205d = (
  { __typename?: 'RichText_efcfd8f6596745f48f85b5421928205d' }
  & Pick<Types.RichText_Efcfd8f6596745f48f85b5421928205d, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RiskImageMapping = (
  { __typename?: 'RiskImageMapping' }
  & Pick<Types.RiskImageMapping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RiskImageMappings = (
  { __typename?: 'RiskImageMappings' }
  & Pick<Types.RiskImageMappings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RiskLevelOption = (
  { __typename?: 'RiskLevelOption' }
  & Pick<Types.RiskLevelOption, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RiskLevelOptionFolder = (
  { __typename?: 'RiskLevelOptionFolder' }
  & Pick<Types.RiskLevelOptionFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RiskWarning = (
  { __typename?: 'RiskWarning' }
  & Pick<Types.RiskWarning, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RiskWarningFolder = (
  { __typename?: 'RiskWarningFolder' }
  & Pick<Types.RiskWarningFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RiskWarningParametersTemplate = (
  { __typename?: 'RiskWarningParametersTemplate' }
  & Pick<Types.RiskWarningParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RolePlaceholder = (
  { __typename?: 'RolePlaceholder' }
  & Pick<Types.RolePlaceholder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RowSplitter = (
  { __typename?: 'RowSplitter' }
  & Pick<Types.RowSplitter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_RowSplitter_340c887da1d1415b9678c763af74ea97 = (
  { __typename?: 'RowSplitter_340c887da1d1415b9678c763af74ea97' }
  & Pick<Types.RowSplitter_340c887da1d1415b9678c763af74ea97, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Rule = (
  { __typename?: 'Rule' }
  & Pick<Types.Rule, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SDRLogoMapping = (
  { __typename?: 'SDRLogoMapping' }
  & Pick<Types.SdrLogoMapping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SDRLogoMappings = (
  { __typename?: 'SDRLogoMappings' }
  & Pick<Types.SdrLogoMappings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SDRTypeOption = (
  { __typename?: 'SDRTypeOption' }
  & Pick<Types.SdrTypeOption, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SDRTypeOptionFolder = (
  { __typename?: 'SDRTypeOptionFolder' }
  & Pick<Types.SdrTypeOptionFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SXAJSSLayout = (
  { __typename?: 'SXAJSSLayout' }
  & Pick<Types.SxajssLayout, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SXARole = (
  { __typename?: 'SXARole' }
  & Pick<Types.SxaRole, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SXAStandardValuesFolder = (
  { __typename?: 'SXAStandardValuesFolder' }
  & Pick<Types.SxaStandardValuesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceAlertMessage = (
  { __typename?: 'SalesforceAlertMessage' }
  & Pick<Types.SalesforceAlertMessage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceCheckBox = (
  { __typename?: 'SalesforceCheckBox' }
  & Pick<Types.SalesforceCheckBox, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceCheckBoxType = (
  { __typename?: 'SalesforceCheckBoxType' }
  & Pick<Types.SalesforceCheckBoxType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButton = (
  { __typename?: 'SalesforceConditionalRadioButton' }
  & Pick<Types.SalesforceConditionalRadioButton, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButtons = (
  { __typename?: 'SalesforceConditionalRadioButtons' }
  & Pick<Types.SalesforceConditionalRadioButtons, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceDateInput = (
  { __typename?: 'SalesforceDateInput' }
  & Pick<Types.SalesforceDateInput, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceDropdown = (
  { __typename?: 'SalesforceDropdown' }
  & Pick<Types.SalesforceDropdown, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceDropdownOption = (
  { __typename?: 'SalesforceDropdownOption' }
  & Pick<Types.SalesforceDropdownOption, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceHiddenField = (
  { __typename?: 'SalesforceHiddenField' }
  & Pick<Types.SalesforceHiddenField, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceInput = (
  { __typename?: 'SalesforceInput' }
  & Pick<Types.SalesforceInput, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceInputType = (
  { __typename?: 'SalesforceInputType' }
  & Pick<Types.SalesforceInputType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedForm = (
  { __typename?: 'SalesforceIntegratedForm' }
  & Pick<Types.SalesforceIntegratedForm, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedFormTypesFolder = (
  { __typename?: 'SalesforceIntegratedFormTypesFolder' }
  & Pick<Types.SalesforceIntegratedFormTypesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceRepeatableSubSection = (
  { __typename?: 'SalesforceRepeatableSubSection' }
  & Pick<Types.SalesforceRepeatableSubSection, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceRichTextArea = (
  { __typename?: 'SalesforceRichTextArea' }
  & Pick<Types.SalesforceRichTextArea, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceSection = (
  { __typename?: 'SalesforceSection' }
  & Pick<Types.SalesforceSection, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceSortCodeInput = (
  { __typename?: 'SalesforceSortCodeInput' }
  & Pick<Types.SalesforceSortCodeInput, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SalesforceSubmissionType = (
  { __typename?: 'SalesforceSubmissionType' }
  & Pick<Types.SalesforceSubmissionType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Scope = (
  { __typename?: 'Scope' }
  & Pick<Types.Scope, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ScopesFolder = (
  { __typename?: 'ScopesFolder' }
  & Pick<Types.ScopesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Scriban = (
  { __typename?: 'Scriban' }
  & Pick<Types.Scriban, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Scripts = (
  { __typename?: 'Scripts' }
  & Pick<Types.Scripts, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SearchBox = (
  { __typename?: 'SearchBox' }
  & Pick<Types.SearchBox, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SearchBoxFolder = (
  { __typename?: 'SearchBoxFolder' }
  & Pick<Types.SearchBoxFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SearchBox_1c04fd611d874590acfe9cc186865ab3 = (
  { __typename?: 'SearchBox_1c04fd611d874590acfe9cc186865ab3' }
  & Pick<Types.SearchBox_1c04fd611d874590acfe9cc186865ab3, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SearchFolder = (
  { __typename?: 'SearchFolder' }
  & Pick<Types.SearchFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SearchResults = (
  { __typename?: 'SearchResults' }
  & Pick<Types.SearchResults, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SearchResultsFolder = (
  { __typename?: 'SearchResultsFolder' }
  & Pick<Types.SearchResultsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SearchResults_a06f7130041d46bb8c2995a2dc00c26a = (
  { __typename?: 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' }
  & Pick<Types.SearchResults_A06f7130041d46bb8c2995a2dc00c26a, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SecondaryHeroBannerParametersTemplate = (
  { __typename?: 'SecondaryHeroBannerParametersTemplate' }
  & Pick<Types.SecondaryHeroBannerParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SectionHeading = (
  { __typename?: 'SectionHeading' }
  & Pick<Types.SectionHeading, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SectionHeadingFolder = (
  { __typename?: 'SectionHeadingFolder' }
  & Pick<Types.SectionHeadingFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SectionHeadingParametersTemplate = (
  { __typename?: 'SectionHeadingParametersTemplate' }
  & Pick<Types.SectionHeadingParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SectionHeadingType = (
  { __typename?: 'SectionHeadingType' }
  & Pick<Types.SectionHeadingType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SectionHeadingTypeFolder = (
  { __typename?: 'SectionHeadingTypeFolder' }
  & Pick<Types.SectionHeadingTypeFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SectionSelector = (
  { __typename?: 'SectionSelector' }
  & Pick<Types.SectionSelector, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SectionSelectorFolder = (
  { __typename?: 'SectionSelectorFolder' }
  & Pick<Types.SectionSelectorFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SectionSelectorTab = (
  { __typename?: 'SectionSelectorTab' }
  & Pick<Types.SectionSelectorTab, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Security_33077d51ebad4d1cb4a83b79f51dba13 = (
  { __typename?: 'Security_33077d51ebad4d1cb4a83b79f51dba13' }
  & Pick<Types.Security_33077d51ebad4d1cb4a83b79f51dba13, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Series = (
  { __typename?: 'Series' }
  & Pick<Types.Series, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SeriesFolder = (
  { __typename?: 'SeriesFolder' }
  & Pick<Types.SeriesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Settings = (
  { __typename?: 'Settings' }
  & Pick<Types.Settings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SettingsFolder = (
  { __typename?: 'SettingsFolder' }
  & Pick<Types.SettingsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Settings_6c82caca67dc464195698faad083230e = (
  { __typename?: 'Settings_6c82caca67dc464195698faad083230e' }
  & Pick<Types.Settings_6c82caca67dc464195698faad083230e, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SharePriceSettings = (
  { __typename?: 'SharePriceSettings' }
  & Pick<Types.SharePriceSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SharedArticlesFolder = (
  { __typename?: 'SharedArticlesFolder' }
  & Pick<Types.SharedArticlesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SharedContentFolder = (
  { __typename?: 'SharedContentFolder' }
  & Pick<Types.SharedContentFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SharedFolder = (
  { __typename?: 'SharedFolder' }
  & Pick<Types.SharedFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SharedHelpArticlesFolder = (
  { __typename?: 'SharedHelpArticlesFolder' }
  & Pick<Types.SharedHelpArticlesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SharedPressReleasesFolder = (
  { __typename?: 'SharedPressReleasesFolder' }
  & Pick<Types.SharedPressReleasesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SharedSettingsFolder = (
  { __typename?: 'SharedSettingsFolder' }
  & Pick<Types.SharedSettingsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SharedSitesSettings = (
  { __typename?: 'SharedSitesSettings' }
  & Pick<Types.SharedSitesSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 = (
  { __typename?: 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' }
  & Pick<Types.SharedSitesSettings_C14bf746030f4e598594395f6d299e61, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Showcase = (
  { __typename?: 'Showcase' }
  & Pick<Types.Showcase, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ShowcaseFolder = (
  { __typename?: 'ShowcaseFolder' }
  & Pick<Types.ShowcaseFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ShowcaseItem = (
  { __typename?: 'ShowcaseItem' }
  & Pick<Types.ShowcaseItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ShowcaseParametersTemplate = (
  { __typename?: 'ShowcaseParametersTemplate' }
  & Pick<Types.ShowcaseParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Site = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SiteContentFolder = (
  { __typename?: 'SiteContentFolder' }
  & Pick<Types.SiteContentFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SiteDefinition = (
  { __typename?: 'SiteDefinition' }
  & Pick<Types.SiteDefinition, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SiteEntryDisclaimer = (
  { __typename?: 'SiteEntryDisclaimer' }
  & Pick<Types.SiteEntryDisclaimer, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SiteFolder = (
  { __typename?: 'SiteFolder' }
  & Pick<Types.SiteFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SiteGrouping = (
  { __typename?: 'SiteGrouping' }
  & Pick<Types.SiteGrouping, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SiteManagement = (
  { __typename?: 'SiteManagement' }
  & Pick<Types.SiteManagement, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SiteSecurityItemPointer = (
  { __typename?: 'SiteSecurityItemPointer' }
  & Pick<Types.SiteSecurityItemPointer, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SiteSelector = (
  { __typename?: 'SiteSelector' }
  & Pick<Types.SiteSelector, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 = (
  { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' }
  & Pick<Types.SiteSelector_A44632f56dcd4d10b4892f4e35e193c3, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SiteSetupRoot = (
  { __typename?: 'SiteSetupRoot' }
  & Pick<Types.SiteSetupRoot, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SiteTheme = (
  { __typename?: 'SiteTheme' }
  & Pick<Types.SiteTheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Site_e46f3af239fa4866a1577017c4b2a40c = (
  { __typename?: 'Site_e46f3af239fa4866a1577017c4b2a40c' }
  & Pick<Types.Site_E46f3af239fa4866a1577017c4b2a40c, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SitecoreFormWrapperParametersTemplate = (
  { __typename?: 'SitecoreFormWrapperParametersTemplate' }
  & Pick<Types.SitecoreFormWrapperParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SitecoreRole = (
  { __typename?: 'SitecoreRole' }
  & Pick<Types.SitecoreRole, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 = (
  { __typename?: 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' }
  & Pick<Types.SitemapSettings_C71d856635c849b7a84d9d176e9cbd05, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SkipLink = (
  { __typename?: 'SkipLink' }
  & Pick<Types.SkipLink, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SkipLinkParameters = (
  { __typename?: 'SkipLinkParameters' }
  & Pick<Types.SkipLinkParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SkipLinksFolder = (
  { __typename?: 'SkipLinksFolder' }
  & Pick<Types.SkipLinksFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Snippet = (
  { __typename?: 'Snippet' }
  & Pick<Types.Snippet, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SnippetItem = (
  { __typename?: 'SnippetItem' }
  & Pick<Types.SnippetItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SnippetsFolder = (
  { __typename?: 'SnippetsFolder' }
  & Pick<Types.SnippetsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SocialLoginWrapper = (
  { __typename?: 'SocialLoginWrapper' }
  & Pick<Types.SocialLoginWrapper, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SocialMediaButtons = (
  { __typename?: 'SocialMediaButtons' }
  & Pick<Types.SocialMediaButtons, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SocialMediaFolder = (
  { __typename?: 'SocialMediaFolder' }
  & Pick<Types.SocialMediaFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SocialMediaShare = (
  { __typename?: 'SocialMediaShare' }
  & Pick<Types.SocialMediaShare, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SocialMediaTemplate = (
  { __typename?: 'SocialMediaTemplate' }
  & Pick<Types.SocialMediaTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SocialNetwork = (
  { __typename?: 'SocialNetwork' }
  & Pick<Types.SocialNetwork, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SocialNetworkFolder = (
  { __typename?: 'SocialNetworkFolder' }
  & Pick<Types.SocialNetworkFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SocialNetworkLink = (
  { __typename?: 'SocialNetworkLink' }
  & Pick<Types.SocialNetworkLink, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SolutionTemplate = (
  { __typename?: 'SolutionTemplate' }
  & Pick<Types.SolutionTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SortResults = (
  { __typename?: 'SortResults' }
  & Pick<Types.SortResults, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SortResultsFolder = (
  { __typename?: 'SortResultsFolder' }
  & Pick<Types.SortResultsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Sorting = (
  { __typename?: 'Sorting' }
  & Pick<Types.Sorting, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SortingGroups = (
  { __typename?: 'SortingGroups' }
  & Pick<Types.SortingGroups, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SpotifyPodcast = (
  { __typename?: 'SpotifyPodcast' }
  & Pick<Types.SpotifyPodcast, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SpotifyPodcastFolder = (
  { __typename?: 'SpotifyPodcastFolder' }
  & Pick<Types.SpotifyPodcastFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_StickyCTA = (
  { __typename?: 'StickyCTA' }
  & Pick<Types.StickyCta, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_StickyCTAFolder = (
  { __typename?: 'StickyCTAFolder' }
  & Pick<Types.StickyCtaFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_StickyCTAParametersTemplate = (
  { __typename?: 'StickyCTAParametersTemplate' }
  & Pick<Types.StickyCtaParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_StrategiesInFocusFolder = (
  { __typename?: 'StrategiesInFocusFolder' }
  & Pick<Types.StrategiesInFocusFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_StrategyInFocus = (
  { __typename?: 'StrategyInFocus' }
  & Pick<Types.StrategyInFocus, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Style = (
  { __typename?: 'Style' }
  & Pick<Types.Style, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Styles = (
  { __typename?: 'Styles' }
  & Pick<Types.Styles, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Styles_9c0dac2808aa4b44bc2153363206f6a5 = (
  { __typename?: 'Styles_9c0dac2808aa4b44bc2153363206f6a5' }
  & Pick<Types.Styles_9c0dac2808aa4b44bc2153363206f6a5, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_SubscriptionBannerParametersTemplate = (
  { __typename?: 'SubscriptionBannerParametersTemplate' }
  & Pick<Types.SubscriptionBannerParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Tab = (
  { __typename?: 'Tab' }
  & Pick<Types.Tab, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TabItem = (
  { __typename?: 'TabItem' }
  & Pick<Types.TabItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TableOfContents = (
  { __typename?: 'TableOfContents' }
  & Pick<Types.TableOfContents, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TableOfContentsFolder = (
  { __typename?: 'TableOfContentsFolder' }
  & Pick<Types.TableOfContentsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TableOfContentsSection = (
  { __typename?: 'TableOfContentsSection' }
  & Pick<Types.TableOfContentsSection, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TableOfContentsSubsection = (
  { __typename?: 'TableOfContentsSubsection' }
  & Pick<Types.TableOfContentsSubsection, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Tabs = (
  { __typename?: 'Tabs' }
  & Pick<Types.Tabs, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TabsFolder = (
  { __typename?: 'TabsFolder' }
  & Pick<Types.TabsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Tabs_f26a9560ccf148c59542800e837caf7a = (
  { __typename?: 'Tabs_f26a9560ccf148c59542800e837caf7a' }
  & Pick<Types.Tabs_F26a9560ccf148c59542800e837caf7a, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Tag = (
  { __typename?: 'Tag' }
  & Pick<Types.Tag, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TagCloud = (
  { __typename?: 'TagCloud' }
  & Pick<Types.TagCloud, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TagFolder = (
  { __typename?: 'TagFolder' }
  & Pick<Types.TagFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TagList = (
  { __typename?: 'TagList' }
  & Pick<Types.TagList, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamBiographySettings = (
  { __typename?: 'TeamBiographySettings' }
  & Pick<Types.TeamBiographySettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamListingCards = (
  { __typename?: 'TeamListingCards' }
  & Pick<Types.TeamListingCards, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamListingCardsFolder = (
  { __typename?: 'TeamListingCardsFolder' }
  & Pick<Types.TeamListingCardsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMember = (
  { __typename?: 'TeamMember' }
  & Pick<Types.TeamMember, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMemberCard = (
  { __typename?: 'TeamMemberCard' }
  & Pick<Types.TeamMemberCard, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMembers = (
  { __typename?: 'TeamMembers' }
  & Pick<Types.TeamMembers, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage = (
  { __typename?: 'TeamMembersParentPage' }
  & Pick<Types.TeamMembersParentPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e = (
  { __typename?: 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' }
  & Pick<Types.TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e = (
  { __typename?: 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' }
  & Pick<Types.TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff = (
  { __typename?: 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' }
  & Pick<Types.TeamMembersParentPage_47f304d629a84648a0e2b942513133ff, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 = (
  { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' }
  & Pick<Types.TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 = (
  { __typename?: 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' }
  & Pick<Types.TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage = (
  { __typename?: 'TeamMembersWildcardPage' }
  & Pick<Types.TeamMembersWildcardPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e = (
  { __typename?: 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' }
  & Pick<Types.TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 = (
  { __typename?: 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' }
  & Pick<Types.TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a = (
  { __typename?: 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' }
  & Pick<Types.TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 = (
  { __typename?: 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' }
  & Pick<Types.TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 = (
  { __typename?: 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' }
  & Pick<Types.TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamProfileCards = (
  { __typename?: 'TeamProfileCards' }
  & Pick<Types.TeamProfileCards, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TeamProfileCardsFolder = (
  { __typename?: 'TeamProfileCardsFolder' }
  & Pick<Types.TeamProfileCardsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TechzoneArticlePage = (
  { __typename?: 'TechzoneArticlePage' }
  & Pick<Types.TechzoneArticlePage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Tenant = (
  { __typename?: 'Tenant' }
  & Pick<Types.Tenant, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TenantFolder = (
  { __typename?: 'TenantFolder' }
  & Pick<Types.TenantFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TenantSecurityItemPointer = (
  { __typename?: 'TenantSecurityItemPointer' }
  & Pick<Types.TenantSecurityItemPointer, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TenantSetupRoot = (
  { __typename?: 'TenantSetupRoot' }
  & Pick<Types.TenantSetupRoot, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TertieryHeroBanner = (
  { __typename?: 'TertieryHeroBanner' }
  & Pick<Types.TertieryHeroBanner, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TertieryHeroBannerParametersTemplate = (
  { __typename?: 'TertieryHeroBannerParametersTemplate' }
  & Pick<Types.TertieryHeroBannerParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Text = (
  { __typename?: 'Text' }
  & Pick<Types.Text, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TextBlock = (
  { __typename?: 'TextBlock' }
  & Pick<Types.TextBlock, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TextBlockHeadingParametersTemplate = (
  { __typename?: 'TextBlockHeadingParametersTemplate' }
  & Pick<Types.TextBlockHeadingParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TextBlockHeadingType = (
  { __typename?: 'TextBlockHeadingType' }
  & Pick<Types.TextBlockHeadingType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TextBlockHeadingTypeFolder = (
  { __typename?: 'TextBlockHeadingTypeFolder' }
  & Pick<Types.TextBlockHeadingTypeFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TextBlockLinkType = (
  { __typename?: 'TextBlockLinkType' }
  & Pick<Types.TextBlockLinkType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TextBlockLinkTypeFolder = (
  { __typename?: 'TextBlockLinkTypeFolder' }
  & Pick<Types.TextBlockLinkTypeFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TextBlocks = (
  { __typename?: 'TextBlocks' }
  & Pick<Types.TextBlocks, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TextBlocksFolder = (
  { __typename?: 'TextBlocksFolder' }
  & Pick<Types.TextBlocksFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TextBlocksParametersTemplate = (
  { __typename?: 'TextBlocksParametersTemplate' }
  & Pick<Types.TextBlocksParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TextFolder = (
  { __typename?: 'TextFolder' }
  & Pick<Types.TextFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TextFolder_b762d56787f5493cbb480c455d834457 = (
  { __typename?: 'TextFolder_b762d56787f5493cbb480c455d834457' }
  & Pick<Types.TextFolder_B762d56787f5493cbb480c455d834457, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Text_b8f5894cb4934016bf784090b0a2fd16 = (
  { __typename?: 'Text_b8f5894cb4934016bf784090b0a2fd16' }
  & Pick<Types.Text_B8f5894cb4934016bf784090b0a2fd16, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Theme = (
  { __typename?: 'Theme' }
  & Pick<Types.Theme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ThemeTag = (
  { __typename?: 'ThemeTag' }
  & Pick<Types.ThemeTag, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ThemeTagsFolder = (
  { __typename?: 'ThemeTagsFolder' }
  & Pick<Types.ThemeTagsFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ThemingMode = (
  { __typename?: 'ThemingMode' }
  & Pick<Types.ThemingMode, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ThemingModes = (
  { __typename?: 'ThemingModes' }
  & Pick<Types.ThemingModes, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Tile = (
  { __typename?: 'Tile' }
  & Pick<Types.Tile, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TileLink = (
  { __typename?: 'TileLink' }
  & Pick<Types.TileLink, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TileParametersTemplate = (
  { __typename?: 'TileParametersTemplate' }
  & Pick<Types.TileParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TileSizeOption = (
  { __typename?: 'TileSizeOption' }
  & Pick<Types.TileSizeOption, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TileSizeOptionFolder = (
  { __typename?: 'TileSizeOptionFolder' }
  & Pick<Types.TileSizeOptionFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TilesFolder = (
  { __typename?: 'TilesFolder' }
  & Pick<Types.TilesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TilesParametersTemplate = (
  { __typename?: 'TilesParametersTemplate' }
  & Pick<Types.TilesParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Title = (
  { __typename?: 'Title' }
  & Pick<Types.Title, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Title_a82e893105754175917de904ef7e6dbe = (
  { __typename?: 'Title_a82e893105754175917de904ef7e6dbe' }
  & Pick<Types.Title_A82e893105754175917de904ef7e6dbe, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Toggle = (
  { __typename?: 'Toggle' }
  & Pick<Types.Toggle, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_ToggleFolder = (
  { __typename?: 'ToggleFolder' }
  & Pick<Types.ToggleFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Toggle_8e4c968e9fa543a89ac4c0baf273ccde = (
  { __typename?: 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' }
  & Pick<Types.Toggle_8e4c968e9fa543a89ac4c0baf273ccde, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Transformation = (
  { __typename?: 'Transformation' }
  & Pick<Types.Transformation, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TrustArticleHeroParametersTemplate = (
  { __typename?: 'TrustArticleHeroParametersTemplate' }
  & Pick<Types.TrustArticleHeroParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TrustFinder = (
  { __typename?: 'TrustFinder' }
  & Pick<Types.TrustFinder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TrustFinderFilterOption = (
  { __typename?: 'TrustFinderFilterOption' }
  & Pick<Types.TrustFinderFilterOption, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TrustRegion = (
  { __typename?: 'TrustRegion' }
  & Pick<Types.TrustRegion, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TrustType = (
  { __typename?: 'TrustType' }
  & Pick<Types.TrustType, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TrustTypesFolder = (
  { __typename?: 'TrustTypesFolder' }
  & Pick<Types.TrustTypesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Twitter = (
  { __typename?: 'Twitter' }
  & Pick<Types.Twitter, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TwitterApp = (
  { __typename?: 'TwitterApp' }
  & Pick<Types.TwitterApp, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TwitterApps = (
  { __typename?: 'TwitterApps' }
  & Pick<Types.TwitterApps, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TwitterFolder = (
  { __typename?: 'TwitterFolder' }
  & Pick<Types.TwitterFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TwitterParametersTemplate = (
  { __typename?: 'TwitterParametersTemplate' }
  & Pick<Types.TwitterParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_TwitterSettings = (
  { __typename?: 'TwitterSettings' }
  & Pick<Types.TwitterSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_UnknownItem = (
  { __typename?: 'UnknownItem' }
  & Pick<Types.UnknownItem, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_UnminifiedFile = (
  { __typename?: 'UnminifiedFile' }
  & Pick<Types.UnminifiedFile, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_UpgradeScript = (
  { __typename?: 'UpgradeScript' }
  & Pick<Types.UpgradeScript, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_UpgradeScriptLibrary = (
  { __typename?: 'UpgradeScriptLibrary' }
  & Pick<Types.UpgradeScriptLibrary, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VariantComponentField = (
  { __typename?: 'VariantComponentField' }
  & Pick<Types.VariantComponentField, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VariantDateField = (
  { __typename?: 'VariantDateField' }
  & Pick<Types.VariantDateField, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 = (
  { __typename?: 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' }
  & Pick<Types.VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VariantPlaceholder = (
  { __typename?: 'VariantPlaceholder' }
  & Pick<Types.VariantPlaceholder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VariantReference = (
  { __typename?: 'VariantReference' }
  & Pick<Types.VariantReference, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VariantSection = (
  { __typename?: 'VariantSection' }
  & Pick<Types.VariantSection, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VariantTemplate = (
  { __typename?: 'VariantTemplate' }
  & Pick<Types.VariantTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VariantText = (
  { __typename?: 'VariantText' }
  & Pick<Types.VariantText, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VariantToken = (
  { __typename?: 'VariantToken' }
  & Pick<Types.VariantToken, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Variants = (
  { __typename?: 'Variants' }
  & Pick<Types.Variants, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VectorFolder = (
  { __typename?: 'VectorFolder' }
  & Pick<Types.VectorFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VectorTile = (
  { __typename?: 'VectorTile' }
  & Pick<Types.VectorTile, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VectorTileLink = (
  { __typename?: 'VectorTileLink' }
  & Pick<Types.VectorTileLink, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VectorTilesFolder = (
  { __typename?: 'VectorTilesFolder' }
  & Pick<Types.VectorTilesFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VectorTilesParametersTemplate = (
  { __typename?: 'VectorTilesParametersTemplate' }
  & Pick<Types.VectorTilesParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Version_95ebc23204774dc38ad3465d5fe8da2f = (
  { __typename?: 'Version_95ebc23204774dc38ad3465d5fe8da2f' }
  & Pick<Types.Version_95ebc23204774dc38ad3465d5fe8da2f, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Video = (
  { __typename?: 'Video' }
  & Pick<Types.Video, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VideoCountOption = (
  { __typename?: 'VideoCountOption' }
  & Pick<Types.VideoCountOption, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VideoCountOptions = (
  { __typename?: 'VideoCountOptions' }
  & Pick<Types.VideoCountOptions, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VideoFolder = (
  { __typename?: 'VideoFolder' }
  & Pick<Types.VideoFolder, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VideoFolder_bba49474673e468186ba8b1a20e067a9 = (
  { __typename?: 'VideoFolder_bba49474673e468186ba8b1a20e067a9' }
  & Pick<Types.VideoFolder_Bba49474673e468186ba8b1a20e067a9, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VideoPage = (
  { __typename?: 'VideoPage' }
  & Pick<Types.VideoPage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VideoParameters = (
  { __typename?: 'VideoParameters' }
  & Pick<Types.VideoParameters, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VideoParametersTemplate = (
  { __typename?: 'VideoParametersTemplate' }
  & Pick<Types.VideoParametersTemplate, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_VideoPressReleasePage = (
  { __typename?: 'VideoPressReleasePage' }
  & Pick<Types.VideoPressReleasePage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results_Video_4bc649610a894242be2dc5026090cf49 = (
  { __typename?: 'Video_4bc649610a894242be2dc5026090cf49' }
  & Pick<Types.Video_4bc649610a894242be2dc5026090cf49, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__AssetsOptimization = (
  { __typename?: '_AssetsOptimization' }
  & Pick<Types._AssetsOptimization, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__BackgroundImage = (
  { __typename?: '_BackgroundImage' }
  & Pick<Types._BackgroundImage, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__CompatibleThemes = (
  { __typename?: '_CompatibleThemes' }
  & Pick<Types._CompatibleThemes, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__CompositeTheme = (
  { __typename?: '_CompositeTheme' }
  & Pick<Types._CompositeTheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__CustomMetadata = (
  { __typename?: '_CustomMetadata' }
  & Pick<Types._CustomMetadata, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__CustomRenderingViewPath = (
  { __typename?: '_CustomRenderingViewPath' }
  & Pick<Types._CustomRenderingViewPath, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__DatasourceBehaviour = (
  { __typename?: '_DatasourceBehaviour' }
  & Pick<Types._DatasourceBehaviour, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__Favicon = (
  { __typename?: '_Favicon' }
  & Pick<Types._Favicon, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__FormsFolderLocation = (
  { __typename?: '_FormsFolderLocation' }
  & Pick<Types._FormsFolderLocation, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__FundSettings = (
  { __typename?: '_FundSettings' }
  & Pick<Types._FundSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__HasValidUrlName = (
  { __typename?: '_HasValidUrlName' }
  & Pick<Types._HasValidUrlName, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__LocalDataLink = (
  { __typename?: '_LocalDataLink' }
  & Pick<Types._LocalDataLink, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__Login = (
  { __typename?: '_Login' }
  & Pick<Types._Login, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__OpenGraphMetadata = (
  { __typename?: '_OpenGraphMetadata' }
  & Pick<Types._OpenGraphMetadata, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__PageDesignTheme = (
  { __typename?: '_PageDesignTheme' }
  & Pick<Types._PageDesignTheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__PageSearchScope = (
  { __typename?: '_PageSearchScope' }
  & Pick<Types._PageSearchScope, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__SearchCriteria = (
  { __typename?: '_SearchCriteria' }
  & Pick<Types._SearchCriteria, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__SearchableWithoutRelatedItems = (
  { __typename?: '_SearchableWithoutRelatedItems' }
  & Pick<Types._SearchableWithoutRelatedItems, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__SeoMetadata = (
  { __typename?: '_SeoMetadata' }
  & Pick<Types._SeoMetadata, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__SiteTheme = (
  { __typename?: '_SiteTheme' }
  & Pick<Types._SiteTheme, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__SitemapSettings = (
  { __typename?: '_SitemapSettings' }
  & Pick<Types._SitemapSettings, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__StickyNote = (
  { __typename?: '_StickyNote' }
  & Pick<Types._StickyNote, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__Styleable = (
  { __typename?: '_Styleable' }
  & Pick<Types._Styleable, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__TwitterMetadata = (
  { __typename?: '_TwitterMetadata' }
  & Pick<Types._TwitterMetadata, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__Webinar = (
  { __typename?: '_Webinar' }
  & Pick<Types._Webinar, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results__WildcardSource = (
  { __typename?: '_WildcardSource' }
  & Pick<Types._WildcardSource, 'id'>
);

export type TrustSearchQuery_search_ItemSearchResults_results = TrustSearchQuery_search_ItemSearchResults_results_Accordion | TrustSearchQuery_search_ItemSearchResults_results_AccordionFolder | TrustSearchQuery_search_ItemSearchResults_results_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 | TrustSearchQuery_search_ItemSearchResults_results_AccordionItem | TrustSearchQuery_search_ItemSearchResults_results_AccordionItem_8cf671721b2d489e809f4c23db5ab2da | TrustSearchQuery_search_ItemSearchResults_results_AccordionParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_AccordionPresentation | TrustSearchQuery_search_ItemSearchResults_results_AccordionPresentationFolder | TrustSearchQuery_search_ItemSearchResults_results_Accordion_02d060598cc14423a9ac9ff2365176b7 | TrustSearchQuery_search_ItemSearchResults_results_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 | TrustSearchQuery_search_ItemSearchResults_results_AddItem | TrustSearchQuery_search_ItemSearchResults_results_AddItem_1e1b739ec3784909941d171aca7362e5 | TrustSearchQuery_search_ItemSearchResults_results_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 | TrustSearchQuery_search_ItemSearchResults_results_AddItem_de8c75222f3241288f20342f479894eb | TrustSearchQuery_search_ItemSearchResults_results_AddItem_ea8a3f269ccd443a95f571b868a94bd0 | TrustSearchQuery_search_ItemSearchResults_results_AddThisParameters | TrustSearchQuery_search_ItemSearchResults_results_AggregatedFacetFilter | TrustSearchQuery_search_ItemSearchResults_results_AlertMessage | TrustSearchQuery_search_ItemSearchResults_results_AlertMessageFolder | TrustSearchQuery_search_ItemSearchResults_results_AlertMessageParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_AlertMessageType | TrustSearchQuery_search_ItemSearchResults_results_AllertMessageTypeFolder | TrustSearchQuery_search_ItemSearchResults_results_Archive | TrustSearchQuery_search_ItemSearchResults_results_ArticleAuthor | TrustSearchQuery_search_ItemSearchResults_results_ArticleAuthorsFolder | TrustSearchQuery_search_ItemSearchResults_results_ArticleCategoriesFolder | TrustSearchQuery_search_ItemSearchResults_results_ArticleCategory | TrustSearchQuery_search_ItemSearchResults_results_ArticleChapter | TrustSearchQuery_search_ItemSearchResults_results_ArticleChapters | TrustSearchQuery_search_ItemSearchResults_results_ArticleContentType | TrustSearchQuery_search_ItemSearchResults_results_ArticleContentTypesFolder | TrustSearchQuery_search_ItemSearchResults_results_ArticleFilter | TrustSearchQuery_search_ItemSearchResults_results_ArticleFilterOption | TrustSearchQuery_search_ItemSearchResults_results_ArticleFootnote | TrustSearchQuery_search_ItemSearchResults_results_ArticleFootnoteLink | TrustSearchQuery_search_ItemSearchResults_results_ArticleFootnoteText | TrustSearchQuery_search_ItemSearchResults_results_ArticleInfogramTile | TrustSearchQuery_search_ItemSearchResults_results_ArticleInfogramTileParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_ArticlePage | TrustSearchQuery_search_ItemSearchResults_results_ArticleRegion | TrustSearchQuery_search_ItemSearchResults_results_ArticleRegionsFolder | TrustSearchQuery_search_ItemSearchResults_results_ArticleSearchPage | TrustSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c | TrustSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 | TrustSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_be414ff574ac4203abb2694811443e25 | TrustSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c | TrustSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 | TrustSearchQuery_search_ItemSearchResults_results_ArticleSeriesCollection | TrustSearchQuery_search_ItemSearchResults_results_ArticleSeriesFolder | TrustSearchQuery_search_ItemSearchResults_results_ArticleSettings | TrustSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBanner | TrustSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBannerFolder | TrustSearchQuery_search_ItemSearchResults_results_ArticleTag | TrustSearchQuery_search_ItemSearchResults_results_ArticleTagsFolder | TrustSearchQuery_search_ItemSearchResults_results_ArticleTeamAuthor | TrustSearchQuery_search_ItemSearchResults_results_ArticleTileParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_ArticleTilesParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f | TrustSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 | TrustSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca | TrustSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c | TrustSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 | TrustSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b | TrustSearchQuery_search_ItemSearchResults_results_ArticlesGroupFolder | TrustSearchQuery_search_ItemSearchResults_results_AttachThemeExtension | TrustSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListings | TrustSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListingsFolder | TrustSearchQuery_search_ItemSearchResults_results_AvailableJSONRenderings | TrustSearchQuery_search_ItemSearchResults_results_AvailableMetaRenderings | TrustSearchQuery_search_ItemSearchResults_results_AvailableRenderings | TrustSearchQuery_search_ItemSearchResults_results_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb | TrustSearchQuery_search_ItemSearchResults_results_AwardsBanner | TrustSearchQuery_search_ItemSearchResults_results_AwardsBannerFolder | TrustSearchQuery_search_ItemSearchResults_results_AwardsBannerImage | TrustSearchQuery_search_ItemSearchResults_results_AwardsBannerParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_BYOCWrapperRenderingParameters | TrustSearchQuery_search_ItemSearchResults_results_BackgroundColorOption | TrustSearchQuery_search_ItemSearchResults_results_BackgroundColorOptionFolder | TrustSearchQuery_search_ItemSearchResults_results_BannerFolder | TrustSearchQuery_search_ItemSearchResults_results_BannerType | TrustSearchQuery_search_ItemSearchResults_results_BannerTypeFolder | TrustSearchQuery_search_ItemSearchResults_results_BaseHeading | TrustSearchQuery_search_ItemSearchResults_results_BaseHeadingFolder | TrustSearchQuery_search_ItemSearchResults_results_BoolFacet | TrustSearchQuery_search_ItemSearchResults_results_BranchesFolder | TrustSearchQuery_search_ItemSearchResults_results_Breadcrumb | TrustSearchQuery_search_ItemSearchResults_results_BrowserTitleDefinition | TrustSearchQuery_search_ItemSearchResults_results_CORSEntry | TrustSearchQuery_search_ItemSearchResults_results_CORSGrouping | TrustSearchQuery_search_ItemSearchResults_results_CTAPresentationType | TrustSearchQuery_search_ItemSearchResults_results_CTAPresentationTypeFolder | TrustSearchQuery_search_ItemSearchResults_results_C__AbrdnPage | TrustSearchQuery_search_ItemSearchResults_results_C__ActionBase | TrustSearchQuery_search_ItemSearchResults_results_C__AdvancedParameter | TrustSearchQuery_search_ItemSearchResults_results_C__App | TrustSearchQuery_search_ItemSearchResults_results_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c | TrustSearchQuery_search_ItemSearchResults_results_C__ArticleWildcardPage | TrustSearchQuery_search_ItemSearchResults_results_C__AvailableRenderingsFolder | TrustSearchQuery_search_ItemSearchResults_results_C__BYOCRenderingParameters | TrustSearchQuery_search_ItemSearchResults_results_C__BackgroundParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_C__BaseCTA | TrustSearchQuery_search_ItemSearchResults_results_C__BasePage | TrustSearchQuery_search_ItemSearchResults_results_C__BasePage_037da552a5524fe4aeee331f57ac1378 | TrustSearchQuery_search_ItemSearchResults_results_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f | TrustSearchQuery_search_ItemSearchResults_results_C__BasePage_315fd21bebf04c9d9f00bae191442f1d | TrustSearchQuery_search_ItemSearchResults_results_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd | TrustSearchQuery_search_ItemSearchResults_results_C__BasePage_728c97b5c56146d9807e21018a972bb5 | TrustSearchQuery_search_ItemSearchResults_results_C__BasePage_6105875085f346729dfc8d133b481f26 | TrustSearchQuery_search_ItemSearchResults_results_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b | TrustSearchQuery_search_ItemSearchResults_results_C__BaseRenderingParameters | TrustSearchQuery_search_ItemSearchResults_results_C__BaseTheme | TrustSearchQuery_search_ItemSearchResults_results_C__BaseVariantField | TrustSearchQuery_search_ItemSearchResults_results_C__Class | TrustSearchQuery_search_ItemSearchResults_results_C__CompositeGroup | TrustSearchQuery_search_ItemSearchResults_results_C__CompositeSection | TrustSearchQuery_search_ItemSearchResults_results_C__EloquaForm | TrustSearchQuery_search_ItemSearchResults_results_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d | TrustSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions | TrustSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 | TrustSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 | TrustSearchQuery_search_ItemSearchResults_results_C__FEaaSRenderingParameters | TrustSearchQuery_search_ItemSearchResults_results_C__FacetSelectorConfigBase | TrustSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 | TrustSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b | TrustSearchQuery_search_ItemSearchResults_results_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 | TrustSearchQuery_search_ItemSearchResults_results_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 | TrustSearchQuery_search_ItemSearchResults_results_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc | TrustSearchQuery_search_ItemSearchResults_results_C__GlobalDatasourceBehavior | TrustSearchQuery_search_ItemSearchResults_results_C__GridDefinition | TrustSearchQuery_search_ItemSearchResults_results_C__GridItemBase | TrustSearchQuery_search_ItemSearchResults_results_C__GridParameters | TrustSearchQuery_search_ItemSearchResults_results_C__HeadlessSite | TrustSearchQuery_search_ItemSearchResults_results_C__HeadlessTenant | TrustSearchQuery_search_ItemSearchResults_results_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b | TrustSearchQuery_search_ItemSearchResults_results_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d | TrustSearchQuery_search_ItemSearchResults_results_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d | TrustSearchQuery_search_ItemSearchResults_results_C__IAllowEmpty | TrustSearchQuery_search_ItemSearchResults_results_C__IBaseVariantDefinition | TrustSearchQuery_search_ItemSearchResults_results_C__IBoosting | TrustSearchQuery_search_ItemSearchResults_results_C__ICacheable | TrustSearchQuery_search_ItemSearchResults_results_C__ICompatibleRenderings | TrustSearchQuery_search_ItemSearchResults_results_C__IComponentVariant | TrustSearchQuery_search_ItemSearchResults_results_C__IControlType | TrustSearchQuery_search_ItemSearchResults_results_C__IDynamicPlaceholder | TrustSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsDataSourceTemplates | TrustSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsEditorScriptURL | TrustSearchQuery_search_ItemSearchResults_results_C__IIcon | TrustSearchQuery_search_ItemSearchResults_results_C__ILocation | TrustSearchQuery_search_ItemSearchResults_results_C__IPaginable | TrustSearchQuery_search_ItemSearchResults_results_C__IPagination | TrustSearchQuery_search_ItemSearchResults_results_C__IPoi | TrustSearchQuery_search_ItemSearchResults_results_C__IRenderingId | TrustSearchQuery_search_ItemSearchResults_results_C__ISplitter | TrustSearchQuery_search_ItemSearchResults_results_C__IStyling | TrustSearchQuery_search_ItemSearchResults_results_C__IVariantDefinition | TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage | TrustSearchQuery_search_ItemSearchResults_results_C__JSONField | TrustSearchQuery_search_ItemSearchResults_results_C__JSONReference | TrustSearchQuery_search_ItemSearchResults_results_C__JSSData | TrustSearchQuery_search_ItemSearchResults_results_C__JSSSettings | TrustSearchQuery_search_ItemSearchResults_results_C__JSSSiteFolder | TrustSearchQuery_search_ItemSearchResults_results_C__JssRootFolder | TrustSearchQuery_search_ItemSearchResults_results_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 | TrustSearchQuery_search_ItemSearchResults_results_C__Navigation_e6d98f24d01c419e871a4617125a49ed | TrustSearchQuery_search_ItemSearchResults_results_C__Page | TrustSearchQuery_search_ItemSearchResults_results_C__PageData | TrustSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder | TrustSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd | TrustSearchQuery_search_ItemSearchResults_results_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 | TrustSearchQuery_search_ItemSearchResults_results_C__PartialDesign | TrustSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder | TrustSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d | TrustSearchQuery_search_ItemSearchResults_results_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d | TrustSearchQuery_search_ItemSearchResults_results_C__PlaceholderWrapper | TrustSearchQuery_search_ItemSearchResults_results_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac | TrustSearchQuery_search_ItemSearchResults_results_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b | TrustSearchQuery_search_ItemSearchResults_results_C__RedirectMapGrouping | TrustSearchQuery_search_ItemSearchResults_results_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 | TrustSearchQuery_search_ItemSearchResults_results_C__Route | TrustSearchQuery_search_ItemSearchResults_results_C__SimpleVideo | TrustSearchQuery_search_ItemSearchResults_results_C__SiteSettingsFolder | TrustSearchQuery_search_ItemSearchResults_results_C__SitemapSettings | TrustSearchQuery_search_ItemSearchResults_results_C__StandardTemplate | TrustSearchQuery_search_ItemSearchResults_results_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c | TrustSearchQuery_search_ItemSearchResults_results_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 | TrustSearchQuery_search_ItemSearchResults_results_C__TrustFolder | TrustSearchQuery_search_ItemSearchResults_results_C__VariantDefinition | TrustSearchQuery_search_ItemSearchResults_results_C__VariantField | TrustSearchQuery_search_ItemSearchResults_results_C__VariantsGrouping | TrustSearchQuery_search_ItemSearchResults_results_C___AdvancedItem | TrustSearchQuery_search_ItemSearchResults_results_C___Arguments | TrustSearchQuery_search_ItemSearchResults_results_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 | TrustSearchQuery_search_ItemSearchResults_results_C___Article | TrustSearchQuery_search_ItemSearchResults_results_C___ArticlePageWorkflow | TrustSearchQuery_search_ItemSearchResults_results_C___ArticleSearchPage | TrustSearchQuery_search_ItemSearchResults_results_C___ArticleWildcard | TrustSearchQuery_search_ItemSearchResults_results_C___AssetServiceThemeMode | TrustSearchQuery_search_ItemSearchResults_results_C___BaseArticle | TrustSearchQuery_search_ItemSearchResults_results_C___BaseDataFolder | TrustSearchQuery_search_ItemSearchResults_results_C___BaseHelpArticle | TrustSearchQuery_search_ItemSearchResults_results_C___BaseInvestmentTrust | TrustSearchQuery_search_ItemSearchResults_results_C___BaseJSSTenant | TrustSearchQuery_search_ItemSearchResults_results_C___BasePage | TrustSearchQuery_search_ItemSearchResults_results_C___BasePageDesign | TrustSearchQuery_search_ItemSearchResults_results_C___BasePageDesignFolder | TrustSearchQuery_search_ItemSearchResults_results_C___BasePartialDesign | TrustSearchQuery_search_ItemSearchResults_results_C___BasePartialDesignFolder | TrustSearchQuery_search_ItemSearchResults_results_C___BasePlaceholder | TrustSearchQuery_search_ItemSearchResults_results_C___BasePlaceholderSettingsFolder | TrustSearchQuery_search_ItemSearchResults_results_C___BasePresentation | TrustSearchQuery_search_ItemSearchResults_results_C___BasePressRelease | TrustSearchQuery_search_ItemSearchResults_results_C___BaseRenderingParameters | TrustSearchQuery_search_ItemSearchResults_results_C___BaseSXAStandardValuesFolder | TrustSearchQuery_search_ItemSearchResults_results_C___BaseSettings | TrustSearchQuery_search_ItemSearchResults_results_C___BaseSharedSitesSettings | TrustSearchQuery_search_ItemSearchResults_results_C___BaseSiteDefinition | TrustSearchQuery_search_ItemSearchResults_results_C___BaseSiteFolder | TrustSearchQuery_search_ItemSearchResults_results_C___BaseSiteGrouping | TrustSearchQuery_search_ItemSearchResults_results_C___BaseSiteRoot | TrustSearchQuery_search_ItemSearchResults_results_C___BaseTenant | TrustSearchQuery_search_ItemSearchResults_results_C___BaseTenantFolder | TrustSearchQuery_search_ItemSearchResults_results_C___BucketRules | TrustSearchQuery_search_ItemSearchResults_results_C___CORS | TrustSearchQuery_search_ItemSearchResults_results_C___Content | TrustSearchQuery_search_ItemSearchResults_results_C___ContentType | TrustSearchQuery_search_ItemSearchResults_results_C___DataAttributes | TrustSearchQuery_search_ItemSearchResults_results_C___DatasourceWorkflow | TrustSearchQuery_search_ItemSearchResults_results_C___Dependencies | TrustSearchQuery_search_ItemSearchResults_results_C___Description | TrustSearchQuery_search_ItemSearchResults_results_C___DesignTemplateMapping | TrustSearchQuery_search_ItemSearchResults_results_C___Designable | TrustSearchQuery_search_ItemSearchResults_results_C___EditType | TrustSearchQuery_search_ItemSearchResults_results_C___EditType_8a9f84baaa124c5d9096935714809da4 | TrustSearchQuery_search_ItemSearchResults_results_C___EditingTheme | TrustSearchQuery_search_ItemSearchResults_results_C___Enabled | TrustSearchQuery_search_ItemSearchResults_results_C___ErrorHandling | TrustSearchQuery_search_ItemSearchResults_results_C___ExternalArticle | TrustSearchQuery_search_ItemSearchResults_results_C___Fields | TrustSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesParent | TrustSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesWildcard | TrustSearchQuery_search_ItemSearchResults_results_C___Footnotes | TrustSearchQuery_search_ItemSearchResults_results_C___FundDetailsWildcard | TrustSearchQuery_search_ItemSearchResults_results_C___FundFormAvailability | TrustSearchQuery_search_ItemSearchResults_results_C___FundMetadataPage | TrustSearchQuery_search_ItemSearchResults_results_C___FundSearchPage | TrustSearchQuery_search_ItemSearchResults_results_C___FundsFolder | TrustSearchQuery_search_ItemSearchResults_results_C___FundsFormsFolder | TrustSearchQuery_search_ItemSearchResults_results_C___FundsLiteratureFolder | TrustSearchQuery_search_ItemSearchResults_results_C___FundsShareclassesDetailsWildcard | TrustSearchQuery_search_ItemSearchResults_results_C___GridMapping | TrustSearchQuery_search_ItemSearchResults_results_C___HelpArticle | TrustSearchQuery_search_ItemSearchResults_results_C___HelpArticleSearchPage | TrustSearchQuery_search_ItemSearchResults_results_C___HelpArticleWildcard | TrustSearchQuery_search_ItemSearchResults_results_C___HorizonDatasourceGrouping | TrustSearchQuery_search_ItemSearchResults_results_C___Icon | TrustSearchQuery_search_ItemSearchResults_results_C___IncludeByDefault | TrustSearchQuery_search_ItemSearchResults_results_C___IncludeIfInstalled | TrustSearchQuery_search_ItemSearchResults_results_C___InternalArticle | TrustSearchQuery_search_ItemSearchResults_results_C___InternetExplorerCompatibilityMode | TrustSearchQuery_search_ItemSearchResults_results_C___IsSystemModule | TrustSearchQuery_search_ItemSearchResults_results_C___JSONVariantPaging | TrustSearchQuery_search_ItemSearchResults_results_C___JSONVariantsBase | TrustSearchQuery_search_ItemSearchResults_results_C___LimitedDisplay | TrustSearchQuery_search_ItemSearchResults_results_C___LinkAttributes | TrustSearchQuery_search_ItemSearchResults_results_C___LinkSettings | TrustSearchQuery_search_ItemSearchResults_results_C___LiteratureHubSearchPage | TrustSearchQuery_search_ItemSearchResults_results_C___ManualKeyInformation | TrustSearchQuery_search_ItemSearchResults_results_C___MemberOf | TrustSearchQuery_search_ItemSearchResults_results_C___MetadataPage | TrustSearchQuery_search_ItemSearchResults_results_C___Modules | TrustSearchQuery_search_ItemSearchResults_results_C___Name | TrustSearchQuery_search_ItemSearchResults_results_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d | TrustSearchQuery_search_ItemSearchResults_results_C___Name_299cdb154745448a807868d401248eaa | TrustSearchQuery_search_ItemSearchResults_results_C___Name_b88cf88159a54a19991e71038751cb60 | TrustSearchQuery_search_ItemSearchResults_results_C___Navigable | TrustSearchQuery_search_ItemSearchResults_results_C___NavigablePage | TrustSearchQuery_search_ItemSearchResults_results_C___PageContent | TrustSearchQuery_search_ItemSearchResults_results_C___PageWorkflow | TrustSearchQuery_search_ItemSearchResults_results_C___PerSiteStandardValues | TrustSearchQuery_search_ItemSearchResults_results_C___Podcast | TrustSearchQuery_search_ItemSearchResults_results_C___PodcastPressRelease | TrustSearchQuery_search_ItemSearchResults_results_C___PremiumContentPage | TrustSearchQuery_search_ItemSearchResults_results_C___PressRelease | TrustSearchQuery_search_ItemSearchResults_results_C___PressReleaseContentType | TrustSearchQuery_search_ItemSearchResults_results_C___PressReleaseSearchPage | TrustSearchQuery_search_ItemSearchResults_results_C___PressReleaseWildcard | TrustSearchQuery_search_ItemSearchResults_results_C___ProtectedTheme | TrustSearchQuery_search_ItemSearchResults_results_C___PublishingGroupingTemplate | TrustSearchQuery_search_ItemSearchResults_results_C___RenderingRelatedParameters | TrustSearchQuery_search_ItemSearchResults_results_C___RenderingVariantsBase | TrustSearchQuery_search_ItemSearchResults_results_C___RenderingsList | TrustSearchQuery_search_ItemSearchResults_results_C___RobotsContent | TrustSearchQuery_search_ItemSearchResults_results_C___RoleDomain | TrustSearchQuery_search_ItemSearchResults_results_C___RoleName | TrustSearchQuery_search_ItemSearchResults_results_C___RoleType | TrustSearchQuery_search_ItemSearchResults_results_C___SalesforceCommonValidations | TrustSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldId | TrustSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldTitle | TrustSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldValue | TrustSearchQuery_search_ItemSearchResults_results_C___Script | TrustSearchQuery_search_ItemSearchResults_results_C___SearchSignature | TrustSearchQuery_search_ItemSearchResults_results_C___Searchable | TrustSearchQuery_search_ItemSearchResults_results_C___SecurityItemPointer | TrustSearchQuery_search_ItemSearchResults_results_C___SharedArticles | TrustSearchQuery_search_ItemSearchResults_results_C___SharedContent | TrustSearchQuery_search_ItemSearchResults_results_C___SharedHelpArticles | TrustSearchQuery_search_ItemSearchResults_results_C___SharedPage | TrustSearchQuery_search_ItemSearchResults_results_C___SharedPressReleases | TrustSearchQuery_search_ItemSearchResults_results_C___SharedRoot | TrustSearchQuery_search_ItemSearchResults_results_C___SharedSettings | TrustSearchQuery_search_ItemSearchResults_results_C___SiteContent | TrustSearchQuery_search_ItemSearchResults_results_C___SiteFolder | TrustSearchQuery_search_ItemSearchResults_results_C___SiteMediaLibrary | TrustSearchQuery_search_ItemSearchResults_results_C___SiteSettings | TrustSearchQuery_search_ItemSearchResults_results_C___SiteTemplate | TrustSearchQuery_search_ItemSearchResults_results_C___SitecoreClientSiteManaging | TrustSearchQuery_search_ItemSearchResults_results_C___Sitemap | TrustSearchQuery_search_ItemSearchResults_results_C___SitemapMediaItems | TrustSearchQuery_search_ItemSearchResults_results_C___SlidersRangeSettings | TrustSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateContent | TrustSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateDescription | TrustSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateName | TrustSearchQuery_search_ItemSearchResults_results_C___SortOrder | TrustSearchQuery_search_ItemSearchResults_results_C___StackBreakpoint | TrustSearchQuery_search_ItemSearchResults_results_C___Statistics | TrustSearchQuery_search_ItemSearchResults_results_C___SupportedLanguages | TrustSearchQuery_search_ItemSearchResults_results_C___Taggable | TrustSearchQuery_search_ItemSearchResults_results_C___TeamMembersParentPage | TrustSearchQuery_search_ItemSearchResults_results_C___TeamMembersWildcard | TrustSearchQuery_search_ItemSearchResults_results_C___TechzoneArticle | TrustSearchQuery_search_ItemSearchResults_results_C___Template | TrustSearchQuery_search_ItemSearchResults_results_C___Title | TrustSearchQuery_search_ItemSearchResults_results_C___Type | TrustSearchQuery_search_ItemSearchResults_results_C___Validation | TrustSearchQuery_search_ItemSearchResults_results_C___VariantPaging | TrustSearchQuery_search_ItemSearchResults_results_C___VectorTile | TrustSearchQuery_search_ItemSearchResults_results_C___VectorTileLink | TrustSearchQuery_search_ItemSearchResults_results_C___Video | TrustSearchQuery_search_ItemSearchResults_results_C___VideoPressRelease | TrustSearchQuery_search_ItemSearchResults_results_C___Width | TrustSearchQuery_search_ItemSearchResults_results_C___WildcardPage | TrustSearchQuery_search_ItemSearchResults_results_CacheSetting | TrustSearchQuery_search_ItemSearchResults_results_Caching_26fce9bf0256458d8281a713a5bf5520 | TrustSearchQuery_search_ItemSearchResults_results_CalendarEvent | TrustSearchQuery_search_ItemSearchResults_results_CallOutSection | TrustSearchQuery_search_ItemSearchResults_results_CallOutSectionDropdownOption | TrustSearchQuery_search_ItemSearchResults_results_CallOutSectionFolder | TrustSearchQuery_search_ItemSearchResults_results_CallOutSectionParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_CallToAction | TrustSearchQuery_search_ItemSearchResults_results_CallToActionFolder | TrustSearchQuery_search_ItemSearchResults_results_CapabilitiesFolder | TrustSearchQuery_search_ItemSearchResults_results_Capability | TrustSearchQuery_search_ItemSearchResults_results_CapabilityMap | TrustSearchQuery_search_ItemSearchResults_results_CapabilityMappings | TrustSearchQuery_search_ItemSearchResults_results_Carousel | TrustSearchQuery_search_ItemSearchResults_results_CarouselFolder | TrustSearchQuery_search_ItemSearchResults_results_CarouselSlide | TrustSearchQuery_search_ItemSearchResults_results_Carousel_2b65f0d87ec54834b4aa1753c0f7036b | TrustSearchQuery_search_ItemSearchResults_results_Checkbox | TrustSearchQuery_search_ItemSearchResults_results_ChecklistFilter | TrustSearchQuery_search_ItemSearchResults_results_ChecklistFilterFolder | TrustSearchQuery_search_ItemSearchResults_results_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee | TrustSearchQuery_search_ItemSearchResults_results_ColumnSplitter | TrustSearchQuery_search_ItemSearchResults_results_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 | TrustSearchQuery_search_ItemSearchResults_results_CompatibilityMode | TrustSearchQuery_search_ItemSearchResults_results_ComponentConfiguration | TrustSearchQuery_search_ItemSearchResults_results_ComponentThemeConfiguration | TrustSearchQuery_search_ItemSearchResults_results_ComponentThemesConfiguration | TrustSearchQuery_search_ItemSearchResults_results_ComponentsConfigurations | TrustSearchQuery_search_ItemSearchResults_results_ConfigurationFolder | TrustSearchQuery_search_ItemSearchResults_results_Container | TrustSearchQuery_search_ItemSearchResults_results_ContainerOption | TrustSearchQuery_search_ItemSearchResults_results_ContainerOptionsFolder | TrustSearchQuery_search_ItemSearchResults_results_ContainerParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_Container_45130bdbbae34edcaea87b68b9d94c7f | TrustSearchQuery_search_ItemSearchResults_results_ContentBlock | TrustSearchQuery_search_ItemSearchResults_results_ContentBlockFolder | TrustSearchQuery_search_ItemSearchResults_results_ContentToken | TrustSearchQuery_search_ItemSearchResults_results_ContentTokenFolder | TrustSearchQuery_search_ItemSearchResults_results_ContentType | TrustSearchQuery_search_ItemSearchResults_results_CorporateTheme | TrustSearchQuery_search_ItemSearchResults_results_CorporateThemesFolder | TrustSearchQuery_search_ItemSearchResults_results_Country | TrustSearchQuery_search_ItemSearchResults_results_CountryISOCode | TrustSearchQuery_search_ItemSearchResults_results_CountryISOCodesFolder | TrustSearchQuery_search_ItemSearchResults_results_CustomerReviewFolder | TrustSearchQuery_search_ItemSearchResults_results_CustomerReviewTile | TrustSearchQuery_search_ItemSearchResults_results_CustomerReviewTileParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_DataBridgeDocumentCategoryMap | TrustSearchQuery_search_ItemSearchResults_results_DataBridgeFund | TrustSearchQuery_search_ItemSearchResults_results_DataBridgeFundRangeName | TrustSearchQuery_search_ItemSearchResults_results_DataBridgeSettingsFolder | TrustSearchQuery_search_ItemSearchResults_results_DataBridgeShareClass | TrustSearchQuery_search_ItemSearchResults_results_DataFolder | TrustSearchQuery_search_ItemSearchResults_results_DatasourceConfiguration | TrustSearchQuery_search_ItemSearchResults_results_DatasourceConfigurations | TrustSearchQuery_search_ItemSearchResults_results_DatasourceWorkflowAction | TrustSearchQuery_search_ItemSearchResults_results_DateFacet | TrustSearchQuery_search_ItemSearchResults_results_DateFilter | TrustSearchQuery_search_ItemSearchResults_results_DateFilterFolder | TrustSearchQuery_search_ItemSearchResults_results_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 | TrustSearchQuery_search_ItemSearchResults_results_DefaultColumnLayout | TrustSearchQuery_search_ItemSearchResults_results_DefaultShareclassMapping | TrustSearchQuery_search_ItemSearchResults_results_DefaultShareclassMappings | TrustSearchQuery_search_ItemSearchResults_results_DescriptiveHighlight | TrustSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightFolder | TrustSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightItem | TrustSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_Device | TrustSearchQuery_search_ItemSearchResults_results_Device_7c27ec70f42e40428a0fabaa2f8eda18 | TrustSearchQuery_search_ItemSearchResults_results_Devices | TrustSearchQuery_search_ItemSearchResults_results_DictionaryFolder | TrustSearchQuery_search_ItemSearchResults_results_DisqusParameters | TrustSearchQuery_search_ItemSearchResults_results_DistanceFacet | TrustSearchQuery_search_ItemSearchResults_results_Divider | TrustSearchQuery_search_ItemSearchResults_results_DocumentItem | TrustSearchQuery_search_ItemSearchResults_results_DocumentListings | TrustSearchQuery_search_ItemSearchResults_results_DocumentListingsFolder | TrustSearchQuery_search_ItemSearchResults_results_DocumentTypeFolder | TrustSearchQuery_search_ItemSearchResults_results_DominantLanguageMapping | TrustSearchQuery_search_ItemSearchResults_results_Dropdown | TrustSearchQuery_search_ItemSearchResults_results_DropdownFilter | TrustSearchQuery_search_ItemSearchResults_results_DropdownFilterFolder | TrustSearchQuery_search_ItemSearchResults_results_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d | TrustSearchQuery_search_ItemSearchResults_results_EditEditingTheme | TrustSearchQuery_search_ItemSearchResults_results_EditFrame | TrustSearchQuery_search_ItemSearchResults_results_EditModePanel | TrustSearchQuery_search_ItemSearchResults_results_EditSiteItem | TrustSearchQuery_search_ItemSearchResults_results_EditSiteItem_f040db0387fe4e10ae4053c63175e31b | TrustSearchQuery_search_ItemSearchResults_results_EditSiteTheme | TrustSearchQuery_search_ItemSearchResults_results_EditTenantTemplate | TrustSearchQuery_search_ItemSearchResults_results_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 | TrustSearchQuery_search_ItemSearchResults_results_EditType | TrustSearchQuery_search_ItemSearchResults_results_EloquaFormFolder | TrustSearchQuery_search_ItemSearchResults_results_EloquaFundForm | TrustSearchQuery_search_ItemSearchResults_results_Enum | TrustSearchQuery_search_ItemSearchResults_results_Enums | TrustSearchQuery_search_ItemSearchResults_results_ErrorPage | TrustSearchQuery_search_ItemSearchResults_results_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 | TrustSearchQuery_search_ItemSearchResults_results_ErrorPage_4dbccce416d1491f94198496e3f77c6d | TrustSearchQuery_search_ItemSearchResults_results_ErrorPage_45d797cc048740ffb693214883ff35c2 | TrustSearchQuery_search_ItemSearchResults_results_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 | TrustSearchQuery_search_ItemSearchResults_results_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 | TrustSearchQuery_search_ItemSearchResults_results_EventCalendarParameters | TrustSearchQuery_search_ItemSearchResults_results_EventList | TrustSearchQuery_search_ItemSearchResults_results_EventListParameters | TrustSearchQuery_search_ItemSearchResults_results_EventTypes | TrustSearchQuery_search_ItemSearchResults_results_EventsFolder | TrustSearchQuery_search_ItemSearchResults_results_ExecuteScript | TrustSearchQuery_search_ItemSearchResults_results_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f | TrustSearchQuery_search_ItemSearchResults_results_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a | TrustSearchQuery_search_ItemSearchResults_results_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca | TrustSearchQuery_search_ItemSearchResults_results_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de | TrustSearchQuery_search_ItemSearchResults_results_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb | TrustSearchQuery_search_ItemSearchResults_results_ExtendSiteTheme | TrustSearchQuery_search_ItemSearchResults_results_ExternalLiterature | TrustSearchQuery_search_ItemSearchResults_results_FEaaSWrapperRenderingParameters | TrustSearchQuery_search_ItemSearchResults_results_FacebookCommentsParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_FacetSlider | TrustSearchQuery_search_ItemSearchResults_results_FacetSliderFolder | TrustSearchQuery_search_ItemSearchResults_results_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 | TrustSearchQuery_search_ItemSearchResults_results_FacetSummary | TrustSearchQuery_search_ItemSearchResults_results_FacetSummaryFolder | TrustSearchQuery_search_ItemSearchResults_results_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 | TrustSearchQuery_search_ItemSearchResults_results_FacetsGrouping | TrustSearchQuery_search_ItemSearchResults_results_FakeNavigationItem | TrustSearchQuery_search_ItemSearchResults_results_FeatureBanner | TrustSearchQuery_search_ItemSearchResults_results_FeatureBannerParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_FeaturedArticles | TrustSearchQuery_search_ItemSearchResults_results_FeaturedArticlesFolder | TrustSearchQuery_search_ItemSearchResults_results_FeaturedTheme | TrustSearchQuery_search_ItemSearchResults_results_FeaturedThemesFolder | TrustSearchQuery_search_ItemSearchResults_results_Feed | TrustSearchQuery_search_ItemSearchResults_results_FeedFolder | TrustSearchQuery_search_ItemSearchResults_results_FeedParameters | TrustSearchQuery_search_ItemSearchResults_results_FieldEditor | TrustSearchQuery_search_ItemSearchResults_results_FieldRenderer | TrustSearchQuery_search_ItemSearchResults_results_FileList | TrustSearchQuery_search_ItemSearchResults_results_FileListFolder | TrustSearchQuery_search_ItemSearchResults_results_FileListParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_File_04129321770849c1801baee196e1c0a8 | TrustSearchQuery_search_ItemSearchResults_results_FilterCriteria | TrustSearchQuery_search_ItemSearchResults_results_FilterCriteriaFolder | TrustSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOption | TrustSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOptions | TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage | TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d | TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 | TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 | TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 | TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce | TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage | TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e | TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 | TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 | TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 | TrustSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 | TrustSearchQuery_search_ItemSearchResults_results_Flip | TrustSearchQuery_search_ItemSearchResults_results_FlipFolder | TrustSearchQuery_search_ItemSearchResults_results_Flip_5ef078504c044b839dafefd752cfaba8 | TrustSearchQuery_search_ItemSearchResults_results_Flipside | TrustSearchQuery_search_ItemSearchResults_results_FloatFacet | TrustSearchQuery_search_ItemSearchResults_results_Footer | TrustSearchQuery_search_ItemSearchResults_results_FooterFolder | TrustSearchQuery_search_ItemSearchResults_results_FooterLink | TrustSearchQuery_search_ItemSearchResults_results_FormRenderingParameters | TrustSearchQuery_search_ItemSearchResults_results_FundAssetClass | TrustSearchQuery_search_ItemSearchResults_results_FundAssetClassesFolder | TrustSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage | TrustSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 | TrustSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f | TrustSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b | TrustSearchQuery_search_ItemSearchResults_results_FundFormsFolder | TrustSearchQuery_search_ItemSearchResults_results_FundInFocus | TrustSearchQuery_search_ItemSearchResults_results_FundInFocusShareClass | TrustSearchQuery_search_ItemSearchResults_results_FundSearchPage | TrustSearchQuery_search_ItemSearchResults_results_FundSearchPage_5505b84dba1f47c7b8054749d802d926 | TrustSearchQuery_search_ItemSearchResults_results_FundSearchPage_5806f83c03bc443380678ff955f4310f | TrustSearchQuery_search_ItemSearchResults_results_FundSearchPage_7432205c04214a419ca064c4cb37501c | TrustSearchQuery_search_ItemSearchResults_results_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a | TrustSearchQuery_search_ItemSearchResults_results_FundSettings | TrustSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage | TrustSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c | TrustSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 | TrustSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc | TrustSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee | TrustSearchQuery_search_ItemSearchResults_results_FundSubAssetClass | TrustSearchQuery_search_ItemSearchResults_results_FundSubAssetClassesFolder | TrustSearchQuery_search_ItemSearchResults_results_FundsExternalLiteratureFolder | TrustSearchQuery_search_ItemSearchResults_results_FundsFolder | TrustSearchQuery_search_ItemSearchResults_results_FundsInFocusFolder | TrustSearchQuery_search_ItemSearchResults_results_FundsInFocusParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_FundsLiteratureFolder | TrustSearchQuery_search_ItemSearchResults_results_FundsLiteratureMappingsFolder | TrustSearchQuery_search_ItemSearchResults_results_Gallery | TrustSearchQuery_search_ItemSearchResults_results_GalleryFolder | TrustSearchQuery_search_ItemSearchResults_results_GalleryImage | TrustSearchQuery_search_ItemSearchResults_results_GalleryParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_GalleryVideo | TrustSearchQuery_search_ItemSearchResults_results_GatedAccordionContainer | TrustSearchQuery_search_ItemSearchResults_results_GlobalLanguageSelector | TrustSearchQuery_search_ItemSearchResults_results_GlobalNavigationBar | TrustSearchQuery_search_ItemSearchResults_results_GoogleAnalytics | TrustSearchQuery_search_ItemSearchResults_results_GoogleTagManager | TrustSearchQuery_search_ItemSearchResults_results_GoogleTagManagerFolder | TrustSearchQuery_search_ItemSearchResults_results_GridSetup | TrustSearchQuery_search_ItemSearchResults_results_GridTheme | TrustSearchQuery_search_ItemSearchResults_results_HTMLCode | TrustSearchQuery_search_ItemSearchResults_results_HTMLCodeFolder | TrustSearchQuery_search_ItemSearchResults_results_HTMLInclude | TrustSearchQuery_search_ItemSearchResults_results_HTMLIncludesFolder | TrustSearchQuery_search_ItemSearchResults_results_HTMLSnippet | TrustSearchQuery_search_ItemSearchResults_results_HTMLSnippetFolder | TrustSearchQuery_search_ItemSearchResults_results_HTMLTag | TrustSearchQuery_search_ItemSearchResults_results_Header | TrustSearchQuery_search_ItemSearchResults_results_HeaderFolder | TrustSearchQuery_search_ItemSearchResults_results_Heading | TrustSearchQuery_search_ItemSearchResults_results_HeadlessSiteSetupRoot | TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b | TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 | TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 | TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_68ffa40c5aab45548f774742b163f318 | TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 | TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_229484893ca144958b9937167dfb5064 | TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_b28055626acc45a2913a9617398c9730 | TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_f1cab1661abb450d84d55d938e7699cb | TrustSearchQuery_search_ItemSearchResults_results_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 | TrustSearchQuery_search_ItemSearchResults_results_HeadlessSolutionTemplateFolder | TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenantSetupRoot | TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 | TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 | TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5d72df6049c74324969205b55767ad7b | TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 | TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_77a403a2094e48afafa60943d349d23d | TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 | TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_94824ac390d748499e5af0275d10811f | TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_4797571864fd40929cf2412c39757ec3 | TrustSearchQuery_search_ItemSearchResults_results_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 | TrustSearchQuery_search_ItemSearchResults_results_HeadlessTrustSite | TrustSearchQuery_search_ItemSearchResults_results_HeadlessVariants | TrustSearchQuery_search_ItemSearchResults_results_HeadlessVariantsGrouping | TrustSearchQuery_search_ItemSearchResults_results_HelpArticlePage | TrustSearchQuery_search_ItemSearchResults_results_HelpArticlePlatform | TrustSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMap | TrustSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMappings | TrustSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformsFolder | TrustSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage | TrustSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 | TrustSearchQuery_search_ItemSearchResults_results_HelpArticleTag | TrustSearchQuery_search_ItemSearchResults_results_HelpArticleTagsFolder | TrustSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage | TrustSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 | TrustSearchQuery_search_ItemSearchResults_results_HelpArticlesGroupFolder | TrustSearchQuery_search_ItemSearchResults_results_HelpTagMap | TrustSearchQuery_search_ItemSearchResults_results_HelpTagMappings | TrustSearchQuery_search_ItemSearchResults_results_HeroBanner | TrustSearchQuery_search_ItemSearchResults_results_Highlight | TrustSearchQuery_search_ItemSearchResults_results_HighlightBlock | TrustSearchQuery_search_ItemSearchResults_results_HighlightBlockFolder | TrustSearchQuery_search_ItemSearchResults_results_HighlightBlockParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_HighlightFolder | TrustSearchQuery_search_ItemSearchResults_results_HighlightItem | TrustSearchQuery_search_ItemSearchResults_results_HighlightParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_Home | TrustSearchQuery_search_ItemSearchResults_results_HomePage | TrustSearchQuery_search_ItemSearchResults_results_HomePage_0d3963a8171d4080b5f808618578b631 | TrustSearchQuery_search_ItemSearchResults_results_HomePage_6d95c7d946c74a70be07304cc73a2010 | TrustSearchQuery_search_ItemSearchResults_results_HomePage_b407f259b4e34c7db9a06e8907a56b17 | TrustSearchQuery_search_ItemSearchResults_results_HomePage_cde13c51062d426b95569e8202edc963 | TrustSearchQuery_search_ItemSearchResults_results_HomePage_de9353283a3e41c495ba386aed0540c6 | TrustSearchQuery_search_ItemSearchResults_results_IFrame | TrustSearchQuery_search_ItemSearchResults_results_IFrameFolder | TrustSearchQuery_search_ItemSearchResults_results_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 | TrustSearchQuery_search_ItemSearchResults_results_IFrameParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_IFrame_0da12d476de24dfeb4d0f513489bfea1 | TrustSearchQuery_search_ItemSearchResults_results_IFrame_88a6f65f2b78491bb3770b06e48883e1 | TrustSearchQuery_search_ItemSearchResults_results_Icon | TrustSearchQuery_search_ItemSearchResults_results_IconFolder | TrustSearchQuery_search_ItemSearchResults_results_Image | TrustSearchQuery_search_ItemSearchResults_results_ImageFolder | TrustSearchQuery_search_ItemSearchResults_results_ImageFolder_edc00e86cef24d0cbfa264460becc323 | TrustSearchQuery_search_ItemSearchResults_results_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 | TrustSearchQuery_search_ItemSearchResults_results_ImageParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_Image_83bc563c6320490092f8204bff81586a | TrustSearchQuery_search_ItemSearchResults_results_Image_15185b0e641844499f934ff03b7ee032 | TrustSearchQuery_search_ItemSearchResults_results_Image_d885df8cb2d64007b34b2bbafb527304 | TrustSearchQuery_search_ItemSearchResults_results_Infographics | TrustSearchQuery_search_ItemSearchResults_results_InfographicsFolder | TrustSearchQuery_search_ItemSearchResults_results_InputValidationStep | TrustSearchQuery_search_ItemSearchResults_results_InputValidationStep_088928cf558e40ec87f3342aa9e66757 | TrustSearchQuery_search_ItemSearchResults_results_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 | TrustSearchQuery_search_ItemSearchResults_results_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f | TrustSearchQuery_search_ItemSearchResults_results_IntegerFacet | TrustSearchQuery_search_ItemSearchResults_results_IntroCopy | TrustSearchQuery_search_ItemSearchResults_results_IntroCopyFolder | TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClass | TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClassFolder | TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 | TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb | TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegion | TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegionFolder | TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyle | TrustSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyleFolder | TrustSearchQuery_search_ItemSearchResults_results_InvestorType | TrustSearchQuery_search_ItemSearchResults_results_InvestorTypesFolder | TrustSearchQuery_search_ItemSearchResults_results_ItemQueriesFolder | TrustSearchQuery_search_ItemSearchResults_results_ItemRights | TrustSearchQuery_search_ItemSearchResults_results_JSBeaconSettings | TrustSearchQuery_search_ItemSearchResults_results_JSONCheckbox | TrustSearchQuery_search_ItemSearchResults_results_JSONContent | TrustSearchQuery_search_ItemSearchResults_results_JSONDate | TrustSearchQuery_search_ItemSearchResults_results_JSONFile | TrustSearchQuery_search_ItemSearchResults_results_JSONImage | TrustSearchQuery_search_ItemSearchResults_results_JSONLayout | TrustSearchQuery_search_ItemSearchResults_results_JSONList | TrustSearchQuery_search_ItemSearchResults_results_JSONMultilistReference | TrustSearchQuery_search_ItemSearchResults_results_JSONPlaceholder | TrustSearchQuery_search_ItemSearchResults_results_JSONQuery | TrustSearchQuery_search_ItemSearchResults_results_JSONResults | TrustSearchQuery_search_ItemSearchResults_results_JSONRichText | TrustSearchQuery_search_ItemSearchResults_results_JSONScriban | TrustSearchQuery_search_ItemSearchResults_results_JSONSection | TrustSearchQuery_search_ItemSearchResults_results_JSONTemplate | TrustSearchQuery_search_ItemSearchResults_results_JSONText | TrustSearchQuery_search_ItemSearchResults_results_JSONToken | TrustSearchQuery_search_ItemSearchResults_results_JSONVariantDefinition | TrustSearchQuery_search_ItemSearchResults_results_JSONVariants | TrustSearchQuery_search_ItemSearchResults_results_JSSLayout | TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 | TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_6b328292f8314ab79885d89a054ca10a | TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff | TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d | TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 | TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_b001fd725bb1476496825a8cb9e995cd | TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_c643bc8630d14d61a173c7870f5dbbad | TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 | TrustSearchQuery_search_ItemSearchResults_results_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 | TrustSearchQuery_search_ItemSearchResults_results_JSSSiteGrouping | TrustSearchQuery_search_ItemSearchResults_results_JSSTenantFolder | TrustSearchQuery_search_ItemSearchResults_results_JavaScriptRendering | TrustSearchQuery_search_ItemSearchResults_results_JsonRendering | TrustSearchQuery_search_ItemSearchResults_results_JurisdictionStatus | TrustSearchQuery_search_ItemSearchResults_results_JurisdictionsFolder | TrustSearchQuery_search_ItemSearchResults_results_KeyHighlightItem | TrustSearchQuery_search_ItemSearchResults_results_KeyHighlights | TrustSearchQuery_search_ItemSearchResults_results_KeyHighlightsFolder | TrustSearchQuery_search_ItemSearchResults_results_KeyHighlightsParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_Language | TrustSearchQuery_search_ItemSearchResults_results_LanguageSelector | TrustSearchQuery_search_ItemSearchResults_results_LanguagesFolder | TrustSearchQuery_search_ItemSearchResults_results_LatestPressReleasesParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_LayoutServiceVariants | TrustSearchQuery_search_ItemSearchResults_results_LimitedDisplayFolder | TrustSearchQuery_search_ItemSearchResults_results_LimitedDisplayOption | TrustSearchQuery_search_ItemSearchResults_results_Link | TrustSearchQuery_search_ItemSearchResults_results_LinkList | TrustSearchQuery_search_ItemSearchResults_results_LinkListFolder | TrustSearchQuery_search_ItemSearchResults_results_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 | TrustSearchQuery_search_ItemSearchResults_results_LinkList_33c9207e3b0446068ef54ca99a97c776 | TrustSearchQuery_search_ItemSearchResults_results_LinkList_97a593ad273141dc80bfceb5ef6a33b7 | TrustSearchQuery_search_ItemSearchResults_results_LinkList_f7561ffcc0d8477fb53d2703a4060be1 | TrustSearchQuery_search_ItemSearchResults_results_Link_68bd1cb5a7624a969ac6cb16ab5882a3 | TrustSearchQuery_search_ItemSearchResults_results_Link_930f134d56784b35bfd1b77f9d0115f1 | TrustSearchQuery_search_ItemSearchResults_results_Link_e24e0789a05848bfabb6c69c0e60b6b7 | TrustSearchQuery_search_ItemSearchResults_results_LinksFolder | TrustSearchQuery_search_ItemSearchResults_results_List | TrustSearchQuery_search_ItemSearchResults_results_ListFacet | TrustSearchQuery_search_ItemSearchResults_results_ListFolder | TrustSearchQuery_search_ItemSearchResults_results_ListItem | TrustSearchQuery_search_ItemSearchResults_results_ListParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_ListStyle | TrustSearchQuery_search_ItemSearchResults_results_ListStyleItem | TrustSearchQuery_search_ItemSearchResults_results_ListingHeroBanner | TrustSearchQuery_search_ItemSearchResults_results_ListingHeroParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_LiteratureAuthorization | TrustSearchQuery_search_ItemSearchResults_results_LiteratureAuthorizationsFolder | TrustSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage | TrustSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d | TrustSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e | TrustSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea | TrustSearchQuery_search_ItemSearchResults_results_LoadMore | TrustSearchQuery_search_ItemSearchResults_results_LoadMoreFolder | TrustSearchQuery_search_ItemSearchResults_results_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 | TrustSearchQuery_search_ItemSearchResults_results_LocationFilter | TrustSearchQuery_search_ItemSearchResults_results_LocationFilterFolder | TrustSearchQuery_search_ItemSearchResults_results_LocationFilter_aaad4aad290744dc90b69e4e83a661ec | TrustSearchQuery_search_ItemSearchResults_results_Log | TrustSearchQuery_search_ItemSearchResults_results_Login | TrustSearchQuery_search_ItemSearchResults_results_Login_abed54dc4f7840ddac562289c9c849d8 | TrustSearchQuery_search_ItemSearchResults_results_LogoTextBlockItem | TrustSearchQuery_search_ItemSearchResults_results_LogoTextBlocks | TrustSearchQuery_search_ItemSearchResults_results_LogoTextBlocksFolder | TrustSearchQuery_search_ItemSearchResults_results_Logout | TrustSearchQuery_search_ItemSearchResults_results_Logout_c2294d8235a6452a94b15eb5e543b602 | TrustSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter | TrustSearchQuery_search_ItemSearchResults_results_ManagedRangeFilterFolder | TrustSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 | TrustSearchQuery_search_ItemSearchResults_results_ManagedRangeItem | TrustSearchQuery_search_ItemSearchResults_results_Map | TrustSearchQuery_search_ItemSearchResults_results_MapParameters | TrustSearchQuery_search_ItemSearchResults_results_MapsFolder | TrustSearchQuery_search_ItemSearchResults_results_MapsProvider | TrustSearchQuery_search_ItemSearchResults_results_MediaBlock | TrustSearchQuery_search_ItemSearchResults_results_MediaBlockFolder | TrustSearchQuery_search_ItemSearchResults_results_MediaBlockParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_MediaFolder_81150e5837f5443fa3c075e14a9321e7 | TrustSearchQuery_search_ItemSearchResults_results_MediaLinkParameters | TrustSearchQuery_search_ItemSearchResults_results_MediaVirtualFolder | TrustSearchQuery_search_ItemSearchResults_results_MegaNavigation | TrustSearchQuery_search_ItemSearchResults_results_MegaNavigationFolder | TrustSearchQuery_search_ItemSearchResults_results_MetaBranding | TrustSearchQuery_search_ItemSearchResults_results_MetaRenderingParameters | TrustSearchQuery_search_ItemSearchResults_results_MetadataPartialDesign | TrustSearchQuery_search_ItemSearchResults_results_Model | TrustSearchQuery_search_ItemSearchResults_results_ModelIterator | TrustSearchQuery_search_ItemSearchResults_results_MyLocationPOI | TrustSearchQuery_search_ItemSearchResults_results_Navigation | TrustSearchQuery_search_ItemSearchResults_results_NavigationCategory | TrustSearchQuery_search_ItemSearchResults_results_NavigationFilter | TrustSearchQuery_search_ItemSearchResults_results_NavigationFilterFolder | TrustSearchQuery_search_ItemSearchResults_results_NavigationLink | TrustSearchQuery_search_ItemSearchResults_results_NavigationSubcategory | TrustSearchQuery_search_ItemSearchResults_results_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 | TrustSearchQuery_search_ItemSearchResults_results_OneTrustSettings | TrustSearchQuery_search_ItemSearchResults_results_OptimiserConfiguration | TrustSearchQuery_search_ItemSearchResults_results_OptimiserConfigurationSection | TrustSearchQuery_search_ItemSearchResults_results_OptimizedFile | TrustSearchQuery_search_ItemSearchResults_results_OracleCDPSettings | TrustSearchQuery_search_ItemSearchResults_results_OverlayContent | TrustSearchQuery_search_ItemSearchResults_results_OverlayFolderTemplate | TrustSearchQuery_search_ItemSearchResults_results_Ownership | TrustSearchQuery_search_ItemSearchResults_results_OwnershipFolder | TrustSearchQuery_search_ItemSearchResults_results_POI | TrustSearchQuery_search_ItemSearchResults_results_POIFolder | TrustSearchQuery_search_ItemSearchResults_results_POIType | TrustSearchQuery_search_ItemSearchResults_results_POIs | TrustSearchQuery_search_ItemSearchResults_results_PageBranchesFolder | TrustSearchQuery_search_ItemSearchResults_results_PageContent | TrustSearchQuery_search_ItemSearchResults_results_PageContentFolder | TrustSearchQuery_search_ItemSearchResults_results_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 | TrustSearchQuery_search_ItemSearchResults_results_PageDesign | TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 | TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 | TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 | TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b | TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 | TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc | TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 | TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb | TrustSearchQuery_search_ItemSearchResults_results_PageDesignFolder_d84605f786ea482da6ff683f6572821c | TrustSearchQuery_search_ItemSearchResults_results_PageDesign_1105b8f81e00426bbf1fc840742d827b | TrustSearchQuery_search_ItemSearchResults_results_PageDesigns | TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_3af52e70e982424b9c85e355542500c9 | TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d | TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 | TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_99a71bba507746729c3fb29b04abee23 | TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 | TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 | TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_b8d9b352c1694b31bd506848b47ca884 | TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_d3b2e1466f744df0900bec314f699ef3 | TrustSearchQuery_search_ItemSearchResults_results_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe | TrustSearchQuery_search_ItemSearchResults_results_PageLevelTabs | TrustSearchQuery_search_ItemSearchResults_results_PageLevelTabsFolder | TrustSearchQuery_search_ItemSearchResults_results_PageList | TrustSearchQuery_search_ItemSearchResults_results_PageSelector | TrustSearchQuery_search_ItemSearchResults_results_PageSelectorConfiguration | TrustSearchQuery_search_ItemSearchResults_results_PageSelectorFolder | TrustSearchQuery_search_ItemSearchResults_results_PageSelector_59a7bb775f8c435ab810291abde80e63 | TrustSearchQuery_search_ItemSearchResults_results_PageSize | TrustSearchQuery_search_ItemSearchResults_results_PageSizeFolder | TrustSearchQuery_search_ItemSearchResults_results_PageSize_b682562e0af64b3e9e3b45273bbe152d | TrustSearchQuery_search_ItemSearchResults_results_PageTheme | TrustSearchQuery_search_ItemSearchResults_results_PageThemesFolder | TrustSearchQuery_search_ItemSearchResults_results_Page_4f49a81db3664f198b89cab92f377d7a | TrustSearchQuery_search_ItemSearchResults_results_Page_5e66d86353544fe6a27d3b894984d50f | TrustSearchQuery_search_ItemSearchResults_results_Page_84f342ad2d0646b9aa9a818201145ca2 | TrustSearchQuery_search_ItemSearchResults_results_Page_718df200be51463d93edf4d77ab7a49e | TrustSearchQuery_search_ItemSearchResults_results_Page_b61d5babe46f4ef39f27b57c4ccefdf7 | TrustSearchQuery_search_ItemSearchResults_results_Page_cfd6e04697e24f3cb9eb41b79afc35dc | TrustSearchQuery_search_ItemSearchResults_results_Page_dae7821153e14dbabb0ddf0b53a90aaf | TrustSearchQuery_search_ItemSearchResults_results_Page_fa608b3e6aeb426388a059d89caabada | TrustSearchQuery_search_ItemSearchResults_results_Pagging | TrustSearchQuery_search_ItemSearchResults_results_Pagination | TrustSearchQuery_search_ItemSearchResults_results_PaginationFolder | TrustSearchQuery_search_ItemSearchResults_results_Paragraph | TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d | TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b | TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 | TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b | TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 | TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_89098e3089aa4062a77346d608caac90 | TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_1695576fb93647d7842ed17730278c32 | TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc | TrustSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a | TrustSearchQuery_search_ItemSearchResults_results_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 | TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns | TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec | TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 | TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_36c869ded22040929ce829f6ed643c66 | TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_1943dc73710a430895515a342c84b037 | TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 | TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e | TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_d52704ed3b704a53abb4292105f687ad | TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_d216303f58d8425688da8cd30d00afab | TrustSearchQuery_search_ItemSearchResults_results_PartialDesigns_facda26791204fa9a0363344348f2c42 | TrustSearchQuery_search_ItemSearchResults_results_PerformanceChartSettings | TrustSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriod | TrustSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriodFolder | TrustSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 | TrustSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d | TrustSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba | TrustSearchQuery_search_ItemSearchResults_results_Placeholder_1ca0304be5b64810821154426f1752c2 | TrustSearchQuery_search_ItemSearchResults_results_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c | TrustSearchQuery_search_ItemSearchResults_results_PlainHtmlParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_Playlist | TrustSearchQuery_search_ItemSearchResults_results_PlaylistFolder | TrustSearchQuery_search_ItemSearchResults_results_PlaylistParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_Podcast | TrustSearchQuery_search_ItemSearchResults_results_PodcastFolder | TrustSearchQuery_search_ItemSearchResults_results_PodcastPage | TrustSearchQuery_search_ItemSearchResults_results_PodcastPressReleasePage | TrustSearchQuery_search_ItemSearchResults_results_PoiTypes | TrustSearchQuery_search_ItemSearchResults_results_PostDeleteStep | TrustSearchQuery_search_ItemSearchResults_results_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 | TrustSearchQuery_search_ItemSearchResults_results_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a | TrustSearchQuery_search_ItemSearchResults_results_PostDeleteStep_b20857895385413883f096f3767cb156 | TrustSearchQuery_search_ItemSearchResults_results_PostSetupStep | TrustSearchQuery_search_ItemSearchResults_results_PostSetupStep_6fac654e22154a419a1d59197bebc0fe | TrustSearchQuery_search_ItemSearchResults_results_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f | TrustSearchQuery_search_ItemSearchResults_results_PostSetupStep_341738aa44fe490e90ff7010a3c2463b | TrustSearchQuery_search_ItemSearchResults_results_PreDeleteStep | TrustSearchQuery_search_ItemSearchResults_results_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 | TrustSearchQuery_search_ItemSearchResults_results_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b | TrustSearchQuery_search_ItemSearchResults_results_PreDeleteStep_f0daf401190f45468bda8568d08e161d | TrustSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep | TrustSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f | TrustSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f | TrustSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e | TrustSearchQuery_search_ItemSearchResults_results_Presentation | TrustSearchQuery_search_ItemSearchResults_results_Presentation_0a70fa7389234a6eabf34134f25f3221 | TrustSearchQuery_search_ItemSearchResults_results_PressReleaseContentType | TrustSearchQuery_search_ItemSearchResults_results_PressReleaseContentTypesFolder | TrustSearchQuery_search_ItemSearchResults_results_PressReleaseFilter | TrustSearchQuery_search_ItemSearchResults_results_PressReleasePage | TrustSearchQuery_search_ItemSearchResults_results_PressReleasePlatform | TrustSearchQuery_search_ItemSearchResults_results_PressReleasePlatformsFolder | TrustSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage | TrustSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f | TrustSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 | TrustSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d | TrustSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 | TrustSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage | TrustSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e | TrustSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 | TrustSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 | TrustSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 | TrustSearchQuery_search_ItemSearchResults_results_PressReleasesGroupFolder | TrustSearchQuery_search_ItemSearchResults_results_PrivacyWarning | TrustSearchQuery_search_ItemSearchResults_results_ProjectFolder | TrustSearchQuery_search_ItemSearchResults_results_Promo | TrustSearchQuery_search_ItemSearchResults_results_PromoFolder | TrustSearchQuery_search_ItemSearchResults_results_PromoFolder_f07cbe8973ae4de692172570260cac6e | TrustSearchQuery_search_ItemSearchResults_results_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 | TrustSearchQuery_search_ItemSearchResults_results_Promo_881869ca7f5845ea8b34ad1bfd3551a8 | TrustSearchQuery_search_ItemSearchResults_results_Promo_dfed4457d760457abec1c0dccdc44381 | TrustSearchQuery_search_ItemSearchResults_results_PromotedContent | TrustSearchQuery_search_ItemSearchResults_results_PromotedContentFolder | TrustSearchQuery_search_ItemSearchResults_results_PropertyListingCard | TrustSearchQuery_search_ItemSearchResults_results_PropertyListingCards | TrustSearchQuery_search_ItemSearchResults_results_PropertyListingCategory | TrustSearchQuery_search_ItemSearchResults_results_PropertyListingFolder | TrustSearchQuery_search_ItemSearchResults_results_Query_98b413525a4b4067b92418a4b50f0a53 | TrustSearchQuery_search_ItemSearchResults_results_QuickLinks | TrustSearchQuery_search_ItemSearchResults_results_QuickLinksFolder | TrustSearchQuery_search_ItemSearchResults_results_QuickLinksParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_QuotationBlockItem | TrustSearchQuery_search_ItemSearchResults_results_QuotationBlocks | TrustSearchQuery_search_ItemSearchResults_results_QuotationBlocksFolder | TrustSearchQuery_search_ItemSearchResults_results_QuotationBlocksParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_Quote | TrustSearchQuery_search_ItemSearchResults_results_QuoteFolder | TrustSearchQuery_search_ItemSearchResults_results_QuoteParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_RadiusFilter | TrustSearchQuery_search_ItemSearchResults_results_RadiusFilterFolder | TrustSearchQuery_search_ItemSearchResults_results_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 | TrustSearchQuery_search_ItemSearchResults_results_RadiusScheme | TrustSearchQuery_search_ItemSearchResults_results_RadiusSchemeValue | TrustSearchQuery_search_ItemSearchResults_results_RangeSliderFilter | TrustSearchQuery_search_ItemSearchResults_results_RangeSliderFilterFolder | TrustSearchQuery_search_ItemSearchResults_results_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 | TrustSearchQuery_search_ItemSearchResults_results_RecentArticles | TrustSearchQuery_search_ItemSearchResults_results_Redirect | TrustSearchQuery_search_ItemSearchResults_results_RedirectMap | TrustSearchQuery_search_ItemSearchResults_results_RedirectMaps | TrustSearchQuery_search_ItemSearchResults_results_Region | TrustSearchQuery_search_ItemSearchResults_results_RegionLanguages | TrustSearchQuery_search_ItemSearchResults_results_RegionLanguagesFolder | TrustSearchQuery_search_ItemSearchResults_results_RelatedArticles | TrustSearchQuery_search_ItemSearchResults_results_RelatedArticlesParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_RenderEngineType | TrustSearchQuery_search_ItemSearchResults_results_RenderingFolder_840d4a46550349ecbf9dbd090946c63d | TrustSearchQuery_search_ItemSearchResults_results_RenderingHost | TrustSearchQuery_search_ItemSearchResults_results_ResizableIFramePage | TrustSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 | TrustSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 | TrustSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 | TrustSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 | TrustSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_f460ab055585441892023750e7cef6b7 | TrustSearchQuery_search_ItemSearchResults_results_ResponsiveImage | TrustSearchQuery_search_ItemSearchResults_results_ResultsCount | TrustSearchQuery_search_ItemSearchResults_results_ResultsCountFolder | TrustSearchQuery_search_ItemSearchResults_results_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 | TrustSearchQuery_search_ItemSearchResults_results_ResultsVariantSelector | TrustSearchQuery_search_ItemSearchResults_results_RichText | TrustSearchQuery_search_ItemSearchResults_results_RichTextFolder | TrustSearchQuery_search_ItemSearchResults_results_RichText_0f3b73366112418c8bbab0526f3887ce | TrustSearchQuery_search_ItemSearchResults_results_RichText_efcfd8f6596745f48f85b5421928205d | TrustSearchQuery_search_ItemSearchResults_results_RiskImageMapping | TrustSearchQuery_search_ItemSearchResults_results_RiskImageMappings | TrustSearchQuery_search_ItemSearchResults_results_RiskLevelOption | TrustSearchQuery_search_ItemSearchResults_results_RiskLevelOptionFolder | TrustSearchQuery_search_ItemSearchResults_results_RiskWarning | TrustSearchQuery_search_ItemSearchResults_results_RiskWarningFolder | TrustSearchQuery_search_ItemSearchResults_results_RiskWarningParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_RolePlaceholder | TrustSearchQuery_search_ItemSearchResults_results_RowSplitter | TrustSearchQuery_search_ItemSearchResults_results_RowSplitter_340c887da1d1415b9678c763af74ea97 | TrustSearchQuery_search_ItemSearchResults_results_Rule | TrustSearchQuery_search_ItemSearchResults_results_SDRLogoMapping | TrustSearchQuery_search_ItemSearchResults_results_SDRLogoMappings | TrustSearchQuery_search_ItemSearchResults_results_SDRTypeOption | TrustSearchQuery_search_ItemSearchResults_results_SDRTypeOptionFolder | TrustSearchQuery_search_ItemSearchResults_results_SXAJSSLayout | TrustSearchQuery_search_ItemSearchResults_results_SXARole | TrustSearchQuery_search_ItemSearchResults_results_SXAStandardValuesFolder | TrustSearchQuery_search_ItemSearchResults_results_SalesforceAlertMessage | TrustSearchQuery_search_ItemSearchResults_results_SalesforceCheckBox | TrustSearchQuery_search_ItemSearchResults_results_SalesforceCheckBoxType | TrustSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButton | TrustSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButtons | TrustSearchQuery_search_ItemSearchResults_results_SalesforceDateInput | TrustSearchQuery_search_ItemSearchResults_results_SalesforceDropdown | TrustSearchQuery_search_ItemSearchResults_results_SalesforceDropdownOption | TrustSearchQuery_search_ItemSearchResults_results_SalesforceHiddenField | TrustSearchQuery_search_ItemSearchResults_results_SalesforceInput | TrustSearchQuery_search_ItemSearchResults_results_SalesforceInputType | TrustSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedForm | TrustSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedFormTypesFolder | TrustSearchQuery_search_ItemSearchResults_results_SalesforceRepeatableSubSection | TrustSearchQuery_search_ItemSearchResults_results_SalesforceRichTextArea | TrustSearchQuery_search_ItemSearchResults_results_SalesforceSection | TrustSearchQuery_search_ItemSearchResults_results_SalesforceSortCodeInput | TrustSearchQuery_search_ItemSearchResults_results_SalesforceSubmissionType | TrustSearchQuery_search_ItemSearchResults_results_Scope | TrustSearchQuery_search_ItemSearchResults_results_ScopesFolder | TrustSearchQuery_search_ItemSearchResults_results_Scriban | TrustSearchQuery_search_ItemSearchResults_results_Scripts | TrustSearchQuery_search_ItemSearchResults_results_SearchBox | TrustSearchQuery_search_ItemSearchResults_results_SearchBoxFolder | TrustSearchQuery_search_ItemSearchResults_results_SearchBox_1c04fd611d874590acfe9cc186865ab3 | TrustSearchQuery_search_ItemSearchResults_results_SearchFolder | TrustSearchQuery_search_ItemSearchResults_results_SearchResults | TrustSearchQuery_search_ItemSearchResults_results_SearchResultsFolder | TrustSearchQuery_search_ItemSearchResults_results_SearchResults_a06f7130041d46bb8c2995a2dc00c26a | TrustSearchQuery_search_ItemSearchResults_results_SecondaryHeroBannerParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_SectionHeading | TrustSearchQuery_search_ItemSearchResults_results_SectionHeadingFolder | TrustSearchQuery_search_ItemSearchResults_results_SectionHeadingParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_SectionHeadingType | TrustSearchQuery_search_ItemSearchResults_results_SectionHeadingTypeFolder | TrustSearchQuery_search_ItemSearchResults_results_SectionSelector | TrustSearchQuery_search_ItemSearchResults_results_SectionSelectorFolder | TrustSearchQuery_search_ItemSearchResults_results_SectionSelectorTab | TrustSearchQuery_search_ItemSearchResults_results_Security_33077d51ebad4d1cb4a83b79f51dba13 | TrustSearchQuery_search_ItemSearchResults_results_Series | TrustSearchQuery_search_ItemSearchResults_results_SeriesFolder | TrustSearchQuery_search_ItemSearchResults_results_Settings | TrustSearchQuery_search_ItemSearchResults_results_SettingsFolder | TrustSearchQuery_search_ItemSearchResults_results_Settings_6c82caca67dc464195698faad083230e | TrustSearchQuery_search_ItemSearchResults_results_SharePriceSettings | TrustSearchQuery_search_ItemSearchResults_results_SharedArticlesFolder | TrustSearchQuery_search_ItemSearchResults_results_SharedContentFolder | TrustSearchQuery_search_ItemSearchResults_results_SharedFolder | TrustSearchQuery_search_ItemSearchResults_results_SharedHelpArticlesFolder | TrustSearchQuery_search_ItemSearchResults_results_SharedPressReleasesFolder | TrustSearchQuery_search_ItemSearchResults_results_SharedSettingsFolder | TrustSearchQuery_search_ItemSearchResults_results_SharedSitesSettings | TrustSearchQuery_search_ItemSearchResults_results_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 | TrustSearchQuery_search_ItemSearchResults_results_Showcase | TrustSearchQuery_search_ItemSearchResults_results_ShowcaseFolder | TrustSearchQuery_search_ItemSearchResults_results_ShowcaseItem | TrustSearchQuery_search_ItemSearchResults_results_ShowcaseParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_Site | TrustSearchQuery_search_ItemSearchResults_results_SiteContentFolder | TrustSearchQuery_search_ItemSearchResults_results_SiteDefinition | TrustSearchQuery_search_ItemSearchResults_results_SiteEntryDisclaimer | TrustSearchQuery_search_ItemSearchResults_results_SiteFolder | TrustSearchQuery_search_ItemSearchResults_results_SiteGrouping | TrustSearchQuery_search_ItemSearchResults_results_SiteManagement | TrustSearchQuery_search_ItemSearchResults_results_SiteSecurityItemPointer | TrustSearchQuery_search_ItemSearchResults_results_SiteSelector | TrustSearchQuery_search_ItemSearchResults_results_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 | TrustSearchQuery_search_ItemSearchResults_results_SiteSetupRoot | TrustSearchQuery_search_ItemSearchResults_results_SiteTheme | TrustSearchQuery_search_ItemSearchResults_results_Site_e46f3af239fa4866a1577017c4b2a40c | TrustSearchQuery_search_ItemSearchResults_results_SitecoreFormWrapperParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_SitecoreRole | TrustSearchQuery_search_ItemSearchResults_results_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 | TrustSearchQuery_search_ItemSearchResults_results_SkipLink | TrustSearchQuery_search_ItemSearchResults_results_SkipLinkParameters | TrustSearchQuery_search_ItemSearchResults_results_SkipLinksFolder | TrustSearchQuery_search_ItemSearchResults_results_Snippet | TrustSearchQuery_search_ItemSearchResults_results_SnippetItem | TrustSearchQuery_search_ItemSearchResults_results_SnippetsFolder | TrustSearchQuery_search_ItemSearchResults_results_SocialLoginWrapper | TrustSearchQuery_search_ItemSearchResults_results_SocialMediaButtons | TrustSearchQuery_search_ItemSearchResults_results_SocialMediaFolder | TrustSearchQuery_search_ItemSearchResults_results_SocialMediaShare | TrustSearchQuery_search_ItemSearchResults_results_SocialMediaTemplate | TrustSearchQuery_search_ItemSearchResults_results_SocialNetwork | TrustSearchQuery_search_ItemSearchResults_results_SocialNetworkFolder | TrustSearchQuery_search_ItemSearchResults_results_SocialNetworkLink | TrustSearchQuery_search_ItemSearchResults_results_SolutionTemplate | TrustSearchQuery_search_ItemSearchResults_results_SortResults | TrustSearchQuery_search_ItemSearchResults_results_SortResultsFolder | TrustSearchQuery_search_ItemSearchResults_results_Sorting | TrustSearchQuery_search_ItemSearchResults_results_SortingGroups | TrustSearchQuery_search_ItemSearchResults_results_SpotifyPodcast | TrustSearchQuery_search_ItemSearchResults_results_SpotifyPodcastFolder | TrustSearchQuery_search_ItemSearchResults_results_StickyCTA | TrustSearchQuery_search_ItemSearchResults_results_StickyCTAFolder | TrustSearchQuery_search_ItemSearchResults_results_StickyCTAParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_StrategiesInFocusFolder | TrustSearchQuery_search_ItemSearchResults_results_StrategyInFocus | TrustSearchQuery_search_ItemSearchResults_results_Style | TrustSearchQuery_search_ItemSearchResults_results_Styles | TrustSearchQuery_search_ItemSearchResults_results_Styles_9c0dac2808aa4b44bc2153363206f6a5 | TrustSearchQuery_search_ItemSearchResults_results_SubscriptionBannerParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_Tab | TrustSearchQuery_search_ItemSearchResults_results_TabItem | TrustSearchQuery_search_ItemSearchResults_results_TableOfContents | TrustSearchQuery_search_ItemSearchResults_results_TableOfContentsFolder | TrustSearchQuery_search_ItemSearchResults_results_TableOfContentsSection | TrustSearchQuery_search_ItemSearchResults_results_TableOfContentsSubsection | TrustSearchQuery_search_ItemSearchResults_results_Tabs | TrustSearchQuery_search_ItemSearchResults_results_TabsFolder | TrustSearchQuery_search_ItemSearchResults_results_Tabs_f26a9560ccf148c59542800e837caf7a | TrustSearchQuery_search_ItemSearchResults_results_Tag | TrustSearchQuery_search_ItemSearchResults_results_TagCloud | TrustSearchQuery_search_ItemSearchResults_results_TagFolder | TrustSearchQuery_search_ItemSearchResults_results_TagList | TrustSearchQuery_search_ItemSearchResults_results_TeamBiographySettings | TrustSearchQuery_search_ItemSearchResults_results_TeamListingCards | TrustSearchQuery_search_ItemSearchResults_results_TeamListingCardsFolder | TrustSearchQuery_search_ItemSearchResults_results_TeamMember | TrustSearchQuery_search_ItemSearchResults_results_TeamMemberCard | TrustSearchQuery_search_ItemSearchResults_results_TeamMembers | TrustSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage | TrustSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e | TrustSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e | TrustSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff | TrustSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 | TrustSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 | TrustSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage | TrustSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e | TrustSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 | TrustSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a | TrustSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 | TrustSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 | TrustSearchQuery_search_ItemSearchResults_results_TeamProfileCards | TrustSearchQuery_search_ItemSearchResults_results_TeamProfileCardsFolder | TrustSearchQuery_search_ItemSearchResults_results_TechzoneArticlePage | TrustSearchQuery_search_ItemSearchResults_results_Tenant | TrustSearchQuery_search_ItemSearchResults_results_TenantFolder | TrustSearchQuery_search_ItemSearchResults_results_TenantSecurityItemPointer | TrustSearchQuery_search_ItemSearchResults_results_TenantSetupRoot | TrustSearchQuery_search_ItemSearchResults_results_TertieryHeroBanner | TrustSearchQuery_search_ItemSearchResults_results_TertieryHeroBannerParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_Text | TrustSearchQuery_search_ItemSearchResults_results_TextBlock | TrustSearchQuery_search_ItemSearchResults_results_TextBlockHeadingParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_TextBlockHeadingType | TrustSearchQuery_search_ItemSearchResults_results_TextBlockHeadingTypeFolder | TrustSearchQuery_search_ItemSearchResults_results_TextBlockLinkType | TrustSearchQuery_search_ItemSearchResults_results_TextBlockLinkTypeFolder | TrustSearchQuery_search_ItemSearchResults_results_TextBlocks | TrustSearchQuery_search_ItemSearchResults_results_TextBlocksFolder | TrustSearchQuery_search_ItemSearchResults_results_TextBlocksParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_TextFolder | TrustSearchQuery_search_ItemSearchResults_results_TextFolder_b762d56787f5493cbb480c455d834457 | TrustSearchQuery_search_ItemSearchResults_results_Text_b8f5894cb4934016bf784090b0a2fd16 | TrustSearchQuery_search_ItemSearchResults_results_Theme | TrustSearchQuery_search_ItemSearchResults_results_ThemeTag | TrustSearchQuery_search_ItemSearchResults_results_ThemeTagsFolder | TrustSearchQuery_search_ItemSearchResults_results_ThemingMode | TrustSearchQuery_search_ItemSearchResults_results_ThemingModes | TrustSearchQuery_search_ItemSearchResults_results_Tile | TrustSearchQuery_search_ItemSearchResults_results_TileLink | TrustSearchQuery_search_ItemSearchResults_results_TileParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_TileSizeOption | TrustSearchQuery_search_ItemSearchResults_results_TileSizeOptionFolder | TrustSearchQuery_search_ItemSearchResults_results_TilesFolder | TrustSearchQuery_search_ItemSearchResults_results_TilesParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_Title | TrustSearchQuery_search_ItemSearchResults_results_Title_a82e893105754175917de904ef7e6dbe | TrustSearchQuery_search_ItemSearchResults_results_Toggle | TrustSearchQuery_search_ItemSearchResults_results_ToggleFolder | TrustSearchQuery_search_ItemSearchResults_results_Toggle_8e4c968e9fa543a89ac4c0baf273ccde | TrustSearchQuery_search_ItemSearchResults_results_Transformation | TrustSearchQuery_search_ItemSearchResults_results_TrustArticleHeroParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_TrustFinder | TrustSearchQuery_search_ItemSearchResults_results_TrustFinderFilterOption | TrustSearchQuery_search_ItemSearchResults_results_TrustRegion | TrustSearchQuery_search_ItemSearchResults_results_TrustType | TrustSearchQuery_search_ItemSearchResults_results_TrustTypesFolder | TrustSearchQuery_search_ItemSearchResults_results_Twitter | TrustSearchQuery_search_ItemSearchResults_results_TwitterApp | TrustSearchQuery_search_ItemSearchResults_results_TwitterApps | TrustSearchQuery_search_ItemSearchResults_results_TwitterFolder | TrustSearchQuery_search_ItemSearchResults_results_TwitterParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_TwitterSettings | TrustSearchQuery_search_ItemSearchResults_results_UnknownItem | TrustSearchQuery_search_ItemSearchResults_results_UnminifiedFile | TrustSearchQuery_search_ItemSearchResults_results_UpgradeScript | TrustSearchQuery_search_ItemSearchResults_results_UpgradeScriptLibrary | TrustSearchQuery_search_ItemSearchResults_results_VariantComponentField | TrustSearchQuery_search_ItemSearchResults_results_VariantDateField | TrustSearchQuery_search_ItemSearchResults_results_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 | TrustSearchQuery_search_ItemSearchResults_results_VariantPlaceholder | TrustSearchQuery_search_ItemSearchResults_results_VariantReference | TrustSearchQuery_search_ItemSearchResults_results_VariantSection | TrustSearchQuery_search_ItemSearchResults_results_VariantTemplate | TrustSearchQuery_search_ItemSearchResults_results_VariantText | TrustSearchQuery_search_ItemSearchResults_results_VariantToken | TrustSearchQuery_search_ItemSearchResults_results_Variants | TrustSearchQuery_search_ItemSearchResults_results_VectorFolder | TrustSearchQuery_search_ItemSearchResults_results_VectorTile | TrustSearchQuery_search_ItemSearchResults_results_VectorTileLink | TrustSearchQuery_search_ItemSearchResults_results_VectorTilesFolder | TrustSearchQuery_search_ItemSearchResults_results_VectorTilesParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_Version_95ebc23204774dc38ad3465d5fe8da2f | TrustSearchQuery_search_ItemSearchResults_results_Video | TrustSearchQuery_search_ItemSearchResults_results_VideoCountOption | TrustSearchQuery_search_ItemSearchResults_results_VideoCountOptions | TrustSearchQuery_search_ItemSearchResults_results_VideoFolder | TrustSearchQuery_search_ItemSearchResults_results_VideoFolder_bba49474673e468186ba8b1a20e067a9 | TrustSearchQuery_search_ItemSearchResults_results_VideoPage | TrustSearchQuery_search_ItemSearchResults_results_VideoParameters | TrustSearchQuery_search_ItemSearchResults_results_VideoParametersTemplate | TrustSearchQuery_search_ItemSearchResults_results_VideoPressReleasePage | TrustSearchQuery_search_ItemSearchResults_results_Video_4bc649610a894242be2dc5026090cf49 | TrustSearchQuery_search_ItemSearchResults_results__AssetsOptimization | TrustSearchQuery_search_ItemSearchResults_results__BackgroundImage | TrustSearchQuery_search_ItemSearchResults_results__CompatibleThemes | TrustSearchQuery_search_ItemSearchResults_results__CompositeTheme | TrustSearchQuery_search_ItemSearchResults_results__CustomMetadata | TrustSearchQuery_search_ItemSearchResults_results__CustomRenderingViewPath | TrustSearchQuery_search_ItemSearchResults_results__DatasourceBehaviour | TrustSearchQuery_search_ItemSearchResults_results__Favicon | TrustSearchQuery_search_ItemSearchResults_results__FormsFolderLocation | TrustSearchQuery_search_ItemSearchResults_results__FundSettings | TrustSearchQuery_search_ItemSearchResults_results__HasValidUrlName | TrustSearchQuery_search_ItemSearchResults_results__LocalDataLink | TrustSearchQuery_search_ItemSearchResults_results__Login | TrustSearchQuery_search_ItemSearchResults_results__OpenGraphMetadata | TrustSearchQuery_search_ItemSearchResults_results__PageDesignTheme | TrustSearchQuery_search_ItemSearchResults_results__PageSearchScope | TrustSearchQuery_search_ItemSearchResults_results__SearchCriteria | TrustSearchQuery_search_ItemSearchResults_results__SearchableWithoutRelatedItems | TrustSearchQuery_search_ItemSearchResults_results__SeoMetadata | TrustSearchQuery_search_ItemSearchResults_results__SiteTheme | TrustSearchQuery_search_ItemSearchResults_results__SitemapSettings | TrustSearchQuery_search_ItemSearchResults_results__StickyNote | TrustSearchQuery_search_ItemSearchResults_results__Styleable | TrustSearchQuery_search_ItemSearchResults_results__TwitterMetadata | TrustSearchQuery_search_ItemSearchResults_results__Webinar | TrustSearchQuery_search_ItemSearchResults_results__WildcardSource;

export type TrustSearchQuery_search_ItemSearchResults = (
  { __typename?: 'ItemSearchResults' }
  & Pick<Types.ItemSearchResults, 'total'>
  & { pageInfo: TrustSearchQuery_search_ItemSearchResults_pageInfo_PageInfo, results: Array<Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results>> }
);

export type TrustSearchQuery_Query = (
  { __typename?: 'Query' }
  & { search: Types.Maybe<TrustSearchQuery_search_ItemSearchResults> }
);


export type TrustSearchQueryVariables = Types.Exact<{
  pageSize: Types.Scalars['Int']['input'];
  language: Types.Scalars['String']['input'];
}>;


export type TrustSearchQuery = TrustSearchQuery_Query;

export type TrustDataFragment = (
  { __typename?: 'C__InvestmentTrustPage' | 'C___BaseInvestmentTrust' | 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' | 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' }
  & { trustRegion: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustRegion_LookupField>, trustLink: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustLink_LinkField>, trustStyle: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustStyle_LookupField>, trustAssetClass: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustAssetClass_LookupField>, trustId: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustId_TextField>, trustName: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustName_TextField>, trustDescription: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustDescription_TextField>, trustImage: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustImage_ImageField>, trustIsHidden: Types.Maybe<TrustSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage_trustIsHidden_CheckboxField> }
);

export const TrustDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrustData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_BaseInvestmentTrust"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trustRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetId"}},{"kind":"Field","name":{"kind":"Name","value":"targetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvestmentTrustRegion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"name_0861e759815b4dfda19ba400b1113815"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustStyle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetId"}},{"kind":"Field","name":{"kind":"Name","value":"targetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvestmentTrustStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"name_6f68560ebdf94e3fb3a82e182e35ed40"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustAssetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetId"}},{"kind":"Field","name":{"kind":"Name","value":"targetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvestmentTrustAssetClass"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"name_f028947c2b30411c9bfc7e3d076d4ae5"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustIsHidden"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolValue"}}]}}]}}]} as unknown as DocumentNode<TrustDataFragment, unknown>;
export const TrustSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrustSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_path","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"24C589E22D454A2CB67ED690470D4B39","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_templates","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"27F30130B0DA40CDA8CB654469C5377D","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"trustIsHidden","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"1","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"NEQ"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_language","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"EQ"}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNext"}}]}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrustData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrustData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_BaseInvestmentTrust"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trustRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetId"}},{"kind":"Field","name":{"kind":"Name","value":"targetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvestmentTrustRegion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"name_0861e759815b4dfda19ba400b1113815"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustStyle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetId"}},{"kind":"Field","name":{"kind":"Name","value":"targetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvestmentTrustStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"name_6f68560ebdf94e3fb3a82e182e35ed40"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustAssetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetId"}},{"kind":"Field","name":{"kind":"Name","value":"targetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvestmentTrustAssetClass"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"name_f028947c2b30411c9bfc7e3d076d4ae5"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trustIsHidden"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolValue"}}]}}]}}]} as unknown as DocumentNode<TrustSearchQuery, TrustSearchQueryVariables>;